<template>
  <div
    :data-theme="themeCheckout.theme || 'light'"
    :data-theme_color="themeCheckout.theme_color || (isHeaven ? 'heaven' : '#00E4A0')"
  >
    <!-- att -->
    <div v-if="preload || hard_loading" class="carregando">
      <div>
        <img v-if="!isHeaven" src="@/assets/img/_logo.svg" alt="logo-loading" class="logo-loading" />
        <img v-else src="@/assets/img/heaven/logo.svg" alt="logo-loading" class="logo-loading" />
        <span class="loading-carregando" :class="{'heaven': isHeaven}"></span>
      </div>
    </div>
    <div>
      <template v-if="themeCheckout.top_thumb">
        <Escassez
          v-if="
            themeCheckout.scarcity == 'on' &&
              (product_type == 'COMMON'
                ? product.status == 'APPROVED'
                : product.product.status == 'APPROVED')
          "
          style="min-height: 100px"
          :class="{ 'is-stick': !isMobile }"
          :mobile="isMobile"
          :dados="themeCheckout.scarcity == 'on' ? escassez : {}"
          :product_id="product.product_id || product.id"
        />
        <div
          class="container banner-container banner-top"
          :class="{
            has_escassez:
              themeCheckout.scarcity == 'on' &&
              (product_type == 'COMMON'
                ? product.status == 'APPROVED'
                : product.product.status == 'APPROVED'),
          }"
        >
          <img :src="themeCheckout.top_thumb" alt="top-thumb" class="banner" />
        </div>
      </template>
      <Navbar
        v-else
        :logo="themeCheckout.logotipo"
        :escassez="
          themeCheckout.scarcity == 'on' &&
            (product_type == 'COMMON'
              ? product.status == 'APPROVED'
              : product.product.status == 'APPROVED')
        "
        :mobile="isMobile"
        :dados_escassez="themeCheckout.scarcity == 'on' ? escassez : {}"
        :product_id="product.product_id || product.id"
      />
      <!-- Body -->
      <b-container class="gray">
        <b-row
          :class="{
            'justify-content-center': charge_success || charge_error,
            'padding-checkout': !themeCheckout.top_thumb && !isMobile,
            'padding-checkout mobile': isMobile,
            thumb: themeCheckout.top_thumb,
            escassez:
              themeCheckout.scarcity == 'on' &&
              (product_type == 'COMMON'
                ? product.status == 'APPROVED'
                : product.product.status == 'APPROVED'),
          }"
        >
          <!-- Purchase Form -->
          <b-col cols="12" md="8" order="3" order-md="1" class="pr-md-0">

            <div v-if="pop_modal.active" class="modal-default">
              <div class="custom-pop-modal">
                <section>
                  <a class="close-pop-modal" @click="closePopModal()">
                    <svg data-v-4fa0a2a1="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="icon cursor-close cursor-pointer text-gray-400" width="25px" height="25px" viewBox="0 0 24 24"><path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path></svg>
                  </a>
                  <h6
                    class="flex-content mb-[8px] text-[17px] font-semibold text-txt-color"
                  >
                  {{ pop_modal.data.title }}

                </h6>
        
                <section>
                  <a :href="pop_modal.data.link">
                    <img
                      class="mb-[30px] image-fix rounded"
                      :src="pop_modal.data.image"
                    />
                  </a>
                </section>
        
                <p class="mt-2 justify-end text-sm text-txt-color">
                  {{ pop_modal.data.description }}
                </p>
                <section class="mt-3 flex w-full justify-end" v-if="pop_modal.data.is_button === 'on'">
                  <a :href="pop_modal.data.link" class="button-custom-modal custom-background">
                    {{ pop_modal.data.button_text }}
                  </a>
                </section>
                </section>
              </div>
            </div>

            <b-overlay :show="loading" rounded="sm">
              <div
                v-if="!charge_error && !charge_success"
                class="Checkout"
                data-anima="top"
              >
                <a
                  v-if="isMobile && etapa_atual > 1"
                  href="#"
                  class="btn-voltar-step"
                  @click.prevent="previous_step"
                >
                  <img src="@/assets/img/icon/arrow.svg" alt="icon-arrow" />
                  Voltar
                </a>
                <b-form
                  v-show="!isMobile || (!address_step && !last_step)"
                  data-anima="top"
                  data-vv-scope="pessoal"
                >
                  <template>
                    <!-- Linguagens -->
                    <Locales
                      :productType="product.type"
                      :productSellerIsHeaven="product.seller.is_heaven"
                      :countryGlobal="countryGlobal"
                    />

                    <div class="Checkout-title">
                      <span class="Checkout-title-number" :style="themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark' ? 'color:white !important;' : ''">
                        01
                      </span>
                      <!-- Dados Pessoais -->
                      {{ $t('checkout.dados_pessoais.title') }}
                    </div>

                    <b-row>
                      <!-- Name -->
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('checkout.dados_pessoais.nome')"
                          label-for="name"
                        >
                          <b-form-input
                            id="name"
                            v-model="data.name"
                            data-test="name"
                            type="text"
                            maxlength="150"
                            @input="debounceSave(saveDataUser)"
                            :placeholder="
                              $t('checkout.dados_pessoais.nome_holder')
                            "
                            name="name"
                            :state="submit ? !errors.has('pessoal.name') : null"
                            v-validate="'required'"
                            v-on:keyup.native="validateForm"
                            :disabled="queryUrl.fn && forceUrl"
                          ></b-form-input>

                          <b-form-invalid-feedback
                            :state="submit ? !errors.has('pessoal.name') : null"
                          >
                            {{ $t('checkout.dados_pessoais.feedbacks.nome') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- E-mail -->
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('checkout.dados_pessoais.email')"
                          label-for="email"
                        >
                          <b-form-input
                            id="email"
                            data-test="email"
                            v-model="data.email"
                            @blur="debounceSave"
                            :placeholder="
                              $t('checkout.dados_pessoais.email_holder')
                            "
                            type="text"
                            name="email"
                            ref="email"
                            :state="
                              submit ? !errors.has('pessoal.email') : null
                            "
                            v-validate="'required|email'"
                            v-on:keyup.native="validateForm"
                            :disabled="queryUrl.em && forceUrl"
                            @copy.prevent
                          ></b-form-input>
                          <b-form-invalid-feedback
                            :state="
                              submit ? !errors.has('pessoal.email') : null
                            "
                          >
                            {{ $t('checkout.dados_pessoais.feedbacks.email') }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <!-- Confirmação de email -->
                      <b-col cols="12" v-if="confirmation_email">
                        <b-form-group
                          :label="
                            $t('checkout.dados_pessoais.confirmation_email')
                          "
                          label-for="confirmation_email"
                        >
                          <b-form-input
                            autocomplete="off"
                            id="confirmation_email"
                            data-test="confirmation_email"
                            v-model="data.confirmation_email"
                            @blur="debounceSave"
                            :placeholder="
                              $t(
                                'checkout.dados_pessoais.confirmation_email_holder'
                              )
                            "
                            type="text"
                            v-validate="'required|email|confirmed:email'"
                            name="confirmation_email"
                            v-on:keyup.native="validateForm"
                            :disabled="queryUrl.em && forceUrl"
                            :state="confirmed_email"
                            @copy.prevent
                            @paste.prevent
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            {{
                              $t(
                                'checkout.dados_pessoais.feedbacks.confirmation_email'
                              )
                            }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <!-- Telephone / Documents -->
                    <b-row>
                      <!-- Telephone -->
                      <b-col cols="12" md="12" lg="7">
                        <b-form-group
                          :label="$t('checkout.dados_pessoais.telefone')"
                          label-for="cellphone"
                        >
                          <VuePhoneNumberInput
                            :disabled="queryUrl.ph && forceUrl"
                            :default-country-code="countryPhone()"
                            :translations="
                              $i18n.locale == 'pt'
                                ? translations_pt
                                : translations_en
                            "
                            :color="themeCheckout.theme_color || '#00E4A0'"
                            :valid-color="
                              themeCheckout.theme_color || '#00E4A0'
                            "
                            error-color="#ff0c37"
                            size="lg"
                            :preferred-countries="[
                              'BR',
                              'PT',
                              'US',
                              'FR',
                              'ES',
                            ]"
                            ref="telinput"
                            :required="true"
                            :countries-height="50"
                            :border-radius="5"
                            v-model="yourValue"
                            @phone-number-blur="blurInputPhone"
                            @update="results_tel = $event"
                            data-test="cellphone"
                          />
                          <b-form-invalid-feedback
                            class="mt-3"
                            :state="
                              (submit ? results_tel.isValid : null) ||
                                !errorPhone
                            "
                          >
                            {{
                              $t('checkout.dados_pessoais.feedbacks.celular')
                            }}
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>

                      <template v-if="countryGlobal !== 'OUTROS'">
                        <!-- CPF / CNPJ -->
                        <b-col
                          v-if="!isMobile && countryGlobal === 'BR'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            :label="$t('checkout.dados_pessoais.document')"
                            label-for="cpf_cnpj"
                          >
                            <b-form-input
                              id="cpf_cnpj"
                              data-test="cpf_cnpj"
                              v-model="data.document"
                              @blur="debounceSave"
                              :placeholder="
                                $t('checkout.dados_pessoais.document_holder')
                              "
                              type="text"
                              name="document"
                              v-validate="'required|cpf_cnpj'"
                              v-mask="['###.###.###-##', '##.###.###/####-##']"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Preencha seu CPF ou CNPJ.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- RFC Document Number -->
                        <b-col
                          v-if="countryGlobal === 'MX'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group label="Número RFC" label-for="document">
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="Número RFC"
                              type="text"
                              v-mask="['##################']"
                              name="document"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- CI Document Number -->
                        <b-col
                          v-if="countryGlobal === 'UY'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group label="Número CI" label-for="document">
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="Número CI"
                              type="text"
                              name="document"
                              v-mask="['############']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- CUIT/CUIL/DNI Document Number -->
                        <b-col
                          v-if="countryGlobal === 'AR'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="CUIT/CUIL o DNI"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="CUIT/CUIL o DNI"
                              type="text"
                              name="document"
                              v-mask="['#####################']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- CC Document Number -->
                        <b-col
                          v-if="countryGlobal === 'CO' && countryFlags"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="CC"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="CC"
                              type="text"
                              name="document"
                              v-mask="['##########']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- ID  Document Number -->
                        <b-col
                          v-if="countryGlobal === 'DO'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="ID"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="ID"
                              type="text"
                              name="document"
                              v-mask="['###########']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- CI Document Number -->
                        <b-col
                          v-if="countryGlobal === 'CR'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="CI"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="CI"
                              type="text"
                              name="document"
                              v-mask="['#########']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- DNI Document Number -->
                        <b-col
                          v-if="countryGlobal === 'PE' && countryFlags"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="DNI"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="DNI"
                              type="text"
                              name="document"
                              v-mask="['#########']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- DNI Document Number -->
                        <b-col
                          v-if="countryGlobal === 'EC' && countryFlags"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group
                            label="CI"
                            label-for="document"
                          >
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="CI"
                              type="text"
                              name="document"
                              v-mask="['####################']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Añadir RUT Document Number -->
                        <b-col
                          v-if="countryGlobal === 'CL'"
                          cols="12"
                          lg="5"
                          md="12"
                        >
                          <b-form-group label="Añadir RUT" label-for="document">
                            <b-form-input
                              id="document"
                              data-test="document"
                              v-model="data.document"
                              @blur="debounceSave"
                              placeholder="Añadir RUT"
                              type="text"
                              name="document"
                              v-mask="['###########']"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                              :disabled="queryUrl.document && forceUrl"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('pessoal.document') : null
                              "
                            >
                              Rellena tu documento.
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </template>
                    </b-row>
                    <!-- Mobile Button Next Step -->
                    <template
                      v-if="isMobile &&
                        (themeCheckout.step_checkout === 'default' ||
                        !themeCheckout.step_checkout)
                      "
                    >
                      <b-row class="mt-3 justify-content-end">
                        <b-col cols="12">
                          <b-button v-if="etapa_total === 3"
                            class="col-12 btn-green"
                            :disabled="loading"
                            type="button"
                            variant="primary"
                            @click="nextStep('address', 'pessoal')"
                          >
                            {{ $t('checkout.mobile.proxima_etapa') }}
                          </b-button>
                          <b-button v-else
                            class="col-12 btn-green"
                            :disabled="loading"
                            type="button"
                            variant="primary"
                            @click="nextStep('pagamento', 'pessoal')"
                          >
                            {{ $t('checkout.mobile.proxima_etapa') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </b-form>

                <b-form
                  v-show="!isMobile ||
                    (address_step && !last_step) ||
                    themeCheckout.step_checkout == 'one_step'
                  "
                  data-vv-scope="address"
                  data-anima="top"
                  style="z-index: 999; position: relative"
                >
                  <!-- Form Address Brasil -->
                  <template v-if="countryGlobal === 'BR'">
                    <!-- Address -->
                    <template v-if="showAddress()">
                      {{ hasAddress() }}
                      <div class="Checkout-title mt-4">
                        <span class="Checkout-title-number" :style="themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark' ? 'color:white !important;' : ''">
                          02
                        </span>
                        {{ $t('checkout.address.address') }}
                      </div>

                      <b-row>
                        <!-- Zipcode -->
                        <b-col cols="12" lg="4" md="12">
                          <b-form-group :label="$t('checkout.address.zipcode_label')" label-for="zipcode">
                            <b-form-input
                              data-test="zipcode"
                              id="zipcode"
                              v-model="data.zipcode"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.zipcode_placeholder')"
                              type="text"
                              name="zipcode"
                              :state="
                                submit ? !errors.has('address.zipcode') : null
                              "
                              v-mask="['#####-###']"
                              v-validate="'required'"
                              @keyup="getCEP('charge')"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('address.zipcode') : null
                              "
                            >
                              {{ $t('checkout.address.zipcode_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Street -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group :label="$t('checkout.address.street_label')" label-for="street">
                            <b-form-input
                              data-test="street"
                              id="street"
                              v-model="data.street"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.street_placeholder')"
                              type="text"
                              name="street"
                              :state="
                                submit ? !errors.has('address.street') : null
                              "
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('address.street') : null
                              "
                            >
                              {{ $t('checkout.address.street_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Number -->
                        <b-col cols="12" lg="3" md="12">
                          <b-form-group :label="$t('checkout.address.number_label')" label-for="number">
                            <b-form-input
                              data-test="number"
                              id="number-address"
                              v-model="data.number"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.number_placeholder')"
                              type="text"
                              name="number"
                              :state="
                                submit ? !errors.has('address.number') : null
                              "
                              v-validate="'required|numeric'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('address.number') : null
                              "
                            >
                              {{ $t('checkout.address.number_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- City -->
                        <b-col cols="12" md="6">
                          <b-form-group :label="$t('checkout.address.city_label')" label-for="city">
                            <b-form-input
                              data-test="city"
                              id="city"
                              v-model="data.city"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.city_placeholder')"
                              type="text"
                              name="city"
                              :state="
                                submit ? !errors.has('address.city') : null
                              "
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('address.city') : null
                              "
                            >
                              {{ $t('checkout.address.city_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Neighborhood -->
                        <b-col cols="12" md="6">
                          <b-form-group :label="$t('checkout.address.neighborhood_label')" label-for="neighborhood">
                            <b-form-input
                              data-test="neighborhood"
                              id="neighborhood"
                              v-model="data.neighborhood"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.neighborhood_placeholder')"
                              type="text"
                              name="neighborhood"
                              :state="submit ? !errors.has('address.neighborhood') : null"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.neighborhood') : null">
                              {{ $t('checkout.address.neighborhood_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- Complement -->
                        <b-col cols="12" lg="7" md="12">
                          <b-form-group
                            :label="$t('checkout.address.complement_label')"
                            label-for="complement"
                          >
                            <b-form-input
                              data-test="complement"
                              id="complement"
                              @blur="debounceSave"
                              v-model="data.complement"
                              :placeholder="$t('checkout.address.complement_placeholder')"
                              type="text"
                              name="complement"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <!-- State -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group :label="$t('checkout.address.state_label')" label-for="state">
                            <b-form-select
                              data-test="state"
                              id="state"
                              v-model="data.state"
                              @input="debounceSave && validateForm"
                              type="text"
                              name="state"
                              :state="
                                submit ? !errors.has('address.state') : null
                              "
                              v-validate="'required'"
                              class="mb-3"
                            >
                              <b-form-select-option disabled :value="null"
                                >Selecione um Estado</b-form-select-option
                              >
                              <b-form-select-option value="AC"
                                >Acre</b-form-select-option
                              >
                              <b-form-select-option value="AL"
                                >Alagoas</b-form-select-option
                              >
                              <b-form-select-option value="AP"
                                >Amapá</b-form-select-option
                              >
                              <b-form-select-option value="AM"
                                >Amazonas</b-form-select-option
                              >
                              <b-form-select-option value="BA"
                                >Bahia</b-form-select-option
                              >
                              <b-form-select-option value="CE"
                                >Ceará</b-form-select-option
                              >
                              <b-form-select-option value="DF"
                                >Distrito Federal</b-form-select-option
                              >
                              <b-form-select-option value="ES"
                                >Espírito Santo</b-form-select-option
                              >
                              <b-form-select-option value="GO"
                                >Goiás</b-form-select-option
                              >
                              <b-form-select-option value="MA"
                                >Maranhão</b-form-select-option
                              >
                              <b-form-select-option value="MT"
                                >Mato Grosso</b-form-select-option
                              >
                              <b-form-select-option value="MS"
                                >Mato Grosso do Sul</b-form-select-option
                              >
                              <b-form-select-option value="MG"
                                >Minas Gerais</b-form-select-option
                              >
                              <b-form-select-option value="PA"
                                >Pará</b-form-select-option
                              >
                              <b-form-select-option value="PB"
                                >Paraíba</b-form-select-option
                              >
                              <b-form-select-option value="PR"
                                >Paraná</b-form-select-option
                              >
                              <b-form-select-option value="PE"
                                >Pernambuco</b-form-select-option
                              >
                              <b-form-select-option value="PI"
                                >Piauí</b-form-select-option
                              >
                              <b-form-select-option value="RJ"
                                >Rio de Janeiro</b-form-select-option
                              >
                              <b-form-select-option value="RN"
                                >Rio Grande do Norte</b-form-select-option
                              >
                              <b-form-select-option value="RS"
                                >Rio Grande do Sul</b-form-select-option
                              >
                              <b-form-select-option value="RO"
                                >Rondônia</b-form-select-option
                              >
                              <b-form-select-option value="RR"
                                >Roraima</b-form-select-option
                              >
                              <b-form-select-option value="SC"
                                >Santa Catarina</b-form-select-option
                              >
                              <b-form-select-option value="SP"
                                >São Paulo</b-form-select-option
                              >
                              <b-form-select-option value="SE"
                                >Sergipe</b-form-select-option
                              >
                              <b-form-select-option value="TO"
                                >Tocantins</b-form-select-option
                              >
                            </b-form-select>
                            <b-form-invalid-feedback
                              :state="
                                submit ? !errors.has('address.state') : null
                              "
                            >
                              {{ $t('checkout.address.state_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Delivery Address Checkbox-->
                        <b-col
                          v-if="(is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'"
                          cols="12"
                          class="mt-2"
                          data-anima="top"
                        >
                          <b-form-checkbox
                            v-model="data.billing_shipping_same_address"
                            name="check-button"
                            switch
                            @change="changeEnderecoEntrega"
                          >
                            {{ $t('checkout.address.address') }}
                            {{ data.is_gift ? $t('checkout.address.of_gift') : $t('checkout.address.of_delivery') }} é
                            {{ $t('checkout.address.same_as_charge') }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                  <!-- Form Address International -->
                  <template v-else>
                    <!-- Address -->
                    <template v-if="showAddress()">
                      {{ hasAddress() }}
                      <div class="Checkout-title mt-4">
                        <span class="Checkout-title-number" :style="themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark' ? 'color:white !important;' : ''">
                          02
                        </span>
                        {{ $t('checkout.address.address') }}
                      </div>

                      <b-row>
                        <!-- Zipcode -->
                        <b-col cols="12" lg="4" md="12">
                          <b-form-group 
                            :label="
                              $i18n.locale === 'pt' && this.countryGlobal === 'PT'
                                ? 'Código Postal'
                                : $t('checkout.address.zipcode_label')
                            "
                            label-for="zipcode"
                          >
                            <b-form-input
                              data-test="zipcode"
                              id="zipcode"
                              v-model="data.zipcode"
                              @blur="debounceSave"
                              placeholder="Código Postal"
                              type="text"
                              name="zipcode"
                              :state="submit ? !errors.has('address.zipcode') : null"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="submit ? !errors.has('address.zipcode') : null"
                            >
                              {{ $t('checkout.address.zipcode_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Street -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group :label="$t('checkout.address.street_label')" label-for="street">
                            <b-form-input
                              data-test="street"
                              id="street"
                              v-model="data.street"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.street_placeholder')"
                              type="text"
                              name="street"
                              :state="submit ? !errors.has('address.street') : null"
                              v-validate="'required'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="submit ? !errors.has('address.street') : null"
                            >
                              {{ $t('checkout.address.street_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Number -->
                        <b-col cols="12" lg="3" md="12">
                          <b-form-group :label="$t('checkout.address.number_label')" label-for="number">
                            <b-form-input
                              data-test="number"
                              id="number-address"
                              v-model="data.number"
                              @blur="debounceSave"
                              :placeholder="$t('checkout.address.number_placeholder')"
                              type="text"
                              name="number"
                              :state="submit ? !errors.has('address.number') : null"
                              v-validate="'required|numeric'"
                              v-on:keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              :state="submit ? !errors.has('address.number') : null"
                            >
                              {{ $t('checkout.address.number_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- City -->
                        <b-col cols="12" md="6">
                          <b-form-group :label="$t('checkout.address.city_label')" label-for="city">
                            <b-form-input
                              id="city"
                              v-model="data.city"
                              data-test="city"
                              type="text"
                              name="city"
                              :placeholder="$t('checkout.address.city_placeholder')"
                              :state="submit ? !errors.has('address.city') : null"
                              v-validate="'required'"
                              @blur="debounceSave"
                              @keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.city') : null">
                              {{ $t('checkout.address.city_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Neighborhood -->
                        <b-col cols="12" md="6">
                          <b-form-group :label="$t('checkout.address.neighborhood_label')" label-for="neighborhood">
                            <b-form-input
                              id="neighborhood"
                              v-model="data.neighborhood"
                              data-test="neighborhood"
                              type="text"
                              name="neighborhood"
                              :placeholder="$t('checkout.address.neighborhood_placeholder')"
                              :state="submit ? !errors.has('address.neighborhood') : null"
                              v-validate="'required'"
                              @blur="debounceSave"
                              @keyup.native="validateForm"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.neighborhood') : null">
                              {{ $t('checkout.address.neighborhood_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- Complement -->
                        <b-col cols="12" lg="7" md="12">
                          <b-form-group
                            :label="$t('checkout.address.complement_label')"
                            label-for="complement"
                          >
                            <b-form-input
                              data-test="complement"
                              id="complement"
                              @blur="debounceSave"
                              v-model="data.complement"
                              :placeholder="$t('checkout.address.complement_placeholder')"
                              type="text"
                              name="complement"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <!-- State / District -->
                        <b-col cols="12" lg="5" md="12">
                          <b-form-group :label="$t('checkout.address.district_label')" label-for="state">
                            <multiselect
                              v-if="!countryGlobal === 'OUTROS'"
                              v-model="data.state"
                              :options="getDistrictOptions(countryGlobal)"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :placeholder="$t('checkout.address.district_placeholder')"
                              :class="{'heaven': isHeaven}"
                              selectLabel=""
                              deselectLabel=""
                              selectedLabel="✔️"
                              name="state"
                              :state="submit ? !errors.has('address.state') : null"
                              v-validate="'required'"
                            ></multiselect>
                            <b-form-input
                              v-else
                              id="state"
                              v-model="data.state"
                              name="state"
                              data-test="state"
                              type="text"
                              :class="{'heaven': isHeaven}"
                              :state="submit ? !errors.has('address.state') : null"
                              :placeholder="$t('checkout.address.district_placeholder')"
                              v-validate="'required'"
                              @blur="debounceSave"
                            ></b-form-input>
                            <b-form-invalid-feedback :state="submit ? !errors.has('address.state') : null">
                              {{ $t('checkout.address.state_feedback_message') }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </b-col>
                        <!-- Delivery Address Checkbox-->
                        <b-col v-if="is_produto_fisico && product.method !== 'FREE'" cols="12" class="mt-2" data-anima="top">
                          <b-form-checkbox
                            v-model="data.billing_shipping_same_address"
                            name="check-button"
                            switch
                            @change="changeEnderecoEntrega"
                          >
                            {{ $t('checkout.address.address') }}
                            {{ data.is_gift ? $t('checkout.address.of_gift') : $t('checkout.address.of_delivery') }} é
                            {{ $t('checkout.address.same_as_charge') }}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </template>
                  </template>

                  <!-- Form Delivery Address Brasil -->
                  <template v-if="countryGlobal === 'BR'">
                    <!-- Delivery Address -->
                    <template
                      v-if="
                        !data.billing_shipping_same_address && (is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'
                      "
                    >
                      <div data-anima="top">
                        <div class="Checkout-title mt-4">
                          <span class="Checkout-title-number">📦</span>
                          {{ data.is_gift
                            ? $t('checkout.address.where_we_should_send_gift')
                            : $t('checkout.address.where_we_should_send_delivery')
                          }}
                        </div>
                        <b-row>
                          <!-- Shipping Zipcode -->
                          <b-col cols="12" lg="4" md="12">
                            <b-form-group
                              :label="$t('checkout.address.zipcode_shipping_label')"
                              label-for="shipping_zipcode"
                            >
                              <b-form-input
                                data-test="shipping_zipcode"
                                id="shipping_zipcode"
                                v-model="shipping.address.zipcode"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.zipcode_shipping_placeholder')"
                                type="text"
                                name="shipping_zipcode"
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_zipcode')
                                    : null
                                "
                                v-mask="['#####-###']"
                                v-validate="'required'"
                                @keyup="getCEP('shipping')"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_zipcode')
                                    : null
                                "
                              >
                                {{ $t('checkout.address.zipcode_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Street -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group
                              :label="$t('checkout.address.street_shipping_label')"
                              label-for="shipping_street"
                            >
                              <b-form-input
                                id="shipping_street"
                                v-model="shipping.address.street"
                                data-test="shipping_street"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.street_shipping_placeholder')"
                                type="text"
                                name="shipping_street"
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_street')
                                    : null
                                "
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_street')
                                    : null
                                "
                              >
                                {{ $t('checkout.address.street_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Number -->
                          <b-col cols="12" lg="3" md="12">
                            <b-form-group
                              :label="$t('checkout.address.number_shipping_label')"
                              label-for="shipping_number"
                            >
                              <b-form-input
                                id="number-address-shipping"
                                v-model="shipping.address.number"
                                data-test="shipping_number"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.number_shipping_placeholder')"
                                type="text"
                                name="shipping_number"
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_number')
                                    : null
                                "
                                v-validate="'required|numeric'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_number')
                                    : null
                                "
                              >
                                {{ $t('checkout.address.number_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping City -->
                          <b-col cols="12" md="6">
                            <b-form-group
                              :label="$t('checkout.address.city_shipping_label')"
                              label-for="shipping_city"
                            >
                              <b-form-input
                                id="shipping_city"
                                v-model="shipping.address.city"
                                data-test="shipping_city"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.city_shipping_placeholder')"
                                type="text"
                                name="shipping_city"
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_city')
                                    : null
                                "
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('address.shipping_city')
                                    : null
                                "
                              >
                                {{ $t('checkout.address.city_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Neighborhood -->
                          <b-col cols="12" md="6">
                            <b-form-group
                              :label="$t('checkout.address.neighborhood_shipping_label')"
                              label-for="shipping_neighborhood"
                            >
                              <b-form-input
                                id="shipping_neighborhood"
                                v-model="shipping.address.neighborhood"
                                data-test="shipping_neighborhood"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.neighborhood_shipping_placeholder')"
                                type="text"
                                name="shipping_neighborhood"
                                :state="submit? !errors.has('address.shipping_neighborhood'): null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="submit ? !errors.has('address.shipping_neighborhood') : null">
                                {{ $t('checkout.address.neighborhood_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping Complement -->
                          <b-col cols="12" lg="7" md="12">
                            <b-form-group
                              :label="$t('checkout.address.complement_shipping_label')"
                              label-for="shipping_complement"
                            >
                              <b-form-input
                                data-test="shipping_complement"
                                id="shipping_complement"
                                @blur="debounceSave"
                                v-model="shipping.address.complement"
                                :placeholder="$t('checkout.address.complement_shipping_placeholder')"
                                type="text"
                                name="shipping_complement"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping State -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group
                              :label="$t('checkout.address.state_shipping_label')"
                              label-for="shipping_state"
                            >
                              <b-form-input
                                id="shipping_state"
                                v-model="shipping.address.state"
                                data-test="shipping_state"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.state_shipping_placeholder')"
                                type="text"
                                name="shipping_state"
                                :state="submit ? !errors.has('address.shipping_state') : null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="submit ? !errors.has('address.shipping_state') : null">
                                {{ $t('checkout.address.state_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </template>
                  <!-- Form Delivery Address International -->
                  <template v-else>
                    <!-- Delivery Address -->
                    <template v-if="!data.billing_shipping_same_address && is_produto_fisico && product.method !== 'FREE'">
                      <div data-anima="top">
                        <div class="Checkout-title mt-4">
                          <span class="Checkout-title-number">📦</span>
                          {{ data.is_gift
                            ? $t('checkout.address.where_we_should_send_gift')
                            : $t('checkout.address.where_we_should_send_delivery')
                          }}
                        </div>
                        <b-row>
                          <!-- Shipping Zipcode -->
                          <b-col cols="12" lg="4" md="12">
                            <b-form-group
                              :label="
                              $i18n.locale === 'pt' && this.countryGlobal === 'PT'
                                ? 'Código Postal'
                                : $t('checkout.address.zipcode_shipping_label')
                              "
                              label-for="shipping_zipcode"
                            >
                              <b-form-input
                                data-test="shipping_zipcode"
                                id="shipping_zipcode"
                                v-model="shipping.address.zipcode"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.zipcode_shipping_placeholder')"
                                type="text"
                                name="shipping_zipcode"
                                :state="submit ? !errors.has('address.shipping_zipcode') : null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="submit ? !errors.has('address.shipping_zipcode') : null"
                              >
                                {{ $t('checkout.address.zipcode_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Street -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group
                              :label="$t('checkout.address.street_shipping_label')"
                              label-for="shipping_street"
                            >
                              <b-form-input
                                id="shipping_street"
                                v-model="shipping.address.street"
                                data-test="shipping_street"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.street_shipping_placeholder')"
                                type="text"
                                name="shipping_street"
                                :state="submit? !errors.has('address.shipping_street'): null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="submit ? !errors.has('address.shipping_street') : null"
                              >
                                {{ $t('checkout.address.street_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Number -->
                          <b-col cols="12" lg="3" md="12">
                            <b-form-group
                              :label="$t('checkout.address.number_shipping_label')"
                              label-for="shipping_number"
                            >
                              <b-form-input
                                id="number-address-shipping"
                                v-model="shipping.address.number"
                                data-test="shipping_number"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.number_shipping_placeholder')"
                                type="text"
                                name="shipping_number"
                                :state="submit ? !errors.has('address.shipping_number') : null"
                                v-validate="'required|numeric'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="submit ? !errors.has('address.shipping_number') : null"
                              >
                                {{ $t('checkout.address.number_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping City -->
                          <b-col cols="12" md="6">
                            <b-form-group
                              :label="$t('checkout.address.city_shipping_label')"
                              label-for="shipping_city"
                            >
                              <b-form-input
                                id="shipping_city"
                                v-model="shipping.address.city"
                                data-test="shipping_city"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.city_shipping_placeholder')"
                                type="text"
                                name="shipping_city"
                                :state="submit ? !errors.has('address.shipping_city') : null"
                                v-validate="'required'"
                                @keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="submit ? !errors.has('address.shipping_state') : null">
                                {{ $t('checkout.address.state_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping Neighborhood -->
                          <b-col cols="12" md="6">
                            <b-form-group
                              :label="$t('checkout.address.neighborhood_shipping_label')"
                              label-for="shipping_neighborhood"
                            >
                              <b-form-input
                                id="shipping_neighborhood"
                                v-model="shipping.address.neighborhood"
                                data-test="shipping_neighborhood"
                                @blur="debounceSave"
                                :placeholder="$t('checkout.address.neighborhood_shipping_placeholder')"
                                type="text"
                                name="shipping_neighborhood"
                                :state="submit? !errors.has('address.shipping_neighborhood'): null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></b-form-input>
                              <b-form-invalid-feedback :state="submit ? !errors.has('address.shipping_neighborhood') : null">
                                {{ $t('checkout.address.neighborhood_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Shipping Complement -->
                          <b-col cols="12" lg="7" md="12">
                            <b-form-group
                              :label="$t('checkout.address.complement_shipping_label')"
                              label-for="shipping_complement"
                            >
                              <b-form-input
                                data-test="shipping_complement"
                                id="shipping_complement"
                                @blur="debounceSave"
                                v-model="shipping.address.complement"
                                :placeholder="$t('checkout.address.complement_shipping_placeholder')"
                                type="text"
                                name="shipping_complement"
                              ></b-form-input>
                            </b-form-group>
                          </b-col>
                          <!-- Shipping State / District -->
                          <b-col cols="12" lg="5" md="12">
                            <b-form-group :label="$t('checkout.address.state_shipping_label')" label-for="state">
                              <multiselect
                                v-model="shipping.address.state"
                                :options="getDistrictOptions(countryGlobal)"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :placeholder="$t('checkout.address.state_shipping_label')"
                                :class="{'heaven': isHeaven}"
                                selectLabel=""
                                deselectLabel=""
                                selectedLabel="✔️"
                                name="shipping_state"
                                :state="submit ? !errors.has('address.shipping_state') : null"
                                v-validate="'required'"
                                v-on:keyup.native="validateForm"
                              ></multiselect>
                              <b-form-invalid-feedback :state="submit ? !errors.has('address.shipping_state') : null">
                                {{ $t('checkout.address.state_shipping_feedback_message') }}
                              </b-form-invalid-feedback>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </template>

                  
                  <!-- Shipping Options -->
                  <div v-if="data.zipcode && this.data.has_shipping_fee && !isFixedShipping"
                    data-anima="top"
                    class="opcoes-frete"
                  >
                    <legend>{{ $t('checkout.address.select_shipping') }}</legend>
                    <!-- Loading -->
                    <div v-if="loading_frete">
                      <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <b-form-group v-if="options_shipping.length &&
                        this.data.has_shipping_fee &&
                        !loading_frete
                      "
                      class="frete-remove-dot"
                      v-slot="{ ariaDescribedby }"
                    >
                      <div v-for="frete in options_shipping"
                        :key="frete.id"
                        class="frete-item"
                      >
                        <b-form-radio
                          v-model="shipping.service_id"
                          name="frete"
                          :aria-describedby="ariaDescribedby"
                          :value="frete.id"
                          @change="changeFrete(frete, $event)"
                        >
                          <div class="infos-frete">
                            <img :src="frete.company.picture" />
                            <div class="info-envio">
                              <span>
                                {{ frete.name }}
                              </span>
                              <span v-if="frete.delivery_range">
                                {{ frete.delivery_range.min }} à
                                {{ frete.delivery_range.max }} dias úteis
                              </span>
                              <span class="frete-valor">
                                {{ filterCurrency(currency_id) }}
                                {{ formatMoney(+frete.price) }}
                              </span>
                            </div>
                          </div>
                        </b-form-radio>
                      </div>
                      <b-dropdown-divider></b-dropdown-divider>
                    </b-form-group>
                  </div>
                  <!-- Mobile Button Next Step -->
                  <template v-if="isMobile &&
                      (themeCheckout.step_checkout == 'default'
                      || !themeCheckout.step_checkout)
                    "
                  >
                    <b-row class="mt-2 justify-content-end">
                      <b-col cols="12">
                        <b-button
                          data-test="nextstep"
                          class="col-12 btn-green"
                          :disabled="loading"
                          type="button"
                          variant="primary"
                          @click="nextStep('pagamento', 'address')"
                        >
                          {{ $t('checkout.address.next_step') }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </template>
                </b-form>

                <b-form
                  v-show="
                    !isMobile ||
                    (last_step && !address_step) ||
                    themeCheckout.step_checkout == 'one_step'
                  "
                  data-vv-scope="pay"
                  data-anima="bottom"
                  style="z-index: -1; position: relative"
                >
                  <template v-if="!(!isMobile && product.method === 'FREE')">
                    <!-- Title of Payment Methods -->
                    <div v-if="product.method !== 'FREE'" class="Checkout-title mt-4">
                      <span class="Checkout-title-number" :style="themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark' ? 'color:white !important;' : ''">
                        0{{ $i18n.locale == 'pt' ? etapa_total : 2 }}
                      </span>
                      <!-- Pagamento -->
                      {{ $t('checkout.pagamento.title') }}
                    </div>
                    <template v-if="countryGlobal !== 'OUTROS'">
                      <!-- CPF / CNPJ - Mobile -->
                      <div v-if="isMobile && countryGlobal === 'BR'">
                        <b-form-group
                          :label="$t('checkout.dados_pessoais.document')"
                          label-for="cpf_cnpj"
                        >
                          <b-form-input
                            id="cpf_cnpj"
                            data-test="cpf_cnpj"
                            v-model="data.document"
                            @blur="debounceSave"
                            :placeholder="
                              $t('checkout.dados_pessoais.document_holder')
                            "
                            type="text"
                            name="document"
                            v-validate="'required|cpf_cnpj'"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            v-on:keyup.native="validateForm"
                            :disabled="queryUrl.document && forceUrl"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            :state="submit ? !errors.has('pay.document') : null"
                          >
                            Preencha seu CPF ou CNPJ.
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </div>
                    </template>
                    <!-- Payment Methods -->
                    <b-tabs
                      v-if="product.method !== 'FREE'"
                      content-class="mt-3"
                      :active-nav-item-class="[{
                        'tab-active-dark': themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark',
                        'tab-active': themeCheckout.theme === 'light' || !(themeCheckout.theme_color === '#17191F' && themeCheckout.theme === 'dark')
                      },'mb-2 mb-md-0']"
                      :no-nav-style="true"
                      nav-class="nav_pagamento"
                      v-model="tabs_controller"
                    >
                      <!-- Credit Card -->
                      <b-tab
                        v-if="
                          (product_type == 'COMMON' &&
                            product.method.includes('CREDIT_CARD') && allowed_methods.includes('CREDIT_CARD')) ||
                            (product_type == 'PROPOSAL' &&
                              product.method.includes('CREDIT_CARD') && allowed_methods.includes('CREDIT_CARD'))
                        "
                        id="CREDIT_CARD"
                        data-test="creditcard"
                        title-link-class="tab-nav-icon CREDIT_CARD"
                        active
                        @click="showBtn('CREDIT_CARD')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          <p>
                            {{
                              $t('checkout.pagamento.metodos.cartao_credito')
                            }}
                          </p>
                        </template>

                        <!-- DOIS CARTÕES APENAS SE FOR  'TRANSACTION' -->
                        <b-nav
                          pills
                          class="cartoes-btn"
                          small
                          v-if="
                            (product_type == 'COMMON' &&
                              product.method.includes('TWO_CREDIT_CARDS') &&
                              product.type == 'TRANSACTION') ||
                              (product_type == 'PROPOSAL' &&
                                product.product.method.includes(
                                  'TWO_CREDIT_CARDS'
                                ) &&
                                product.product.type == 'TRANSACTION')
                          "
                        >
                          <b-nav-item
                            data-test="1cartao"
                            :active="method == 'CREDIT_CARD'"
                            @click="addCard1"
                          >
                            <font-awesome-icon
                              icon="credit-card"
                              class="icon mr-2"
                            />
                            {{
                              $t('checkout.pagamento.metodos.um_cartao.title')
                            }}
                          </b-nav-item>
                          <b-nav-item
                            data-test="2cartoes"
                            :active="method == 'TWO_CREDIT_CARDS'"
                            @click="addCard2"
                          >
                            <font-awesome-icon
                              icon="credit-card"
                              class="icon mr-1"
                            /><font-awesome-icon
                              icon="credit-card"
                              class="icon mr-2"
                            />
                            {{
                              $t(
                                'checkout.pagamento.metodos.dois_cartoes.title'
                              )
                            }}
                          </b-nav-item>
                        </b-nav>

                        <b-row
                          v-if="
                            method == 'CREDIT_CARD' ||
                              method == 'TWO_CREDIT_CARDS'
                          "
                          data-anima="top"
                        >
                          <!-- Cartao 01 -->
                          <b-col
                            cols="12"
                            md="6"
                            data-anima="top"
                            id="dados-card"
                          >
                            <span
                              v-if="method == 'TWO_CREDIT_CARDS'"
                              class="card-tag"
                            >
                              {{
                                $t(
                                  'checkout.pagamento.metodos.dois_cartoes.flag'
                                )
                              }}
                              01
                            </span>
                            <b-form-group
                              v-if="method == 'TWO_CREDIT_CARDS'"
                              :label="
                                $t(
                                  'checkout.pagamento.metodos.dois_cartoes.valor'
                                )
                              "
                              label-for="card_amount"
                            >
                              <b-form-input
                                data-test="cardamount1"
                                id="card_amount"
                                v-model="data.cards[0].amount"
                                @blur="changeFirstCard"
                                type="text"
                                :placeholder="
                                  `${filterCurrency(currency_id)} 100,00`
                                "
                                name="card_amount"
                                v-validate="'min_value:1'"
                                :state="
                                  submit
                                    ? formatValueToValidation(
                                        data.cards[0].amount
                                      )
                                    : null
                                "
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? formatValueToValidation(
                                        data.cards[0].amount
                                      )
                                    : null
                                "
                              >
                                {{
                                  $t(
                                    'checkout.pagamento.feedbacks.valor_cartao'
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                              :label="
                                $t(
                                  'checkout.pagamento.metodos.um_cartao.numero'
                                )
                              "
                              label-for="card_number"
                            >
                              <b-form-input
                                data-test="cardnumber1"
                                id="card_number"
                                v-model="data.cards[0].number"
                                type="text"
                                :placeholder="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.numero_holder'
                                  )
                                "
                                name="card_number"
                                :state="
                                  submit
                                    ? !(
                                        errors.has('pay.card_number') ||
                                        card_number_error
                                      )
                                    : null
                                "
                                v-validate="'required'"
                                v-mask="generateCardNumberMask"
                                v-on:focus="focusInput"
                                v-on:blur="blurInput"
                                data-ref="cardNumber"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !(
                                        errors.has('pay.card_number') ||
                                        card_number_error
                                      )
                                    : null
                                "
                              >
                                {{
                                  $t(
                                    'checkout.pagamento.feedbacks.numero_cartao'
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                              :label="
                                $t(
                                  'checkout.pagamento.metodos.um_cartao.titular'
                                )
                              "
                              label-for="card_holder_name"
                            >
                              <b-form-input
                                data-test="cardname1"
                                id="card_holder_name"
                                v-model="data.cards[0].holder_name"
                                type="text"
                                :placeholder="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.titular_holder'
                                  )
                                "
                                name="card_holder_name"
                                :state="
                                  submit
                                    ? !errors.has('pay.card_holder_name')
                                    : null
                                "
                                v-validate="'required'"
                                v-on:focus="focusInput"
                                v-on:blur="blurInput"
                                data-ref="cardName"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('pay.card_holder_name')
                                    : null
                                "
                              >
                                {{
                                  $t(
                                    'checkout.pagamento.feedbacks.titular_cartao'
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-row>
                              <b-col cols="12" md="8">
                                <b-row>
                                  <b-col cols="12" md="6">
                                    <b-form-group
                                      :label="
                                        $t(
                                          'checkout.pagamento.metodos.um_cartao.mes'
                                        )
                                      "
                                      label-for="card_month"
                                    >
                                      <b-form-select
                                        data-test="cardmonth1"
                                        v-model="data.cards[0].month"
                                        class="mb-3"
                                        id="card_month"
                                        name="card_month"
                                        v-validate="'required'"
                                        :state="
                                          submit
                                            ? !errors.has('pay.card_month')
                                            : null
                                        "
                                      >
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              'checkout.pagamento.metodos.um_cartao.mes'
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="n in 12"
                                          :key="n"
                                          :value="n < 10 ? '0' + n : n"
                                          :disabled="n < minCardMonth"
                                        >
                                          {{ 10 > n ? '0' + n : n }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback
                                        :state="
                                          submit
                                            ? !errors.has(
                                                'pay.credit_card.card_month'
                                              )
                                            : null
                                        "
                                      >
                                        {{
                                          $t(
                                            'checkout.pagamento.feedbacks.mes_cartao'
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>

                                  <b-col cols="12" md="6">
                                    <b-form-group
                                      :label="
                                        $t(
                                          'checkout.pagamento.metodos.um_cartao.ano'
                                        )
                                      "
                                      label-for="card_year"
                                    >
                                      <b-form-select
                                        id="card_year"
                                        v-model="data.cards[0].year"
                                        data-test="cardyear1"
                                        class="mb-3"
                                        name="card_year"
                                        v-validate="'required'"
                                        :state="
                                          submit
                                            ? !errors.has('pay.card_year')
                                            : null
                                        "
                                      >
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              'checkout.pagamento.metodos.um_cartao.ano'
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="(n, $index) in 12"
                                          :key="n"
                                          :value="$index + minCardYear"
                                        >
                                          {{ $index + minCardYear }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback
                                        :state="
                                          submit
                                            ? !errors.has(
                                                'pay.credit_card.card_year'
                                              )
                                            : null
                                        "
                                      >
                                        {{
                                          $t(
                                            'checkout.pagamento.feedbacks.ano_cartao'
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>

                              <b-col cols="12" md="4">
                                <b-form-group
                                  :label="
                                    $t(
                                      'checkout.pagamento.metodos.um_cartao.CVV'
                                    )
                                  "
                                  label-for="card_cvv"
                                >
                                  <b-form-input
                                    id="card_cvv"
                                    v-model="data.cards[0].cvv"
                                    data-test="cardcvv1"
                                    type="text"
                                    name="card_cvv"
                                    :state="
                                      submit
                                        ? !errors.has('pay.card_cvv')
                                        : null
                                    "
                                    v-validate="'required'"
                                    maxlength="4"
                                    v-mask="'####'"
                                    v-on:focus="flipCard(true)"
                                    v-on:blur="flipCard(false)"
                                  ></b-form-input>
                                  <b-form-invalid-feedback
                                    :state="
                                      submit
                                        ? !errors.has('pay.card_cvv')
                                        : null
                                    "
                                  >
                                    {{
                                      $t(
                                        'checkout.pagamento.feedbacks.cvv_cartao'
                                      )
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="12" md="6" data-anima="top" id="_card">
                            <!-- Credit Card -->
                            <card
                              v-if="method == 'CREDIT_CARD'"
                              ref="card"
                              :card_number="data.cards[0].number"
                              :card_holder_name="data.cards[0].holder_name"
                              :card_month="String(data.cards[0].month)"
                              :card_year="String(data.cards[0].year)"
                              :card_cvv="data.cards[0].cvv"
                            />

                            <!-- Cartao 02 -->
                            <template v-if="method == 'TWO_CREDIT_CARDS'">
                              <span class="card-tag">Cartão 02</span>
                              <b-form-group
                                :label="
                                  $t(
                                    'checkout.pagamento.metodos.dois_cartoes.valor'
                                  )
                                "
                                label-for="card_amount"
                              >
                                <b-form-input
                                  id="card_amount"
                                  v-model="data.cards[1].amount"
                                  data-test="cardamount2"
                                  @blur="changeSecondCard"
                                  type="text"
                                  :placeholder="
                                    `${filterCurrency(currency_id)} 100,00`
                                  "
                                  name="card_amount"
                                  :state="
                                    submit
                                      ? formatValueToValidation(
                                          data.cards[1].amount
                                        )
                                      : null
                                  "
                                  v-validate="'min_value:1'"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                  :state="
                                    submit
                                      ? formatValueToValidation(
                                          data.cards[1].amount
                                        )
                                      : null
                                  "
                                >
                                  {{
                                    $t(
                                      'checkout.pagamento.feedbacks.valor_cartao'
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group
                                :label="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.numero'
                                  )
                                "
                                label-for="card_number"
                              >
                                <b-form-input
                                  id="card_number"
                                  v-model="data.cards[1].number"
                                  data-test="cardnumber2"
                                  type="text"
                                  :placeholder="
                                    $t(
                                      'checkout.pagamento.metodos.um_cartao.numero_holder'
                                    )
                                  "
                                  name="partial_card_number"
                                  :state="
                                    submit
                                      ? !(
                                          errors.has(
                                            'pay.partial_card_number'
                                          ) || card_number_error
                                        )
                                      : null
                                  "
                                  v-validate="'required'"
                                  v-mask="generateCardNumberMask"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                  :state="
                                    submit
                                      ? !(
                                          errors.has(
                                            'pay.partial_card_number'
                                          ) || card_number_error
                                        )
                                      : null
                                  "
                                >
                                  {{
                                    $t(
                                      'checkout.pagamento.feedbacks.numero_cartao'
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-form-group
                                :label="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.titular'
                                  )
                                "
                                label-for="card_holder_name"
                              >
                                <b-form-input
                                  id="card_holder_name"
                                  v-model="data.cards[1].holder_name"
                                  data-test="cardname2"
                                  type="text"
                                  :placeholder="
                                    $t(
                                      'checkout.pagamento.metodos.um_cartao.titular_holder'
                                    )
                                  "
                                  name="partial_card_holder_name"
                                  :state="
                                    submit
                                      ? !errors.has(
                                          'pay.partial_card_holder_name'
                                        )
                                      : null
                                  "
                                  v-validate="'required'"
                                ></b-form-input>
                                <b-form-invalid-feedback
                                  :state="
                                    submit
                                      ? !errors.has(
                                          'pay.partial_card_holder_name'
                                        )
                                      : null
                                  "
                                >
                                  {{
                                    $t(
                                      'checkout.pagamento.feedbacks.titular_cartao'
                                    )
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>

                              <b-row>
                                <b-col cols="12" md="8">
                                  <b-row>
                                    <b-col cols="12" md="6">
                                      <b-form-group
                                        :label="
                                          $t(
                                            'checkout.pagamento.metodos.um_cartao.mes'
                                          )
                                        "
                                        label-for="card_month"
                                      >
                                        <b-form-select
                                          data-test="cardmonth2"
                                          v-model="data.cards[1].month"
                                          class="mb-3"
                                          id="card_month"
                                          name="partial_card_month"
                                          v-validate="'required'"
                                          :state="
                                            submit
                                              ? !errors.has(
                                                  'pay.partial_card_month'
                                                )
                                              : null
                                          "
                                        >
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                'checkout.pagamento.metodos.um_cartao.mes'
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option
                                            v-for="n in 12"
                                            :key="n"
                                            :value="n < 10 ? '0' + n : n"
                                            :disabled="n < minCardMonth"
                                          >
                                            {{ 10 > n ? '0' + n : n }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback
                                          :state="
                                            submit
                                              ? !errors.has(
                                                  'pay.partial_card_month'
                                                )
                                              : null
                                          "
                                        >
                                          {{
                                            $t(
                                              'checkout.pagamento.feedbacks.mes_cartao'
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>

                                    <b-col cols="12" md="6">
                                      <b-form-group
                                        :label="
                                          $t(
                                            'checkout.pagamento.metodos.um_cartao.ano'
                                          )
                                        "
                                        label-for="card_year"
                                      >
                                        <b-form-select
                                          id="card_year"
                                          v-model="data.cards[1].year"
                                          data-test="cardyear2"
                                          class="mb-3"
                                          name="partial_card_year"
                                          v-validate="'required'"
                                          :state="
                                            submit
                                              ? !errors.has(
                                                  'pay.partial_card_year'
                                                )
                                              : null
                                          "
                                        >
                                          <b-form-select-option value="">
                                            {{
                                              $t(
                                                'checkout.pagamento.metodos.um_cartao.ano'
                                              )
                                            }}
                                          </b-form-select-option>
                                          <b-form-select-option
                                            v-for="(n, $index) in 12"
                                            :key="n"
                                            :value="$index + minCardYear"
                                          >
                                            {{ $index + minCardYear }}
                                          </b-form-select-option>
                                        </b-form-select>
                                        <b-form-invalid-feedback
                                          :state="
                                            submit
                                              ? !errors.has(
                                                  'pay.partial_card_year'
                                                )
                                              : null
                                          "
                                        >
                                          {{
                                            $t(
                                              'checkout.pagamento.feedbacks.ano_cartao'
                                            )
                                          }}
                                        </b-form-invalid-feedback>
                                      </b-form-group>
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col cols="12" md="4">
                                  <b-form-group
                                    :label="
                                      $t(
                                        'checkout.pagamento.metodos.um_cartao.CVV'
                                      )
                                    "
                                    label-for="card_cvv"
                                  >
                                    <b-form-input
                                      id="card_cvv"
                                      v-model="data.cards[1].cvv"
                                      data-test="cardcvv2"
                                      type="text"
                                      name="partial_card_cvv"
                                      :state="
                                        submit
                                          ? !errors.has('pay.partial_card_cvv')
                                          : null
                                      "
                                      v-validate="'required'"
                                      maxlength="4"
                                      v-mask="'####'"
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                      :state="
                                        submit
                                          ? !errors.has('pay.partial_card_cvv')
                                          : null
                                      "
                                    >
                                      {{
                                        $t(
                                          'checkout.pagamento.feedbacks.cvv_cartao'
                                        )
                                      }}
                                    </b-form-invalid-feedback>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                            </template>
                          </b-col>
                        </b-row>
                      </b-tab>
                      <!-- Debit Card -->
                      <b-tab
                        v-if="product.method.includes('DEBITCARD') && allowed_methods.includes('DEBITCARD') && isHeaven"
                        id="DEBITCARD"
                        data-test="creditcard"
                        title-link-class="tab-nav-icon DEBITCARD"
                        active
                        @click="showBtn('DEBITCARD')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          <p>
                            {{ $t('checkout.pagamento.metodos.cartao_debito') }}
                          </p>
                        </template>

                        <!-- DOIS CARTÕES APENAS SE FOR  'TRANSACTION' -->

                        <b-row data-anima="top">
                          <!-- Cartao 01 -->
                          <b-col
                            cols="12"
                            md="6"
                            data-anima="top"
                            id="dados-card"
                          >
                            <b-form-group
                              :label="
                                $t(
                                  'checkout.pagamento.metodos.um_cartao.numero'
                                )
                              "
                              label-for="card_number"
                            >
                              <b-form-input
                                data-test="cardnumber1"
                                id="card_number"
                                v-model="data.cards[0].number"
                                type="text"
                                :placeholder="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.numero_holder'
                                  )
                                "
                                name="card_number"
                                :state="
                                  submit
                                    ? !(
                                        errors.has('pay.card_number') ||
                                        card_number_error
                                      )
                                    : null
                                "
                                v-validate="'required'"
                                v-mask="generateCardNumberMask"
                                v-on:focus="focusInput"
                                v-on:blur="blurInput"
                                data-ref="cardNumber"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !(
                                        errors.has('pay.card_number') ||
                                        card_number_error
                                      )
                                    : null
                                "
                              >
                                {{
                                  $t(
                                    'checkout.pagamento.feedbacks.numero_cartao'
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                              :label="
                                $t(
                                  'checkout.pagamento.metodos.um_cartao.titular'
                                )
                              "
                              label-for="card_holder_name"
                            >
                              <b-form-input
                                data-test="cardname1"
                                id="card_holder_name"
                                v-model="data.cards[0].holder_name"
                                type="text"
                                :placeholder="
                                  $t(
                                    'checkout.pagamento.metodos.um_cartao.titular_holder'
                                  )
                                "
                                name="card_holder_name"
                                :state="
                                  submit
                                    ? !errors.has('pay.card_holder_name')
                                    : null
                                "
                                v-validate="'required'"
                                v-on:focus="focusInput"
                                v-on:blur="blurInput"
                                data-ref="cardName"
                              ></b-form-input>
                              <b-form-invalid-feedback
                                :state="
                                  submit
                                    ? !errors.has('pay.card_holder_name')
                                    : null
                                "
                              >
                                {{
                                  $t(
                                    'checkout.pagamento.feedbacks.titular_cartao'
                                  )
                                }}
                              </b-form-invalid-feedback>
                            </b-form-group>

                            <b-row>
                              <b-col cols="12" md="8">
                                <b-row>
                                  <b-col cols="12" md="6">
                                    <b-form-group
                                      :label="
                                        $t(
                                          'checkout.pagamento.metodos.um_cartao.mes'
                                        )
                                      "
                                      label-for="card_month"
                                    >
                                      <b-form-select
                                        data-test="cardmonth1"
                                        v-model="data.cards[0].month"
                                        class="mb-3"
                                        id="card_month"
                                        name="card_month"
                                        v-validate="'required'"
                                        :state="
                                          submit
                                            ? !errors.has('pay.card_month')
                                            : null
                                        "
                                      >
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              'checkout.pagamento.metodos.um_cartao.mes'
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="n in 12"
                                          :key="n"
                                          :value="n < 10 ? '0' + n : n"
                                          :disabled="n < minCardMonth"
                                        >
                                          {{ 10 > n ? '0' + n : n }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback
                                        :state="
                                          submit
                                            ? !errors.has(
                                                'pay.credit_card.card_month'
                                              )
                                            : null
                                        "
                                      >
                                        {{
                                          $t(
                                            'checkout.pagamento.feedbacks.mes_cartao'
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>

                                  <b-col cols="12" md="6">
                                    <b-form-group
                                      :label="
                                        $t(
                                          'checkout.pagamento.metodos.um_cartao.ano'
                                        )
                                      "
                                      label-for="card_year"
                                    >
                                      <b-form-select
                                        id="card_year"
                                        v-model="data.cards[0].year"
                                        data-test="cardyear1"
                                        class="mb-3"
                                        name="card_year"
                                        v-validate="'required'"
                                        :state="
                                          submit
                                            ? !errors.has('pay.card_year')
                                            : null
                                        "
                                      >
                                        <b-form-select-option value="">
                                          {{
                                            $t(
                                              'checkout.pagamento.metodos.um_cartao.ano'
                                            )
                                          }}
                                        </b-form-select-option>
                                        <b-form-select-option
                                          v-for="(n, $index) in 12"
                                          :key="n"
                                          :value="$index + minCardYear"
                                        >
                                          {{ $index + minCardYear }}
                                        </b-form-select-option>
                                      </b-form-select>
                                      <b-form-invalid-feedback
                                        :state="
                                          submit
                                            ? !errors.has(
                                                'pay.credit_card.card_year'
                                              )
                                            : null
                                        "
                                      >
                                        {{
                                          $t(
                                            'checkout.pagamento.feedbacks.ano_cartao'
                                          )
                                        }}
                                      </b-form-invalid-feedback>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </b-col>

                              <b-col cols="12" md="4">
                                <b-form-group
                                  :label="
                                    $t(
                                      'checkout.pagamento.metodos.um_cartao.CVV'
                                    )
                                  "
                                  label-for="card_cvv"
                                >
                                  <b-form-input
                                    id="card_cvv"
                                    v-model="data.cards[0].cvv"
                                    data-test="cardcvv1"
                                    type="text"
                                    name="card_cvv"
                                    :state="
                                      submit
                                        ? !errors.has('pay.card_cvv')
                                        : null
                                    "
                                    v-validate="'required'"
                                    maxlength="4"
                                    v-mask="'####'"
                                    v-on:focus="flipCard(true)"
                                    v-on:blur="flipCard(false)"
                                  ></b-form-input>
                                  <b-form-invalid-feedback
                                    :state="
                                      submit
                                        ? !errors.has('pay.card_cvv')
                                        : null
                                    "
                                  >
                                    {{
                                      $t(
                                        'checkout.pagamento.feedbacks.cvv_cartao'
                                      )
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>

                          <b-col cols="12" md="6" data-anima="top" id="_card">
                            <!-- Debit Card -->
                            <card
                              v-if="method == 'DEBITCARD'"
                              ref="card"
                              :card_number="data.cards[0].number"
                              :card_holder_name="data.cards[0].holder_name"
                              :card_month="String(data.cards[0].month)"
                              :card_year="String(data.cards[0].year)"
                              :card_cvv="data.cards[0].cvv"
                            />
                          </b-col>
                        </b-row>
                      </b-tab>
                      <!-- Pix -->
                      <b-tab
                        v-if="product.method.includes('PIX') && allowed_methods.includes('PIX')"
                        id="PIX"
                        data-test="pix"
                        title-link-class="tab-nav-icon PIX"
                        @click="showBtn('PIX')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="qrcode" class="icon" />
                          Pix
                        </template>
                        
                      </b-tab>
                      <SafetypayCash
                        v-if="product.method.includes('SAFETYPAY-CASH') && allowed_methods.includes('SAFETYPAY-CASH') && product.seller.is_heaven && isHeaven"
                        @click="showBtn('SAFETYPAY-CASH')"
                      />
                      <Efecty
                        v-if="product.method.includes('EFECTY') && allowed_methods.includes('EFECTY') && product.seller.is_heaven && isHeaven"
                        @click="showBtn('EFECTY')"
                      />
                      <!-- Pagofacil -->
                      <b-tab
                        v-if="product.method.includes('PAGOFACIL') && allowed_methods.includes('PAGOFACIL') && isHeaven"
                        id="PAGOFACIL"
                        data-test="PAGOFACIL"
                        title-link-class="tab-nav-icon PAGOFACIL"
                        @click="showBtn('PAGOFACIL')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          PAGOFACIL
                        </template>
                      </b-tab>
                      <!-- Rapipago -->
                      <b-tab
                        v-if="product.method.includes('RAPIPAGO') && allowed_methods.includes('RAPIPAGO') && isHeaven"
                        id="RAPIPAGO"
                        data-test="RAPIPAGO"
                        title-link-class="tab-nav-icon RAPIPAGO"
                        @click="showBtn('RAPIPAGO')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          RAPIPAGO
                        </template>
                      </b-tab>
                      <!-- Pagosnet -->
                      <b-tab
                        v-if="product.method.includes('PAGOSNET') && allowed_methods.includes('PAGOSNET') && isHeaven"
                        id="PAGOSNET"
                        data-test="PAGOSNET"
                        title-link-class="tab-nav-icon PAGOSNET"
                        @click="showBtn('PAGOSNET')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          PAGOSNET
                        </template>
                      </b-tab>
                      <!-- EFT -->
                      <b-tab
                        v-if="product.method.includes('EFT') && allowed_methods.includes('EFT') && isHeaven"
                        id="EFT"
                        data-test="EFT"
                        title-link-class="tab-nav-icon EFT"
                        @click="showBtn('EFT')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          EFT
                        </template>

                        <b-col cols="12" lg="8" md="12">
                          <b-form-group label="Banco" label-for="bank">
                            <b-form-select
                              id="bank"
                              data-test="bank"
                              v-model="bank_type"
                              placeholder="Seleccione su banco"
                              value-field="code"
                              text-field="name"
                              name="bank"
                              :options="external_banks"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-tab>
                      <!-- Multicaja -->
                      <b-tab
                        v-if="product.method.includes('MULTICAJA') && allowed_methods.includes('MULTICAJA') && isHeaven"
                        id="MULTICAJA"
                        data-test="MULTICAJA"
                        title-link-class="tab-nav-icon MULTICAJA"
                        @click="showBtn('MULTICAJA')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          MULTICAJA
                        </template>
                      </b-tab>
                      <!-- Sencillito -->
                      <b-tab
                        v-if="product.method.includes('SENCILLITO') && allowed_methods.includes('SENCILLITO') && isHeaven"
                        id="SENCILLITO"
                        data-test="SENCILLITO"
                        title-link-class="tab-nav-icon SENCILLITO"
                        @click="showBtn('SENCILLITO')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SENCILLITO
                        </template>
                      </b-tab>
                      <!-- Servipag -->
                      <b-tab
                        v-if="product.method.includes('SERVIPAG') && allowed_methods.includes('SERVIPAG') && isHeaven"
                        id="SERVIPAG"
                        data-test="SERVIPAG"
                        title-link-class="tab-nav-icon SERVIPAG"
                        @click="showBtn('SERVIPAG')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SERVIPAG
                        </template>
                      </b-tab>
                      <!-- Webpay -->
                      <b-tab
                        v-if="product.method.includes('WEBPAY') && allowed_methods.includes('WEBPAY') && isHeaven"
                        id="WEBPAY"
                        data-test="WEBPAY"
                        title-link-class="tab-nav-icon WEBPAY"
                        @click="showBtn('WEBPAY')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          WEBPAY
                        </template>
                      </b-tab>
                      <!-- SPEI -->
                      <b-tab
                        v-if="product.method.includes('SPEI') && allowed_methods.includes('SPEI') && isHeaven"
                        id="SPEI"
                        data-test="SPEI"
                        title-link-class="tab-nav-icon SPEI"
                        @click="showBtn('SPEI')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="credit-card" class="icon" />
                          SPEI
                        </template>
                      </b-tab>
                      <Oxxo
                        v-if="product.method.includes('OXXO') && allowed_methods.includes('OXXO') && product.seller.is_heaven  && isHeaven"
                        @click="showBtn('OXXO')"
                      />
                      <!-- Ticket -->
                      <b-tab
                        v-if="product.method.includes('BOLETO') && allowed_methods.includes('BOLETO')"
                        id="BOLETO"
                        data-test="boleto"
                        title-link-class="tab-nav-icon BOLETO"
                        @click="showBtn('BOLETO')"
                      >
                        <template v-slot:title>
                          <font-awesome-icon icon="file-invoice-dollar" class="icon" />
                          Boleto
                        </template>
                        <div data-anima="top" v-if="$i18n.locale == 'pt'">
                          <p>
                            Pagamentos com Boleto Bancário levam até 3 dias
                            úteis para serem compensados e então terem os
                            produtos liberados.
                          </p>
                        </div>
                      </b-tab>
                      <!-- Paypal -->
                      <b-tab
                        v-if="
                          products_list.length === 1 &&
                          product.method.includes('PAYPAL') &&
                          !hasBumpSelected
                        "
                        id="PAYPAL"
                        data-test="paypal"
                        title-link-class="tab-nav-icon PAYPAL"
                        @click="renderPaypal()"
                      >
                        <template v-slot:title>
                          <font-awesome-icon :icon="['fab', 'paypal']" class="icon" />
                          Paypal
                        </template>
                      </b-tab>
                    </b-tabs>

                    <!-- Instellments -->
                    <b-row class="justify-content-start">
                      <b-col
                        v-if="validateInstallments()"
                        cols="12"
                        md="6"
                        id="parcelas_item"
                      >
                        <b-form-group
                          :label=" $t('checkout.pagamento.metodos.um_cartao.parcelas')"
                          label-for="installments"
                        >
                          <!-- Installments Not Fixed -->
                          <b-form-select
                            v-if="validateSelectNotFixedInstallments()"
                            id="installments"
                            v-model="installments"
                            data-test="installments"
                            @change="changeParcelamentoCartao"
                            name="installments"
                          >
                            <template v-for="(n, $index) in  product.max_installments">
                              <b-form-select-option
                                v-if="getIndexInstallments($index + 1)"
                                :key="n"
                                :value="$index + 1"
                              >
                                {{
                                  $index + 1 > 1
                                    ? $index +
                                      1 +
                                      `x ${!sem_juros ? $t('order.de') : ''} ${
                                        sem_juros ? '(Sem Juros) de' : ''
                                      } ${filterCurrency(currency_id)} ` +
                                      formatMoney(getInstallments($index + 1)) +
                                      `${sem_juros ? '' : '*'}`
                                    : $index +
                                      1 +
                                      `x ${$t('order.de')} ${filterCurrency(
                                        currency_id
                                      )}
                                      ${formatMoney(getInstallments(1))}`
                                }}
                              </b-form-select-option>
                            </template>
                          </b-form-select>

                          <!-- Installments Fixed -->
                          <b-form-select
                            v-if="
                              parcela_fixa &&
                              countryGlobal !== 'CO' &&
                              countryGlobal !== 'CL' &&
                              countryGlobal !== 'MX' &&
                              countryGlobal !== 'PE' &&
                              countryGlobal !== 'UY'
                            "
                            id="installments"
                            v-model="installments"
                            data-test="installments"
                            name="installments"
                            @change="changeParcelamentoCartao"
                          >
                            <b-form-select-option v-bind:value="parcela_fixa">
                              {{
                                parcela_fixa +
                                  `x ${$t('order.de')} ${filterCurrency(
                                    currency_id
                                  )} ` +
                                  formatMoney(getInstallments(parcela_fixa)) +
                                  `${sem_juros ? '' : '*'}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <!-- Parcelas Boleto -->
                      <b-col
                        v-if="
                          method == 'BOLETO' &&
                          permite_parcela_boleto > 1 &&
                          product.type == 'TRANSACTION'
                        "
                        cols="12"
                        md="6"
                        id="parcelas_item"
                      >
                        <b-form-group
                          label="Parcelas do boleto"
                          label-for="installments"
                        >
                          <b-form-select
                            id="installments"
                            v-model="installments_boleto"
                            data-test="installmentsboleto"
                            name="installments"
                          >
                            <b-form-select-option
                              v-for="(n, $index) in permite_parcela_boleto"
                              :key="n"
                              :value="$index + 1"
                            >
                              {{
                                $index + 1 > 1
                                  ? $index +
                                    1 +
                                    `x${product.no_interest_installments ? ' (Sem juros)' : ''} ${$t('order.de')} ${filterCurrency(currency_id)} ` +
                                    formatMoney(getInstallments($index + 1)) +
                                    '*'
                                  : $index +
                                    1 +
                                    `x${product.no_interest_installments ? ' (Sem juros)' : ''} ${$t('order.de')} ${filterCurrency(currency_id)}
                                    ${formatMoney(getInstallments(1))}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <!-- Parcelas Assinatura -->
                      <b-col
                        v-if="
                          method == 'CREDIT_CARD' &&
                            permite_parcela_assinatura > 1 &&
                            product.type == 'SUBSCRIPTION' &&
                            product.period > 30
                        "
                        cols="12"
                        md="6"
                        id="parcelas_item"
                      >
                        <b-form-group
                          label="Parcelas da Assinatura"
                          label-for="installments"
                        >
                          <b-form-select
                            v-if="!parcela_fixa"
                            id="installments"
                            v-model="installments"
                            data-test="installmentsboleto"
                            name="installments"
                          >
                            <template
                              v-for="(n, $index) in permite_parcela_assinatura"
                            >
                              <b-form-select-option
                                v-if="getIndexInstallments($index + 1)"
                                :key="n"
                                :value="$index + 1"
                              >
                                {{
                                  $index + 1 > 1
                                    ? $index +
                                      1 +
                                      `x ${$t('order.de')} ${filterCurrency(
                                        currency_id
                                      )} ` +
                                      formatMoney(getInstallments($index + 1)) +
                                      `${sem_juros ? '' : '*'}`
                                    : $index +
                                      1 +
                                      `x ${$t('order.de')} ${filterCurrency(
                                        currency_id
                                      )}
                                    ${formatMoney(getInstallments(1))}`
                                }}
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <!-- parcela fixa -->
                          <b-form-select
                            v-if="parcela_fixa"
                            id="installments"
                            v-model="installments"
                            data-test="installments"
                            name="installments"
                          >
                            <b-form-select-option :value="parcela_fixa">
                              {{
                                parcela_fixa +
                                  `x ${$t('order.de')} ${filterCurrency(
                                    currency_id
                                  )} ` +
                                  formatMoney(getInstallments(parcela_fixa)) +
                                  `${sem_juros ? '' : '*'}`
                              }}
                            </b-form-select-option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col>
                        <div v-if="themeCheckout.trial_position == 'bottom'">
                          <b-badge
                            v-if="product.trial"
                            data-test="trialproduct"
                            variant="success"
                            class="Product-trial business"
                          >
                            {{ $t('order.apos_trial') }} de
                            {{ product.trial }}
                            dias:
                            {{ calculateAmountAfterTrial() }}

                            <span v-if="product.type === 'SUBSCRIPTION'">
                              {{ setPeriod }}
                            </span>
                          </b-badge>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                  <!-- List Order Bump -->
                  <div v-if="bump_list.length && !permite_parcela_boleto && !hasOnlyPaypalMethod && product.method !== 'FREE' && !hasFreeBump">
                    <div class="Product-bump">
                      <!-- Custom Title of Order Bump -->
                      <p class="titleBump" v-if="custom_bump">
                        {{ custom_bump.ob_title }}
                      </p>
                      <!-- Normal Title of Order Bump -->
                      <p class="titleBump" v-else>
                        {{ $t('checkout.pagamento.bump.title') }} 🔥
                      </p>
                      <!-- Order Bump -->
                      <div
                        v-for="(bump, index) in bump_list"
                        :key="bump.id"
                        :class="{ noBump: no_bump }"
                      >
                        <!-- Normal Order Bump -->
                        <order-bump-card
                          v-if="bump.method !== 'FREE'"
                          :item="bump"
                          :method="method"
                          :data="data"
                          :custom="custom_bump"
                          :currentCurrency="filterCurrency()"
                          :product-seller-id="product.seller.id"
                          @clicked="changeBump(bump, index)"
                          @selected-shipping="productHasShipping"
                        >
                        </order-bump-card>
                      </div>
                    </div>
                  </div>

                  <b-tooltip
                    v-if="hasBumpSelected"
                    target="paypal-click-btn"
                    :title="
                      $t('checkout.pagamento.paypal_desabilitado_pelo_bump')
                    "
                  />

                  <b-row
                    id="paypal-click-btn"
                    v-if="method == 'PAYPAL'"
                    data-anima="top"
                  >
                    <b-col cols="12" style="padding: 30px">
                      <div
                        v-if="paypal_true == true"
                        id="div-paypal"
                        ref="paypal"
                        data-test="submitpaypal"
                      ></div>
                      <b-button
                        v-else
                        id="disabled-paypal"
                        block
                        type="button"
                        disabled
                        variant="dark"
                        class="btn-paypal"
                      >
                        <img
                          src="data:image/svg+xml;base64,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"
                          width="75px"
                          data-v-fd53f700=""
                          alt="paypal"
                          aria-label="PayPal"
                          class="
                            paypal-logo
                            paypal-logo-paypal
                            paypal-logo-color-white
                          "
                        />
                        {{ $t('checkout.pagamento.metodos.paypal.btn_text') }}
                      </b-button>
                      <Captcha
                        ref="CaptchaPaypal"
                        @changeVerify="(e) => changeVerify(e, true)"
                      ></Captcha>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2" data-anima="bottom">
                    <b-col cols="12">
                      <!-- Buy Now Button -->
                      <b-button
                        v-show="btn_paypal == false"
                        v-if="!captcha"
                        data-test="submit"
                        variant="success"
                        class="col-12 btn-checkout"
                        :disabled="loading"
                        type="button"
                        @click="onSubmit('get')"
                      >
                        <div v-if="!loading">
                          {{
                            !themeCheckout.button_text
                              ? $t('checkout.footer.btn_compra')
                              : themeCheckout.button_text
                          }}
                        </div>
                        <div v-if="loading">
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                      </b-button>

                      <Captcha
                        v-if="captcha"
                        ref="Captcha"
                        @changeVerify="changeVerify"
                      >
                        <b-button
                          v-show="btn_paypal == false"
                          data-test="submit"
                          variant="success"
                          class="col-12 btn-checkout"
                          :disabled="loading"
                          type="button"
                          @click="onSubmit()"
                        >
                          <div v-if="!loading">
                            {{
                              !themeCheckout.button_text
                                ? $t('checkout.footer.btn_compra')
                                : themeCheckout.button_text
                            }}
                          </div>
                          <div v-if="loading">
                            <b-spinner label="Loading..."></b-spinner>
                          </div>
                        </b-button>
                      </Captcha>

                      <small v-if="captcha">
                        {{ $t('checkout.captcha') }}
                        <a href="https://policies.google.com/privacy"
                          >{{ $t('checkout.captcha2') }}
                        </a>
                        {{ $t('checkout.captcha4') }}
                        <a href="https://policies.google.com/terms">{{
                          $t('checkout.captcha3')
                        }}</a>
                        {{ $t('checkout.captcha5') }}.
                      </small>

                      <template v-if="method === 'PIX'">
                        <div data-anima="top">
                          <InfoPix
                            :main_color="themeCheckout.theme_color || (this.isHeaven ? '#0070EB' : '#00E4A0')"
                          />
                        </div>
                      </template>

                      <!-- Security and Encryption Info -->
                      <div class="mt-4 d-flex align-items-center">
                        <font-awesome-icon icon="lock" class="icon-lock" />
                        <p class="m-0 ml-3">
                          {{ $t('checkout.footer.info_seguranca') }}
                        </p>
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </div>

              <template v-if="themeCheckout.bottom_thumb">
                <div class="container banner-container container-banner-footer">
                  <img
                    :src="themeCheckout.bottom_thumb"
                    alt="bottom-thumb"
                    class="banner"
                  />
                </div>
              </template>

              <div class="Checkout-footer-brands">
                <div
                  class="footer-safe"
                  v-if="!charge_error && !charge_success"
                >
                  <div class="item-safe">
                    <img
                      src="@/assets/img/icon/safe_lock.svg"
                      alt="safe_lock"
                    />
                    <p>{{ $t('checkout.footer.icons.compra_segura.label') }}</p>
                    <p class="destaque-info _lock">
                      {{ $t('checkout.footer.icons.compra_segura.destaque') }}
                    </p>
                  </div>
                  <div class="item-safe">
                    <img
                      src="@/assets/img/icon/safe_product.svg"
                      alt="safe_product"
                    />
                    <p>
                      {{ $t('checkout.footer.icons.produto_revisado.label') }}
                    </p>
                    <p class="destaque-info _product">
                      {{
                        $t('checkout.footer.icons.produto_revisado.destaque')
                      }}
                    </p>
                  </div>
                  <div class="item-safe">
                    <img
                      src="@/assets/img/icon/safe_dados.svg"
                      alt="safe_dados"
                    />
                    <p>
                      {{ $t('checkout.footer.icons.dados_protegidos.label') }}
                    </p>
                    <p class="destaque-info _dados">
                      {{
                        $t('checkout.footer.icons.dados_protegidos.destaque')
                      }}
                    </p>
                  </div>
                </div>

                <div
                  v-if="isMobile && themeCheckout.theme == 'light'"
                  class="cards_type mobile"
                >
                  <img v-if="!isHeaven" src="@/assets/img/logo2.png" class="icon-footer" alt="icon-greenn" />
                  <img v-else src="@/assets/img/heaven/logo.svg" class="icon-footer" alt="icon-greenn" />
                  <img
                    :src="getImg('visa')"
                    class="icon-footer"
                    alt="icon-visa"
                  />
                  <img
                    :src="getImg('mastercard')"
                    class="icon-footer"
                    alt="icon-mastercard"
                  />
                  <img
                    :src="getImg('hipercard-v2')"
                    class="icon-footer"
                    alt="icon-hipercard"
                  />
                  <img
                    :src="getImg('diners')"
                    class="icon-footer"
                    alt="icon-diners"
                  />
                  <img
                    :src="getImg('elo')"
                    class="icon-footer"
                    alt="icon-elo"
                  />
                  <img
                    :src="getImg('boleto-barcode')"
                    class="icon-footer"
                    alt="icon-boleto"
                  />
                </div>
                <div
                  v-if="isMobile && themeCheckout.theme == 'dark'"
                  class="cards_type mobile"
                >
                  <img v-if="!isHeaven" src="@/assets/img/logo2-dark.png" class="icon-footer" alt="icon-greenn" />
                  <img v-else src="@/assets/img/heaven/logo-dark.svg" class="icon-footer" alt="icon-greenn" />
                  <img
                    :src="getImg('visa-dark')"
                    class="icon-footer"
                    alt="icon-visa"
                  />
                  <img
                    :src="getImg('mastercard-dark')"
                    class="icon-footer"
                    alt="icon-mastercard"
                  />
                  <img
                    :src="getImg('hipercard-v2-dark')"
                    class="icon-footer"
                    alt="icon-hipercard"
                  />
                  <img
                    :src="getImg('diners-dark')"
                    class="icon-footer"
                    alt="icon-diners"
                  />
                  <img
                    :src="getImg('elo-dark')"
                    class="icon-footer"
                    alt="icon-elo"
                  />
                  <img
                    :src="getImg('boleto-barcode-dark')"
                    class="icon-footer"
                    alt="icon-boleto"
                  />
                </div>

                <p
                  v-if="
                    !charge_error && !charge_success && !isMobile && !sem_juros
                  "
                  class="p-footer"
                >
                  {{ $t('checkout.footer.taxa_parcela') }}
                  <!-- Interest Free Instellments -->
                </p>
                <div
                  v-if="
                    !charge_error &&
                      !charge_success &&
                      !isMobile &&
                      themeCheckout.theme == 'light'
                  "
                  class="cards_type"
                >
                  <img v-if="!isHeaven" src="@/assets/img/logo2.png" class="icon-footer" alt="icon-greenn" />
                  <img v-else src="@/assets/img/heaven/logo.svg" class="icon-footer" alt="icon-greenn" />
                  <img
                    :src="getImg('visa')"
                    class="icon-footer"
                    alt="icon-visa"
                  />
                  <img
                    :src="getImg('mastercard')"
                    class="icon-footer"
                    alt="icon-mastercard"
                  />
                  <img
                    :src="getImg('hipercard-v2')"
                    class="icon-footer"
                    alt="icon-hipercard"
                  />
                  <img
                    :src="getImg('diners')"
                    class="icon-footer"
                    alt="icon-diners"
                  />
                  <img
                    :src="getImg('elo')"
                    class="icon-footer"
                    alt="icon-elo"
                  />
                  <img
                    :src="getImg('boleto-barcode')"
                    class="icon-footer"
                    alt="icon-boleto"
                  />
                </div>

                <div
                  v-if="
                    !charge_error &&
                      !charge_success &&
                      !isMobile &&
                      themeCheckout.theme == 'dark'
                  "
                  class="cards_type"
                >
                  <img v-if="!isHeaven" src="@/assets/img/logo2-dark.png" class="icon-footer" alt="icon-greenn" />
                  <img v-else src="@/assets/img/heaven/logo-dark.svg" class="icon-footer" alt="icon-greenn" />
                  <img
                    :src="getImg('visa-dark')"
                    class="icon-footer"
                    alt="icon-visa"
                  />
                  <img
                    :src="getImg('mastercard-dark')"
                    class="icon-footer"
                    alt="icon-mastercard"
                  />
                  <img
                    :src="getImg('hipercard-v2-dark')"
                    class="icon-footer"
                    alt="icon-hipercard"
                  />
                  <img
                    :src="getImg('diners-dark')"
                    class="icon-footer"
                    alt="icon-diners"
                  />
                  <img
                    :src="getImg('elo-dark')"
                    class="icon-footer"
                    alt="icon-elo"
                  />
                  <img
                    :src="getImg('boleto-barcode-dark')"
                    class="icon-footer"
                    alt="icon-boleto"
                  />
                </div>
              </div>

              <b-row
                v-if="!charge_error && !charge_success"
                class="Checkout-footer"
              >
                <div class="info-termos">
                  <p class="p-footer"></p>
                  <p class="p-footer mb-1" v-if="isMobile && !sem_juros">
                    {{ $t('checkout.footer.taxa_parcela') }}
                  </p>
                  <p class="p-footer" v-if="has_greenn_me">
                    {{ isHeaven ? 'Heaven' : 'Greenn' }} © {{ ano_atual }} -
                    {{ $t('checkout.footer.direitos_reservados_me') }}
                  </p>
                  <p class="p-footer" v-else>
                    {{ isHeaven ? 'Heaven' : 'Greenn' }} © {{ ano_atual }} -
                    {{ $t('checkout.footer.direitos_reservados') }}
                  </p>
                </div>
              </b-row>

              <!-- Confirmation -->
              <div v-if="charge_success">
                <div class="wrapper-box success">
                  <b-row class="justify-content-center my-5">
                    <div class="icon">
                      <font-awesome-icon icon="check" />
                    </div>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <h5 class="text-center">
                        {{ $t('checkout.sucesso_compra') }}
                      </h5>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <!-- Failed -->
              <div v-if="charge_error">
                <h5
                  v-if="
                    (product_type == 'COMMON' &&
                      product.status_product == 'APPROVED' &&
                      product.status_offer == 'APPROVED' &&
                      product.is_active === 1) ||
                      (product_type == 'PROPOSSAL' &&
                        product.product.status_product == 'APPROVED' &&
                        product.product.status_offer == 'APPROVED' &&
                        product.product.is_active === 1)
                  "
                >
                  {{ product.method === 'FREE' || !product.method ? '' : $t('checkout.erro_compra') }}
                </h5>
                <div class="wrapper-box failed">
                  <b-row class="justify-content-center my-5">
                    <div class="icon">
                      <font-awesome-icon icon="times" />
                    </div>
                  </b-row>
                  <h5 class="text-center">{{ error_message }}</h5>
                </div>
              </div>
            </b-overlay>
          </b-col>
          <!-- Product Card -->
          <b-col
            v-if="!charge_error && !charge_success && renderComponent"
            cols="12"
            md="4"
            order="1"
            order-md="2"
            class="mb-3 mb-md-0 p-md-0"
          >
            <div
              class="Product"
              :class="{ 'product-desktop': !isMobile }"
              data-anima="right"
            >
              <!-- Secure Purchase -->
              <div class="Product-header">
                <font-awesome-icon icon="shield-alt" class="mr-2" />
                {{ $t('order.text_header') }}
              </div>
              <div class="content-card" :hasCustomCharge="hasCustomCharges">
                <!-- Product Image -->
                <div v-if="product.images" class="imagem-produto" data-test="imgproduct">
                  <img
                    v-if="product.images.length"
                    :src="product.images[0].path"
                    alt="product-image"
                    class="product-img"
                  />
                  <div v-else class="product-img" data-test="imgproduct"></div>
                </div>
                <!-- Product Info -->
                <div class="info-card">
                  <!-- Info Sub -->
                  <p v-if="product.type == 'SUBSCRIPTION'" class="tipo-produto">
                    {{ $t('order.info_sub') }}
                  </p>
                  <!-- Name -->
                  <div class="Product-name_2" data-test="nameproduct">
                    {{ product.name }}
                  </div>
                  <!-- More Product Info Subscription -->
                  <div v-if="product.type === 'SUBSCRIPTION'" class="Product-price_2">
                    <!-- Free Trial -->
                    <div
                      v-if="product.trial"
                      data-test="priceproduct"
                      class="Product-price_2 free-trial business"
                    >
                      {{ $t('order.gratuito_por') }}
                      {{ product.trial }}
                      {{ $t('order.dias') }}
                    </div>
                    <!-- Showing Value Without Evaluation -->
                    <div
                      v-else-if="
                        !product.pre_selected_installment &&
                        !product.max_subscription_installments
                      "
                      class="Product-price_2"
                      data-test="priceproduct"
                    >
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(amount) }}
                      <div
                        v-if="product.type == 'SUBSCRIPTION'"
                        data-test="periodproduct"
                        class="Product-subscription-period"
                      >
                        {{ setPeriod }}
                      </div>
                    </div>
                    <!-- When method is BOLETO or OXXO or EFECTY or PIX -->
                    <section v-else-if="method === 'BOLETO' || method === 'OXXO' || method === 'EFECTY' || method === 'PIX'">
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(amount) }}
                    </section>
                    <!-- Price with Installments -->
                    <div
                      v-else
                      class="Product-price_2"
                      data-test="priceproduct"
                    >
                      <template v-if="installments === 1 && products_list.length === 1">
                        {{ filterCurrency(currency_id) }}
                        {{ formatMoney(getInstallments()) }}
                        {{ setPeriod }}
                      </template>  
                      <template v-else>  
                        {{ installments }}x {{ $t('order.de') }}
                        {{ filterCurrency(currency_id) }}
                        {{ formatMoney(getInstallments()) }}
                        {{ sem_juros ? '(Sem Juros)' : '' }}
                      </template>  
                    </div>
                    <section class="custom_charges" v-if="hasCustomCharges && !exceptionSellerId">
                      <section class="charges" :opened="opened">
                        <p v-for="charge in customCharges" :key="charge.id" class="w-100 d-flex justify-content-between">
                          <span>{{ charge.sequence }}ª {{ $t('checkout.different_amount_text.charge') }}</span>
                          <span>{{ filterCurrency() }} {{ formatMoney(charge.amount) }}</span>
                        </p>
                        <p class="w-100 d-flex justify-content-between">
                          <span class="text-wrap pr-1">{{ $t('checkout.different_amount_text.other_charges') }}</span>
                          <span class="text-nowrap">{{ filterCurrency() }} {{ formatMoney(product.amount) }}</span>
                        </p>
                      </section>
                      <button class="show-more" @click="opened = !opened">
                        {{ !opened ? $t('checkout.different_amount_text.show_more') : $t("checkout.pagamento.bump.hide") }}
                      </button>
                    </section>
                  </div>
                  <!-- More Product Info -->
                  <div v-else class="Product-price_2" data-test="priceproduct">
                    <div>
                      <template v-if="product.method === 'FREE'">
                        <span class="custom-free">{{ $t('order.gratis') }}</span>
                      </template>
                      <template v-else>
                        <div
                          v-if="
                            sem_parcela ||
                              method === 'PAYPAL' ||
                              method === 'OXXO' ||
                              method === 'EFECTY' ||
                              method === 'SENCILLITO' ||
                              method === 'SPEI' ||
                              method === 'SAFETYPAY-CASH'
                          "
                          data-test="installmentsproduct"
                        >
                          <small v-if="installments_boleto < 2" class="d-block small-text mb-1">
                            {{ $t('order.vc_pagara') }}
                          </small>
                          <!-- Original Amount -->
                          <small data-test="avistaproduct x" class="d-block small-text mb-1">
                            <span
                              v-if="original_amount && cupom_checkout && cupom_valid"
                              class="original-amount"
                            >
                              {{ filterCurrency(currency_id) }}
                              {{ formatMoney(original_amount) }}
                            </span>
                          </small>
                          <!-- Tiket Amount with Instellments -->
                          <div v-if="method == 'BOLETO' && permite_parcela_boleto > 1">
                            <span v-if="installments_boleto > 1">
                              {{ installments_boleto }}x {{ $t('order.de') }}
                            </span>
                            {{ filterCurrency(currency_id) }}
                            {{ formatMoney(getInstallments(installments_boleto)) }}

                            <small
                              v-if="installments_boleto > 1"
                              class="d-block small-text"
                            >
                              {{ $t('order.a_vista') }}
                              {{ filterCurrency(currency_id) }}
                              {{ formatMoney(amount) }}
                              <br
                                v-if="
                                  checkoutPayment &&
                                    checkoutPayment.price &&
                                    checkoutPayment.price.payable_tax
                                "
                              />
                              {{
                                checkoutPayment &&
                                checkoutPayment.price &&
                                checkoutPayment.price.payable_tax
                                  ? $t('order.impostos')
                                  : ''
                              }}
                            </small>
                          </div>
                          <!-- Amount with Shipping -->
                          <div v-else>
                            <span v-if="method !== 'PAYPAL' || !paypal">
                              {{ filterCurrency(currency_id) }}
                              {{
                                shipping.amount &&
                                product.format !== 'PHYSICALPRODUCT' &&
                                product.type_shipping_fee === 'DYNAMIC'
                                  ? formatMoney(amount + shipping.amount)
                                  : formatMoney(amount)
                              }}
                            </span>
                            <!-- Amount Paypal -->
                            <span v-else>
                              {{ paypal.symbol_currency }}
                              {{ formatMoney(paypal.amount) }}
                            </span>
                          </div>
                        </div>
                        <div v-else data-test="installmentsproduct">
                          <!-- Original Amount -->
                          <small data-test="avistaproduct xx" class="d-block small-text mb-1">
                            <span
                              v-if="original_amount && cupom_checkout && cupom_valid"
                              class="original-amount"
                            >
                              {{ filterCurrency(currency_id) }}
                              {{ formatMoney(original_amount) }}
                            </span>
                          </small>

                          {{ installments }}x {{ $t('order.de') }}
                          {{ filterCurrency(currency_id) }}
                          {{ formatMoney(getInstallments()) }}

                          {{ sem_juros ? '(Sem Juros)' : '' }}
                          <!-- À Vista -->
                          <small
                            v-if="
                              installments > 1 &&
                                parcela_fixa === null &&
                                !this.product.pre_selected_installment
                            "
                            data-test="avistaproduct xxx"
                            class="d-block small-text"
                          >
                            {{ $t('order.a_vista') }}
                            {{ filterCurrency(currency_id) }}
                            {{
                              shipping.amount &&
                              product.format !== 'PHYSICALPRODUCT' &&
                              product.type_shipping_fee === 'DYNAMIC'
                                ? formatMoney(amount + shipping.amount)
                                : formatMoney(amount)
                            }}
                            <br
                              v-if="
                                checkoutPayment &&
                                  checkoutPayment.price &&
                                  checkoutPayment.price.payable_tax
                              "
                            />
                            {{
                              checkoutPayment &&
                              checkoutPayment.price &&
                              checkoutPayment.price.payable_tax
                                ? $t('order.impostos')
                                : ''
                            }}
                            <br
                              v-if="
                                checkoutPayment &&
                                  checkoutPayment.price &&
                                  checkoutPayment.price.payable_tax
                              "
                            />
                          </small>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- More Product Info Subscription Mobile -->
              <div v-if="isMobile && product.type === 'SUBSCRIPTION'" class="mt-2 mx-4">
                <!-- Warranty Days -->
                <div
                  v-if="themeCheckout.warranty_checkout == 'on'"
                  class="item-info"
                >
                  <p data-test="warrantyproduct">
                    <span>{{ $t('order.garantia_label') }}: </span>
                    {{ product.warranty}}
                    {{ $t('order.dias_garantia') }}
                  </p>
                </div>
                <!-- Frete -->
                <div class="item-info" v-if="(is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'">
                  <div class="info-title">Frete</div>
                  <template v-if="products_list.length">
                    <section v-for="(item, index) in products_list" :key="index" class="shippingContent">
                      <span class="shippingRow" v-if="isPhysicalProduct(item.product_id, index === 0)">
                        <p class="mr-3">
                          {{ 
                            index === 0
                              ? product.name 
                              : bump_list.filter(prod => prod.id === item.product_id).pop().name 
                          }}
                        </p>
                        <p class="text-right" style="min-width:fit-content;">
                          {{ shippingAmountFormat(index, item) === 'Grátis' ||
                               shippingAmountFormat(index, item) === 'a calcular'
                                ? shippingAmountFormat(index, item)
                                : '+' + shippingAmountFormat(index, item)
                            }}
                        </p>
                      </span>
                    </section>
                  </template>
                  <p class="frete-amount" v-else>
                    {{ noShippingFee ? 'GRÁTIS para todo Brasil' : 'a calcular' }}
                  </p>
                </div>
                <!-- Order Bumps -->
                <div class="item-info" v-if="products_list.length > 1">
                  <div class="info-title">
                    Order Bumps
                  </div>
                  <div
                    class="d-flex justify-content-between mb-2"
                    v-for="(orderbump, index) in bump_list"
                    :key="'orderbump_'+index"
                  >
                    <template v-if="products_list.some(x => x.product_id === orderbump.id)">
                      <p class="mr-3">{{ orderbump.name }}</p>
                      <p class="text-right" style="min-width:fit-content;">
                        +{{ filterCurrency(currency_id) }}
                        {{ 
                          formatMoney(orderbump.custom_charges.length 
                            ? orderbump.custom_charges[0].amount 
                            : orderbump.amount) 
                        }}
                      </p>
                    </template>
                  </div>
                </div>
                <!-- Cupom -->
                <div class="item-info" v-if="cupom_checkout && amount_cupom && amount_cupom > 0">
                  <div class="info-title">
                    {{ $t('checkout.cupom.cupom') }}
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <p>{{ cupom_checkout.toUpperCase() }}</p>
                    <p>-{{ filterCurrency(currency_id) }} {{ formatMoney(amount_cupom) }}</p>
                  </div>
                </div>
                <!-- Country Fees -->
                <div class="item-info" v-if="typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0">
                  <div class="info-title">
                    {{ $t('order.country_taxs') }}
                  </div>
                  <div
                    class="d-flex justify-content-between mb-2"
                    v-for="(tax, index) in checkoutPayment.price.tax"
                    :key="'tax_'+index"
                  >
                    <p>{{ tax.description }}</p>
                    <p>+{{ filterCurrency(currency_id) }} {{ formatMoney(tax.local_amount) }}</p>
                  </div>
                </div>
                <!-- Total -->
                <div
                  v-if="
                    products_list.length > 1 ||
                    (cupom_checkout && amount_cupom && amount_cupom > 0) ||
                    (typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0)
                  "
                  class="item-info d-flex justify-content-between"
                >
                  <div class="info-title">
                    Total
                  </div>
                  <!-- Subscription -->
                  <template v-if="product.type == 'SUBSCRIPTION'">
                    <p v-if="method === 'BOLETO' || method === 'OXXO' || method === 'EFECTY' || method === 'PIX'" class="total-blue">
                      {{ filterCurrency(currency_id) }} {{ formatMoney(product.trial ? (amount - product.amount): amount) }}
                    </p>
                    <p v-else class="total-blue">
                      {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                    </p>
                  </template>
                  <!-- Transaction -->
                  <template v-else>
                    <template v-if="sem_parcela || method === 'PAYPAL' ||  method === 'OXXO' ||  method === 'EFECTY' || method === 'SENCILLITO' || method === 'SPEI' || method === 'SAFETYPAY-CASH'">
                      <template v-if="method == 'BOLETO' && permite_parcela_boleto > 1">
                        <p v-if="installments_boleto > 1" class="total-blue">
                          {{ installments_boleto }}x {{ $t('order.de') }}
                        </p>
                        {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments(installments_boleto)) }}
                      </template>
                      <template v-else>
                        <p v-if="method !== 'PAYPAL' || !paypal" class="total-blue">
                          {{ filterCurrency(currency_id) }}
                          {{
                            shipping.amount &&
                            product.format !== 'PHYSICALPRODUCT' &&
                            product.type_shipping_fee === 'DYNAMIC'
                              ? formatMoney(amount + shipping.amount)
                              : formatMoney(amount)
                          }}
                        </p>
                        <p v-else class="total-blue">
                          {{ paypal.symbol_currency }}
                          {{ formatMoney(paypal.amount) }}
                        </p>
                      </template>
                    </template>
                    <template v-else>
                      <p class="total-blue">
                        {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                      </p>
                    </template>
                  </template>
                </div>
                <!-- Author -->
                <div class="item-info">
                  <p v-if="product.seller" data-test="sellerproduct">
                    <span>{{ $t('order.autor_label') }}: </span>
                    {{
                      product.seller.company
                        ? product.seller.company.fantasy_name ||
                          product.seller.company.name
                        : product.seller.name
                    }}
                  </p>
                </div>
                <!-- E-mail -->
                <div class="item-info">
                  <p
                    v-if="
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.email
                    "
                    data-test="support_email"
                  >
                    <span>{{ $t('order.email_label') }}: </span>
                    {{ product.seller.company.email }}
                  </p>
                </div>
                <!-- Telephone -->
                <div class="item-info">
                  <p
                    v-if="
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.support_telephone
                    "
                    data-test="support_telephone"
                  >
                    <span>{{ $t('order.telefone_label') }}: </span>
                    <a :href="`tel:${product.seller.company.support_telephone}`">
                      {{ product.seller.company.support_telephone }}
                    </a>
                  </p>
                </div>
              </div>
              <!-- More Product Info Mobile -->
              <div v-if="isMobile && product.type !== 'SUBSCRIPTION'" class="mt-2 mx-4">
                <!-- Frete -->
                <div class="item-info" v-if="(is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'">
                  <div class="info-title">Frete</div>
                  <template v-if="products_list.length">
                    <section v-for="(item, index) in products_list" :key="index" class="shippingContent">
                      <span class="shippingRow" v-if="isPhysicalProduct(item.product_id, index === 0)">
                        <p class="mr-3">
                          {{ 
                            index === 0
                              ? product.name 
                              : bump_list.filter(prod => prod.id === item.product_id).pop().name 
                          }}
                        </p>
                        <p class="text-right" style="min-width:fit-content;">
                          {{ shippingAmountFormat(index, item) === 'Grátis' ||
                               shippingAmountFormat(index, item) === 'a calcular'
                                ? shippingAmountFormat(index, item)
                                : '+' + shippingAmountFormat(index, item)
                            }}
                        </p>
                      </span>
                    </section>
                  </template>
                  <p class="frete-amount" v-else>
                    {{ noShippingFee ? 'GRÁTIS para todo Brasil' : 'a calcular' }}
                  </p>
                </div>
                <!-- Warranty Days -->
                <div
                  v-if="themeCheckout.warranty_checkout == 'on'"
                  class="item-info"
                >
                  <p data-test="warrantyproduct">
                    <span>{{ $t('order.garantia_label') }}: </span>
                    {{ product.warranty }}
                    {{ $t('order.dias_garantia') }}
                  </p>
                </div>
                <!-- Order Bumps -->
                <div class="item-info" v-if="products_list.length > 1">
                  <div class="info-title">
                    Order Bumps
                  </div>
                  <div
                    class="d-flex justify-content-between mb-2"
                    v-for="(orderbump, index) in bump_list"
                    :key="'orderbump_'+index"
                  >
                    <template v-if="products_list.some(x => x.product_id === orderbump.id)">
                      <p class="mr-3">{{ orderbump.name }}</p>
                      <p class="text-right" style="min-width:fit-content;">
                        +{{ filterCurrency(currency_id) }}
                        {{ 
                          formatMoney(orderbump.custom_charges.length 
                            ? orderbump.custom_charges[0].amount 
                            : orderbump.amount) 
                        }}
                      </p>
                    </template>
                  </div>
                </div>
                <!-- Cupom -->
                <div class="item-info" v-if="cupom_checkout && amount_cupom && amount_cupom > 0">
                  <div class="info-title">
                    {{ $t('checkout.cupom.cupom') }}
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <p>{{ cupom_checkout.toUpperCase() }}</p>
                    <p>-{{ filterCurrency(currency_id) }} {{ formatMoney(amount_cupom) }}</p>
                  </div>
                </div>
                <!-- Country Fees -->
                <div class="item-info" v-if="typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0">
                  <div class="info-title">
                    {{ $t('order.country_taxs') }}
                  </div>
                  <div
                    class="d-flex justify-content-between mb-2"
                    v-for="(tax, index) in checkoutPayment.price.tax"
                    :key="'tax_'+index"
                  >
                    <p>{{ tax.description }}</p>
                    <p>+{{ filterCurrency(currency_id) }} {{ formatMoney(tax.local_amount) }}</p>
                  </div>
                </div>
                <!-- Total -->
                <div
                  v-if="
                    products_list.length > 1 ||
                    (cupom_checkout && amount_cupom && amount_cupom > 0) ||
                    (typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0)
                  "
                  class="item-info d-flex justify-content-between"
                >
                  <div class="info-title">
                    Total
                  </div>
                  <!-- Subscription -->
                  <template v-if="product.type == 'SUBSCRIPTION'">
                    <p v-if="method === 'BOLETO' || method === 'OXXO' || method === 'EFECTY' || method === 'PIX'" class="total-blue">
                      {{ filterCurrency(currency_id) }} {{ formatMoney(product.trial ? (amount - product.amount): amount) }}
                    </p>
                    <p v-else class="total-blue">
                      {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                    </p>
                  </template>
                  <!-- Transaction -->
                  <template v-else>
                    <template v-if="sem_parcela || method === 'PAYPAL' ||  method === 'OXXO' ||  method === 'EFECTY' || method === 'SENCILLITO' || method === 'SPEI' || method === 'SAFETYPAY-CASH'">
                      <template v-if="method == 'BOLETO' && permite_parcela_boleto > 1">
                        <p v-if="installments_boleto > 1" class="total-blue">
                          {{ installments_boleto }}x {{ $t('order.de') }}
                        </p>
                        {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments(installments_boleto)) }}
                      </template>
                      <template v-else>
                        <p v-if="method !== 'PAYPAL' || !paypal" class="total-blue">
                          {{ filterCurrency(currency_id) }}
                          {{
                            shipping.amount &&
                            product.format !== 'PHYSICALPRODUCT' &&
                            product.type_shipping_fee === 'DYNAMIC'
                              ? formatMoney(amount + shipping.amount)
                              : formatMoney(amount)
                          }}
                        </p>
                        <p v-else class="total-blue">
                          {{ paypal.symbol_currency }}
                          {{ formatMoney(paypal.amount) }}
                        </p>
                      </template>
                    </template>
                    <template v-else>
                      <p class="total-blue">
                        {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                      </p>
                    </template>
                  </template>
                </div>
                <!-- Author -->
                <div class="item-info">
                  <p v-if="product.seller" data-test="sellerproduct">
                    <span>{{ $t('order.autor_label') }}: </span>
                    {{
                      product.seller.company
                        ? product.seller.company.fantasy_name ||
                          product.seller.company.name
                        : product.seller.name
                    }}
                  </p>
                </div>
                <!-- E-mail -->
                <div class="item-info">
                  <p
                    v-if="
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.email
                    "
                    data-test="support_email"
                  >
                    <span>{{ $t('order.email_label') }}: </span>
                    {{ product.seller.company.email }}
                  </p>
                </div>
                <!-- Telephone -->
                <div class="item-info">
                  <p
                    v-if="
                      product.seller &&
                      product.seller.company &&
                      product.seller.company.support_telephone
                    "
                    data-test="support_telephone"
                  >
                    <span>{{ $t('order.telefone_label') }}: </span>
                    <a :href="`tel:${product.seller.company.support_telephone}`">
                      {{ product.seller.company.support_telephone }}
                    </a>
                  </p>
                </div>
              </div>
              <!-- Gift -->
              <div
                v-if="
                  product.type == 'TRANSACTION' &&
                  product.format == 'PHYSICALPRODUCT' &&
                  product.can_be_gifted
                "
                class="item-info gift-content"
              >
                <b-badge variant="info">
                  <b-form-checkbox
                    id="check-gift"
                    v-model="data.is_gift"
                    name="check-gift"
                  >
                    {{ $t('checkout.address.want_gift_someone') }} 🎁
                  </b-form-checkbox>
                </b-badge>
                <b-form-group v-if="data.is_gift" data-anima="top" class="mt-3">
                  <b-form-textarea
                    id="gift_message"
                    v-model="data.gift_message"
                    data-test="gift_message"
                    type="text"
                    name="gift_message"
                    placeholder="Escreva uma mensagem para quem receberá o presente"
                    :state="submit ? !errors.has('gift_message') : null"
                    v-validate="'required'"
                  ></b-form-textarea>

                  <b-form-invalid-feedback
                    :state="submit ? !errors.has('gift_message') : null"
                  >
                    {{ $t('checkout.dados_pessoais.feedbacks.gift_message') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <!-- Coupom Mobile -->
              <div
                v-if="permite_cupom && isMobile"
                class="item-info cupom-mobile"
              >
                <Cupom
                  :cupom_checkout="cupom_checkout"
                  :product_id="product.product_id || product.id"
                  :product_name="product.name"
                  :amount="product.amount"
                  :discountAmount="discount_amount"
                  :country="countryGlobal"
                  :countryGlobalSettings="countryGlobalSettings"
                  ref="Cupom"
                />
              </div>
              <div
                v-if="isMobile"
                class="item-info cupom-mobile"
              >
                <Cashback 
                  v-if="!isHeaven"
                  :hasCashback="product.cashback ? true : false"
                  :cashback="product.cashback"
                />
              </div>

              <b-row v-if="product.type === 'SUBSCRIPTION'" class="infos-mais">
                <!-- mostrando valor grifado (cupom) -->
                <b-col
                  cols="12"
                >
                  <!-- Recurring shipping -->
                  <section class="item-info my-2" v-if="this.data.has_shipping_fee && product.shipping_fee_is_recurring === 0">
                    <b-badge variant="info" class="text-wrap text-left">
                      {{ $t('checkout.recurring_shipping.isNotRecurring') }}
                    </b-badge>
                  </section>
                  <div>
                    <!-- Amount with Cupom -->
                    <span
                      v-if="original_amount && cupom_checkout && cupom_valid"
                      class="original-amount mb-2"
                    >
                      {{ filterCurrency(currency_id) }}
                      {{ formatMoney(original_amount) }}
                      <span>{{ setPeriod }}</span>
                    </span>

                    <!-- Trial -->
                    <div v-if="themeCheckout.trial_position != 'bottom'">
                      <b-badge
                        v-if="product.trial && !hasCustomCharges"
                        data-test="trialproduct"
                        variant="success"
                        class="Product-trial business"
                      >
                        {{ $t('order.apos_trial') }}
                        {{ product.trial }}
                        dias:
                        {{ calculateAmountAfterTrial() }}
                        <span>{{ setPeriod }}</span>
                      </b-badge>
                    </div>
                  </div>
                  <!-- More Product Info -->
                  <div v-if="!isMobile">
                    <!-- Frete -->
                    <div class="item-info" v-if="(is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'">
                      <div class="info-title">Frete</div>
                      <template v-if="products_list.length">
                        <section v-for="(item, index) in products_list" :key="index" class="shippingContent">
                          <span class="shippingRow" v-if="isPhysicalProduct(item.product_id, index === 0)">
                            <p class="mr-3">
                              {{ 
                                index === 0
                                  ? product.name 
                                  : bump_list.filter(prod => prod.id === item.product_id).pop().name 
                              }}
                            </p>
                            <p class="text-right" style="min-width:fit-content;">
                              {{ shippingAmountFormat(index, item) === 'Grátis' ||
                               shippingAmountFormat(index, item) === 'a calcular'
                                ? shippingAmountFormat(index, item)
                                : '+' + shippingAmountFormat(index, item)
                              }}
                            </p>
                          </span>
                        </section>
                      </template>
                      <p class="frete-amount" v-else>
                        {{ noShippingFee ? 'GRÁTIS para todo Brasil' : 'a calcular' }}
                      </p>
                    </div>
                    <!-- Warranty Days -->
                    <div
                      v-if="themeCheckout.warranty_checkout == 'on'"
                      class="item-info"
                    >
                      <div class="info-title">
                        {{ $t('order.garantia_label') }}
                      </div>
                      <p data-test="warrantyproduct">
                        {{ product.warranty }}
                        {{ $t('order.dias_garantia') }}
                      </p>
                    </div>
                    <!-- Order Bumps -->
                    <div class="item-info" v-if="products_list.length > 1">
                      <div class="info-title">
                        Order Bumps
                      </div>
                      <div
                        class="d-flex justify-content-between mb-2"
                        v-for="(orderbump, index) in bump_list"
                        :key="'orderbump_'+index"
                      >
                        <template v-if="products_list.some(x => x.product_id === orderbump.id)">
                          <p class="mr-3">{{ orderbump.name }}</p>
                          <p class="text-right" style="min-width:fit-content;">
                            +{{ filterCurrency(currency_id) }}
                            {{ 
                              formatMoney(orderbump.custom_charges.length 
                                ? orderbump.custom_charges[0].amount 
                                : orderbump.amount) 
                            }}
                          </p>
                        </template>
                      </div>
                    </div>
                    <!-- Cupom -->
                    <div class="item-info" v-if="cupom_checkout && amount_cupom && amount_cupom > 0">
                      <div class="info-title">
                        {{ $t('checkout.cupom.cupom') }}
                      </div>
                      <div class="d-flex justify-content-between mb-2">
                        <p>{{ cupom_checkout.toUpperCase() }}</p>
                        <p>-{{ filterCurrency(currency_id) }} {{ formatMoney(amount_cupom) }}</p>
                      </div>
                    </div>
                    <!-- Country Fees -->
                    <div class="item-info" v-if="typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0">
                      <div class="info-title">
                        {{ $t('order.country_taxs') }}
                      </div>
                      <div
                        class="d-flex justify-content-between mb-2"
                        v-for="(tax, index) in checkoutPayment.price.tax"
                        :key="'tax_'+index"
                      >
                        <p>{{ tax.description }}</p>
                        <p>+{{ filterCurrency(currency_id) }} {{ formatMoney(tax.local_amount) }}</p>
                      </div>
                    </div>
                    <!-- Total -->
                    <div
                      v-if="
                        products_list.length > 1 ||
                        (cupom_checkout && amount_cupom && amount_cupom > 0) ||
                        (typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0)
                      "
                      class="item-info d-flex justify-content-between"
                    >
                      <div class="info-title">
                        Total
                      </div>
                      <!-- Subscription -->
                      <template v-if="product.type == 'SUBSCRIPTION'">
                        <p v-if="method === 'BOLETO' || method === 'OXXO' || method === 'EFECTY' || method === 'PIX'" class="total-blue">
                          {{ filterCurrency(currency_id) }} {{ formatMoney(product.trial ? (amount - product.amount): amount) }}
                        </p>
                        <p v-else class="total-blue">
                          {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                        </p>
                      </template>
                      <!-- Transaction -->
                      <template v-else>
                        <template v-if="sem_parcela || method === 'PAYPAL' ||  method === 'OXXO' ||  method === 'EFECTY' || method === 'SENCILLITO' || method === 'SPEI' || method === 'SAFETYPAY-CASH'">
                          <template v-if="method == 'BOLETO' && permite_parcela_boleto > 1">
                            <p v-if="installments_boleto > 1" class="total-blue">
                              {{ installments_boleto }}x {{ $t('order.de') }}
                            </p>
                            {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments(installments_boleto)) }}
                          </template>
                          <template v-else>
                            <p v-if="method !== 'PAYPAL' || !paypal" class="total-blue">
                              {{ filterCurrency(currency_id) }}
                              {{
                                shipping.amount &&
                                product.format !== 'PHYSICALPRODUCT' &&
                                product.type_shipping_fee === 'DYNAMIC'
                                  ? formatMoney(amount + shipping.amount)
                                  : formatMoney(amount)
                              }}
                            </p>
                            <p v-else class="total-blue">
                              {{ paypal.symbol_currency }}
                              {{ formatMoney(paypal.amount) }}
                            </p>
                          </template>
                        </template>
                        <template v-else>
                          <p class="total-blue">
                            {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                          </p>
                        </template>
                      </template>
                    </div>
                    <!-- Author -->
                    <div class="item-info">
                      <div class="info-title">
                        {{ $t('order.autor_label') }}
                      </div>
                      <p v-if="product.seller" data-test="sellerproduct">
                        {{
                          product.seller.company
                            ? product.seller.company.fantasy_name ||
                              product.seller.company.name
                            : product.seller.name
                        }}
                      </p>
                    </div>
                    <!-- E-mail -->
                    <div class="item-info">
                      <div
                        v-if="
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.email
                        "
                        class="info-title"
                      >
                        {{ $t('order.email_label') }}
                      </div>
                      <p
                        v-if="
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.email
                        "
                        data-test="support_email"
                      >
                        {{ product.seller.company.email }}
                      </p>
                    </div>
                    <!-- Telephone -->
                    <div class="item-info">
                      <div
                        v-if="
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.support_telephone
                        "
                        class="info-title"
                      >
                        {{ $t('order.telefone_label') }}
                      </div>
                      <p
                        v-if="
                          product.seller &&
                          product.seller.company &&
                          product.seller.company.support_telephone
                        "
                        data-test="support_telephone"
                      >
                        <a :href="`tel:${product.seller.company.support_telephone}`">
                          {{ product.seller.company.support_telephone }}
                        </a>
                      </p>
                    </div>
                    <!-- Cupom -->
                    <div v-show="permite_cupom" class="item-info">
                      <Cupom
                        :cupom_checkout="cupom_checkout"
                        :product_id="product.product_id || product.id"
                        :product_name="product.name"
                        :amount="product.amount"
                        :discountAmount="discount_amount"
                        :country="countryGlobal"
                        :countryGlobalSettings="countryGlobalSettings"
                        ref="Cupom"
                      />
                      <Cashback
                        v-if="!isHeaven"
                        :hasCashback="product.cashback ? true : false"
                        :cashback="product.cashback"
                      />
                    </div>
                  </div>
                </b-col>
              </b-row>

              <b-row v-else class="infos-mais">
                <b-col cols="12" v-if="!isMobile">
                  <section class="item-info my-2" v-if="this.data.has_shipping_fee && product.shipping_fee_is_recurring === 0">
                    <b-badge variant="info" class="text-wrap text-left">
                      {{ $t('checkout.recurring_shipping.isNotRecurring') }}
                    </b-badge>
                  </section>
                  <!-- Frete -->
                  <div class="item-info" v-if="(is_produto_fisico || hasPhysicalProduct) && product.method !== 'FREE'">
                    <div class="info-title">Frete</div>
                    <template v-if="products_list.length">
                      <section v-for="(item, index) in products_list" :key="index" class="shippingContent">
                        <span class="shippingRow" v-if="isPhysicalProduct(item.product_id, index === 0)">
                          <p class="mr-3">
                            {{ 
                              index === 0
                                ? product.name 
                                : bump_list.filter(prod => prod.id === item.product_id).pop().name 
                            }}
                          </p>
                          <p class="text-right" style="min-width:fit-content;">
                            {{ shippingAmountFormat(index, item) === 'Grátis' ||
                               shippingAmountFormat(index, item) === 'a calcular'
                                ? shippingAmountFormat(index, item)
                                : '+' + shippingAmountFormat(index, item)
                            }}
                          </p>
                        </span>
                      </section>
                    </template>
                    <p class="frete-amount" v-else>
                      {{ noShippingFee ? 'GRÁTIS para todo Brasil' : 'a calcular' }}
                    </p>
                  </div>
                  <!-- Warranty Days -->
                  <div
                    v-if="themeCheckout.warranty_checkout == 'on'"
                    class="item-info"
                  >
                    <div class="info-title">
                      {{ $t('order.garantia_label') }}
                    </div>
                    <p data-test="warrantyproduct">
                      {{ product.warranty }}
                      {{ $t('order.dias_garantia') }}
                    </p>
                  </div>
                  <!-- Order Bumps -->
                  <div class="item-info" v-if="products_list.length > 1">
                    <div class="info-title">
                      Order Bumps
                    </div>
                    <div
                      class="d-flex justify-content-between mb-2"
                      v-for="(orderbump, index) in bump_list"
                      :key="'orderbump_'+index"
                    >
                      <template v-if="products_list.some(x => x.product_id === orderbump.id)">
                        <p class="mr-3">{{ orderbump.name }}</p>
                        <p class="text-right" style="min-width:fit-content;">
                          +{{ filterCurrency(currency_id) }}
                          {{ 
                            formatMoney(orderbump.custom_charges.length 
                              ? orderbump.custom_charges[0].amount 
                              : orderbump.amount) 
                          }}
                        </p>
                      </template>
                    </div>
                  </div>
                  <!-- Cupom -->
                  <div class="item-info" v-if="cupom_checkout && amount_cupom && amount_cupom > 0">
                    <div class="info-title">
                      {{ $t('checkout.cupom.cupom') }}
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                      <p>{{ cupom_checkout.toUpperCase() }}</p>
                      <p>-{{ filterCurrency(currency_id) }} {{ formatMoney(amount_cupom) }}</p>
                    </div>
                  </div>
                  <!-- Country Fees -->
                  <div class="item-info" v-if="typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0">
                    <div class="info-title">
                      {{ $t('order.country_taxs') }}
                    </div>
                    <div
                      class="d-flex justify-content-between mb-2"
                      v-for="(tax, index) in checkoutPayment.price.tax"
                      :key="'tax_'+index"
                    >
                      <p>{{ tax.description }}</p>
                      <p>+{{ filterCurrency(currency_id) }} {{ formatMoney(tax.local_amount) }}</p>
                    </div>
                  </div>
                  <!-- Total -->
                  <div
                    v-if="
                      products_list.length > 1 ||
                      (cupom_checkout && amount_cupom && amount_cupom > 0) ||
                      (typeof checkoutPayment.price === 'object' && checkoutPayment.price.tax.length > 0)
                    "
                    class="item-info d-flex justify-content-between"
                  >
                    <div class="info-title">
                      Total
                    </div>
                    <!-- Subscription -->
                    <template v-if="product.type == 'SUBSCRIPTION'">
                      <p v-if="method === 'BOLETO' || method === 'OXXO' || method === 'EFECTY' || method === 'PIX'" class="total-blue">
                        {{ filterCurrency(currency_id) }} {{ formatMoney(product.trial ? (amount - product.amount): amount) }}
                      </p>
                      <p v-else class="total-blue">
                        {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                      </p>
                    </template>
                    <!-- Transaction -->
                    <template v-else>
                      <template v-if="sem_parcela || method === 'PAYPAL' ||  method === 'OXXO' ||  method === 'EFECTY' || method === 'SENCILLITO' || method === 'SPEI' || method === 'SAFETYPAY-CASH'">
                        <template v-if="method == 'BOLETO' && permite_parcela_boleto > 1">
                          <p v-if="installments_boleto > 1" class="total-blue">
                            {{ installments_boleto }}x {{ $t('order.de') }}
                          </p>
                          {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments(installments_boleto)) }}
                        </template>
                        <template v-else>
                          <p v-if="method !== 'PAYPAL' || !paypal" class="total-blue">
                            {{ filterCurrency(currency_id) }}
                            {{
                              shipping.amount &&
                              product.format !== 'PHYSICALPRODUCT' &&
                              product.type_shipping_fee === 'DYNAMIC'
                                ? formatMoney(amount + shipping.amount)
                                : formatMoney(amount)
                            }}
                          </p>
                          <p v-else class="total-blue">
                            {{ paypal.symbol_currency }}
                            {{ formatMoney(paypal.amount) }}
                          </p>
                        </template>
                      </template>
                      <template v-else>
                        <p class="total-blue">
                          {{ installments }}x {{ $t('order.de') }} {{ filterCurrency(currency_id) }} {{ formatMoney(getInstallments()) }}
                        </p>
                      </template>
                    </template>
                  </div>
                  <!-- Author -->
                  <div class="item-info">
                    <div class="info-title">{{ $t('order.autor_label') }}</div>
                    <p v-if="product.seller" data-test="sellerproduct">
                      {{
                        product.seller.company
                          ? product.seller.company.fantasy_name ||
                            product.seller.company.name
                          : product.seller.name
                      }}
                    </p>
                  </div>
                  <!-- E-mail -->
                  <div class="item-info">
                    <div
                      v-if="
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.email
                      "
                      class="info-title"
                    >
                      {{ $t('order.email_label') }}
                    </div>
                    <p
                      v-if="
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.email
                      "
                      data-test="support_email"
                    >
                      {{ product.seller.company.email }}
                    </p>
                  </div>
                  <!-- Telephone -->
                  <div class="item-info">
                    <div
                      v-if="
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.support_telephone
                      "
                      class="info-title"
                    >
                      {{ $t('order.telefone_label') }}
                    </div>
                    <p
                      v-if="
                        product.seller &&
                        product.seller.company &&
                        product.seller.company.support_telephone
                      "
                      data-test="support_telephone"
                    >
                      <a :href="`tel:${product.seller.company.support_telephone}`">
                        {{ product.seller.company.support_telephone }}
                      </a>
                    </p>
                  </div>
                  <!-- Coupom -->
                  <div v-if="permite_cupom" class="item-info">
                    <Cupom
                      :cupom_checkout="cupom_checkout"
                      :product_id="product.product_id || product.id"
                      :product_name="product.name"
                      :amount="product.amount"
                      :discountAmount="discount_amount"
                      :country="countryGlobal"
                      :countryGlobalSettings="countryGlobalSettings"
                      ref="Cupom"
                    />
                  </div>
                  <Cashback
                    v-if="!isHeaven"
                    :hasCashback="product.cashback ? true : false"
                    :cashback="product.cashback"
                  />
                </b-col>
              </b-row>
            </div>
            <!-- Banner -->
            <template v-if="themeCheckout.side_thumb && !isMobile">
              <div class="container banner-container container-banner-side">
                <img
                  :src="themeCheckout.side_thumb"
                  alt="side-thumb"
                  class="banner"
                />
              </div>
            </template>
            <!-- Banner Mobile -->
            <template v-if="themeCheckout.side_thumb_mobile && isMobile">
              <div class="container banner-container container-banner-side">
                <img
                  :src="themeCheckout.side_thumb_mobile"
                  alt="side-thumb-mobile"
                  class="banner"
                />
              </div>
            </template>
          </b-col>

          <b-col v-if="isMobile && !charge_error" class="etapas" order="2">
            <p></p>
            <p>
              <span
                v-for="(etapa, index) in etapa_total"
                :key="etapa"
                class="icon-etapa"
                :class="{ target: index == 0 }"
              ></span>
            </p>
          </b-col>
        </b-row>
        <Alert
          :product_name="product.name"
          :message_error="error_message"
          :has_code="has_code"
        />
        <!-- WhatsApp -->
        <a
          v-if="
            themeCheckout.whatsapp_button &&
              themeCheckout.whatsapp_number &&
              themeCheckout.whatsapp_number != ''
          "
          :href="
            'https://wa.me/' +
              wpp_number +
              '?text=' +
              themeCheckout.whatsapp_msg.replace(' ', '%20')
          "
          class="btn-wpp"
          target="_blank"
          :style="
            themeCheckout.jivochat_id
              ? 'bottom: 110px; right: 23px !important;'
              : ''
          "
        >
          <img src="@/assets/img/icon/whatsapp.png" height="40" width="40" />
        </a>
      </b-container>
    </div>
  </div>
</template>

<script>

import VuePhoneNumberInput from 'vue-phone-number-input';
import Cashback from '@/components/Checkout/Cashback';
import Navbar from '@/components/navbar/index.vue';
import PaymentService from '@/services/resources/PaymentService';
import GatewayService from '@/services/resources/GatewayService';
import ProductService from '@/services/resources/ProductService';
import CheckoutService from '@/services/resources/CheckoutService';
import UserSettingsService from '@/services/resources/UserSettingsService';
import GlobalSettingsService from '@/services/resources/GlobalSettingsService';
import ClientStatisticsService from '@/services/resources/ClientStatisticsService';
import LeadService from '@/services/resources/LeadService';
import ShippingService from '@/services/resources/ShippingService';
import ProposalService from '@/services/resources/ProposalService';
import Card from '@/components/Checkout/Card';
import Escassez from '@/components/Checkout/Escassez';
import axios from 'axios';
import Cookies from 'js-cookie';
import pagarme from '@/assets/js/pagarme.min';
import UAParser from 'ua-parser-js';
import Money from '@/mixins/money';
import Alert from '@/components/Alert';
import Locales from '@/components/Locales';
import Cupom from '@/components/Checkout/Cupom';
import OrderBumpCard from '@/components/Checkout/OrderBumpCard';
import Oxxo from '@/components/Checkout/paymentMethods/Oxxo.vue'
import Efecty from '@/components/Checkout/paymentMethods/Efecty.vue'
import SafetypayCash from '@/components/Checkout/paymentMethods/SafetypayCash.vue'
import { EventBus } from '@/main.js';
import Vue from 'vue';
import InfoPix from '@/components/Checkout/InfoPix';
import { symbolCurrency } from '@/utils/currency.js';
import { sanitizeUrl } from '@/utils/url.js';
import Captcha from '@/components/security/Captcha.vue';
import { GreennLogs } from '@/services/resources/GreennLogs.js';
import { districtOptions } from '@/utils/districtOptions.js'
import Multiselect from 'vue-multiselect'
import GatewayHashService from '@/services/resources/GatewayHashService';

const serviceGateway = GatewayService.build();
const servicePayment = PaymentService.build();
const serviceProduct = ProductService.build();
const serviceCheckout = CheckoutService.build();
const serviceSettings = UserSettingsService.build();
const serviceGlobalSettings = GlobalSettingsService.build();
const serviceClientStatistics = ClientStatisticsService.build();
const serviceLead = LeadService.build();
const serviceShipping = ShippingService.build();
const serviceProposal = ProposalService.build();
const serviceGatewayHash = GatewayHashService.build();

export default {
  components: {
    Card,
    Navbar,
    Alert,
    Locales,
    VuePhoneNumberInput,
    Cupom,
    Escassez,
    InfoPix,
    Captcha,
    OrderBumpCard,
    Oxxo,
    Efecty,
    SafetypayCash,
    Multiselect,
    Cashback
  },

  data() {
    return {
      countries_obrigatory_document: ['BR', 'CL', 'MX'],
      hard_loading: false,
      captcha: false,
      captcha_code: '',
      amount_cupom: 0,
      bank_type: '',
      external_banks: [],
      address_step: false,
      affiliate: null,
      affiliate_id: null,
      amexCardMask: '#### ###### #####',
      amount_cards: {
        card_1: 0,
        card_2: 0,
      },
      boleto_barcode: null,
      boleto_url: null,
      b_offer: null,
      btn_paypal: false,
      bump: null,
      bump_list: [],
      bump_descriptions: [],
      business: false,
      buy_button_text: 'Comprar agora',
      capture: {
        product_id: null,
        proposal_id: null,
        seller_id: null,
        affiliate_id: null,
        name: null,
        email: null,
        cpf: null,
        cellphone: null,
        zip_code: null,
        street: null,
        number: null,
        neighborhood: null,
        city: null,
        state: null,
        step: null,
        uuid: null,
      },
      card_number_error: false,
      charge_success: false,
      charge_error: false,
      checkoutPayment: [],
      client: {
        width: 0,
      },
      client_statistics: [],
      country_code: 'BR',
      countryGlobal: 'BR',
      countryGlobalSettings: 'BR',
      cupom_checkout: '',
      cupom_valid: false,
      currency: 'BRL',
      currency_id: 1,
      custom_bump: null,
      data: {
        name: '',
        email: '',
        confirmation_email: '',
        cellphone: '',
        document: '',
        cards: [
          {
            amount: '',
            number: '',
            holder_name: '',
            valid: '',
            year: '',
            month: '',
            cvv: '',
          },
        ],
        zipcode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        bump: false,
        gift_message: '',
        is_gift: false,
        billing_shipping_same_address: false,
        has_shipping_fee: false,
        gateway: null
      },
      dataLog: {},
      debounce: null,
      debugPixel: false,
      defaultCountry: '',
      document: null,
      error_message: '',
      errorPhone: false,
      escassez: null,
      pop_modal: {
        active: false,
        data:null
      },
      etapa_atual: 1,
      etapa_total: 2,
      forceUrl: false,
      foreign: false,
      has_code: false,
      has_greenn_me: false,
      includeBump: false,
      installments: 1,
      installments_boleto: 1,
      last_step: false,
      loading: false,
      loading_frete: false,
      is_antifraude: false,
      is_produto_fisico: false,
      isBr: true,
      metas: null,
      method: '',
      method_pix: false,
      minCardYear: new Date().getFullYear(),
      monthly_interest: 0,
      no_bump: false,
      notifications: [],
      options_shipping: [],
      original_amount: 0,
      otherCardMask: '#### #### #### ####',
      page_thanks_response: '',
      parcela_fixa: null,
      paypal: {
        original_amount: 0,
        amount: 0,
        currency: 'BRL',
        symbol_currency: 'R$',
      },
      resultPaypal: null,
      paypal_true: false,
      permite_cupom: 1,
      permite_parcela_assinatura: 0,
      permite_parcela_boleto: 0,
      possui_endereco: false,
      preload: false,
      price: 0,
      product: {
        images: [{ path: '' }],
        name: '',
        description: '',
        affiliation_lead: '',
        seller: {
          company: {
            name: '',
          },
          name: '',
        },
        method: '',
        status: '',
      },
      product_type: 'COMMON',
      products_client_statistics: [],
      products_list: [],
      queryUrl: {
        fn: null,
        document: null,
        ph: null,
        em: null,
      },
      rate: {
        target_currency: '',
        base_currency: '',
        token: '',
      },
      renderComponent: true,
      sem_juros: 0,
      sem_parcela: false,
      shipping: {
        address: {
          zipcode: '',
          street: '',
          number: '',
          complement: '',
          neighborhood: '',
          city: '',
          state: '',
        },
        service_name: '',
        service_id: '',
        amount: 0,
        old_amount: 0,
        frete: null,
        frete_anterior: null,
      },
      submit: false,
      themeCheckout: {
        theme: null,
        theme_color: null,
        top_thumb: null,
        bottom_thumb: null,
        side_thumb: null,
        side_thumb_mobile: null,
        logotipo: null,
        theme_color_bg: null,
        whatsapp_number: '',
        whatsapp_button: null,
        whatsapp_msg: '',
      },
      upsell_id: undefined,
      uuid: this.$uuid.v4(),
      valid_document_es: false,
      wpp: false,
      wpp_number: '',
      confirmation_email: false,
      allowed_methods: null,
      tabs_controller: 0,
      opened: false,
      discount_amount: 0,
      // telephone
      yourValue: this.$route.query.ph ?? null,
      results_tel: {
        valid: false,
      },
      results_country: {
        valid: false,
      },
      translations_pt: {
        countrySelectorLabel: 'Código do país',
        countrySelectorError: 'Escolha um país',
        phoneNumberLabel: 'Número de Telefone',
        example: 'Exemplo: ',
      },
      translations_en: {
        countrySelectorLabel: 'Country code',
        countrySelectorError: 'Choose a country',
        phoneNumberLabel: 'Phone number',
        example: 'Example: ',
      },
      allow_free_offers : null,
      // Variable to save mercado pago methods
      mp: null,
    }
  },
  mixins: [Money],
  computed: {
    exceptionSellerId() {
      if(process.env.CUSTOM_CHARGES_EXCEPTION) {
        const ids = JSON.parse(process.env.CUSTOM_CHARGES_EXCEPTION)
        return ids.some(x => parseInt(x) === parseInt(this.product.seller.id))
      }
      return false
    },
    sessionId() {
      return this.uuid;
    },
    countryFlags() {
      return this.$store.getters["getCountryFlags"]
    },
    hasOnlyPaypalMethod() {
      let res = false;
      const methods = this.product.method.split(',');
      if (methods.length === 1 && methods[0] === 'PAYPAL') {
        res = true;
      }
      return res;
    },
    setPeriod() {
      const type = this.product_type;
      let periodo = 0;

      let texto = '';
      if (type == 'COMMON') periodo = this.product.period;
      else if (type == 'PROPOSAL') periodo = this.product.product.period;

      switch (periodo) {
        case 30:
          texto = this.$t('order.por_mes');
          break;
        case 90:
          texto = this.$t('order.por_trimestre');
          break;
        case 180:
          texto = this.$t('order.por_semestre');
          break;
        case 365:
          texto = this.$t('order.por_ano');
          break;
        default:
          if (periodo > 365) {
            texto = `/ ${Math.floor(periodo / 365)} ${this.$t('order.anos')}`;
          } else {
            texto = `/ ${periodo} ${this.$t('order.dias')}`;
          }
          break;
      }

      return texto;
    },
    ano_atual() {
      return new Date().getFullYear();
    },
    generateCardNumberMask() {
      return this.getCardType === 'amex'
        ? this.amexCardMask
        : this.otherCardMask;
    },
    minCardMonth() {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    },
    isMobile() {
      return this.client.width <= 769;
    },
    amount: {
      get() {
        return this.price;
      },
      set(value) {
        this.price = value;
      },
    },
    confirmed_email() {
      if (
        this.data.email &&
        this.data.email.length &&
        this.data.confirmation_email.length
      ) {
        return this.data.confirmation_email == this.data.email;
      }
      return this.submit ? false : null;
    },
    hasBumpSelected() {
      let res = false;
      if (
        this.bump_list.length > 0 &&
        this.bump_list.filter((b) => b.checkbox).length > 0
      ) {
        res = true;
      }
      return res;
    },
    hasPhysicalProduct() {
      return this.bump_list.some(bump => bump.format === 'PHYSICALPRODUCT' && bump.checkbox)
    },
    hasSubscriptionBump() {
      return (this.product.type === 'SUBSCRIPTION' && this.bump_list.some(bump => bump.checkbox)) || this.bump_list.some(bump => bump.type === 'SUBSCRIPTION' && bump.checkbox)
    },
    hasFreeBump() {
      return this.bump_list.every(bump => bump.method === 'FREE')
    },
    noShippingFee() {
      return !this.data.has_shipping_fee && this.bump_list.some(bump => !bump.has_shipping_fee && bump.checkbox)
    },
    isFixedShipping() {
      return this.product.type_shipping_fee === 'FIXED'
    },
    valueOfSelectedBumps() {
      return this.bump_list.reduce((accumulator, currentValue) => accumulator + currentValue.amount, 0)
    },
    /** 
     * @description this function returns the total value of all signature-type bumps that are marked
     */
    totalBumpSubscription(){
      let amount = 0;
      this.bump_list.forEach((item) => {
        if (!item.checkbox) return;
        let product = this.products_list.filter(prod => item.id === prod.product_id).pop();
        if (item.type === 'SUBSCRIPTION' && item.checkbox) amount += item.amount
        if (product?.shipping_amount) amount += parseFloat(product.shipping_amount)
      })
      return parseFloat(amount.toFixed(2));
    },
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    },
    /**
     * @returns this method returns if product has custom charges
     */
    hasCustomCharges() {
      if (this.product.custom_charges) return !!this.product.custom_charges.length
      return false;
    },
    /**
     * @returns this method returns product custom charges
     */
    customCharges() {
      if (!this.hasCustomCharges) return null;
      return this.product.custom_charges;
    },
    currentCountryCoin() {
      return this.checkoutPayment.data.to;
    }
  },
  watch: {
    'data.cards': {
      deep: true,
      handler() {
        for (let i = 0; i < this.data.cards.length; i++) {
          try {
            if(this.data.cards[i]?.amount){
              let fixedAmount = this.data.cards[i]?.amount.toString().replace(/[^\d,-]/g, '').replace(',', '.').replace('.', '');
              this.data.cards[i].total = (fixedAmount / 100).toFixed(2);
            }
          } catch (error) {
            console.error('Error parsing card total', error);
          }
        }
      }
    },
    results_tel(event) {
      // this.$refs.telinput.$refs.CountrySelector.$listeners.input(event.countryCode);
      this.defaultCountry = event.countryCode;
      this.foreign = event.countryCode !== 'BR';

      if (event.countryCode !== 'BR') this.errorPhone = false;
    },
    yourValue() {
      this.debounceSave();
    },
    checkoutPayment(data) {
      this.checkoutPayment = data;
      this.forceRerender();
      if (
        this.checkoutPayment.base_currency !== 'BRL' &&
        this.findCountryInstallments()
      ) {
        this.installments = 1;
        this.parcela_fixa = null;
      }
    },
    countryGlobal() {
      this.country_code = this.countryGlobal;
      if (
        this.checkoutPayment.base_currency !== 'BRL' &&
        this.findCountryInstallments()
      ) {
        this.installments = 1;
        this.parcela_fixa = null;
      }
    },
    parcela_fixa() {
      if (
        this.checkoutPayment.base_currency !== 'BRL' &&
        this.findCountryInstallments()
      ) {
        this.parcela_fixa = null;
      }
    },
    installments() {
      if (
        this.checkoutPayment.base_currency !== 'BRL' &&
        this.findCountryInstallments()
      ) {
        this.installments = 1;
      }
    },
    products_list() {
      if (this.products_list.length > 1 && this.method === 'PAYPAL') {
        if (this.product.method.search(',') === -1) {
          this.clickTab(this.product.method);
          document
            .getElementById(this.product.method + '___BV_tab_button__')
            .click();
        } else {
          this.clickTab(this.product.method.split(',')[0]);
          document
            .getElementById(
              this.product.method.split(',')[0] + '___BV_tab_button__'
            )
            .click();
        }
      } else if (document.getElementById(this.method + '___BV_tab_button__')) {
        this.clickTab(this.method);
        document.getElementById(this.method + '___BV_tab_button__').click();
      }
    },
    hasBumpSelected(val) {
      if (val) {
        this.hidePaypal();
      }
    },
    allowed_methods(methods) {
      if (methods.includes(this.method)) {
        this.showBtn(this.method)
      } else {
        this.showBtn(methods.split(",")[0])
      }
      setTimeout(() => {
        const tabs = document.querySelectorAll('.tab-nav-icon');
        tabs.forEach((item, index) => {
          if (item.id.includes(this.method)) {
            this.tabs_controller = index;
          }
        });
      }, 10)
    },
  },
  methods: {
    handleMouseOut(event){
      let is_seen = Cookies.get(`pop_modal_${this.$route.params.product}`) ? true : false;

      if(!is_seen && this.pop_modal && this.pop_modal.data && this.pop_modal.data.is_on === "on"){
        if (
          event.clientY <= 0 ||
          event.clientX <= 0 ||
          event.clientX >= window.innerWidth ||
          event.clientY >= window.innerHeight
        ) {
          this.pop_modal.active = true;

          Cookies.set(`pop_modal_${this.$route.params.product}`, false, {
            expires: 7,
            path: "/",
          });
        }
      }
    },
    handleTouchEnd(event) {
      let isSeen = Cookies.get(`pop_modal_${this.$route.params.product}`) ? true : false;

      if (!isSeen && this.pop_modal && this.pop_modal.data && this.pop_modal.data.is_on === "on") {
        const touch = event.changedTouches[0];
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
      
        if (
          touch.clientY <= 0 ||
          touch.clientX <= 0 ||
          touch.clientX >= windowWidth ||
          touch.clientY >= windowHeight
        ) {
          this.pop_modal.active = true;
        
          Cookies.set(`pop_modal_${this.$route.params.product}`, false, {
            expires: 7,
            path: "/",
          });
        }
      }
    },
    closePopModal(){
      this.pop_modal.active = false;
    },
    redirectOfferPanel(currentCountry) {
      if (this.product && this.product.seller.is_heaven && this.product.seller.is_greenn && this.product.offer_redirect) {
        const urlAtual = new URL(window.location.href);
        const parametros = `/${this.product.offer_redirect.product_id}/offer/${this.product.offer_redirect.hash}`;
        const queries = urlAtual.search + "&country=" + currentCountry;

        if (this.product.offer_redirect_id) {
          if(currentCountry != 'BR' && !this.product.is_heaven && urlAtual.origin === process.env.VUE_CHECKOUT_PAGE) {
            const novaRota = process.env.VUE_CHECKOUT_HEAVEN_PAGE;
            const novaUrl = `${novaRota}${parametros}${queries}`;
            window.location.href = novaUrl;
          }

          if(currentCountry == 'BR' && this.product.is_heaven && urlAtual.origin === process.env.VUE_CHECKOUT_HEAVEN_PAGE) {
            const novaRota = process.env.VUE_CHECKOUT_PAGE_FAST;
            const novaUrl = `${novaRota}${parametros}${queries}`;
            window.location.href = novaUrl;
          }
        }
      }
    },
    async processPaypal() {
      let product_id, amount, bump_amount
      amount = this.product.amount
      product_id = this.product.id
      if(this.data.bump) bump_amount = this.bump.amount

      let response = await this.paymentPayPal(
        this.product_type,
        product_id,
        amount,
        bump_amount,
        this.resultPaypal
      )

      let sales = Array.isArray(response) ? response : response.sales

      if(sales.length) {
        this.loading = false
        this.preload = false
        if((sales[0].success && !sales[0].code) || sales[0].status == 'delayed') {
          Cookies.remove('affiliate_' + product_id);
          let query = {
            s_id: sales[0].status == 'delayed' ? 'delayed' : sales[0].sale_id
          }
          if(sales[0].token) {
            query.token = sales[0].token;
          }
          if(this.vtk89(sales[0].token)) {
            query = Object.assign(this.$route.query, query);
            this.formatPageThankYou(sales);

            let chc = '';
            if(sales && sales.length && sales[0].chc) chc = '?chc=' + sales[0].chc
            
            if(this.$route.params.hash) query.offer = this.$route.params.hash
            this.$router.push({
              path: `/${this.product.id}/obrigado` + chc,
              query: query,
              params: {
                id_product: this.product.id,
                name_product: this.product.name,
                valor: this.amount,
                trial:
                  this.product_type == 'COMMON'
                    ? this.product.trial
                    : this.product.product.trial,
                thank_you_page:
                  sales[0].product.custom_thank_you_page ||
                  this.page_thanks_response,
                isCheckout: true,
                methodCheckout: 'PAYPAL',
                // response
                dados_response: response,
              },
            });
          }
        } else this.paymentError(sales[0]);
      } else if (response.reason) this.r3t();
      else this.paymentError(sales);
    },
    changeVerify(e, fromPaypal = false) {
      this.captcha_code = e;
      if (!fromPaypal) this.onSubmit('get');
      if(this.resultPaypal) this.processPaypal();
    },
    addSignifydSnippet() {
      let signifySnippet = document.createElement('script');
      signifySnippet.setAttribute(
        'src',
        'https://cdn-scripts.signifyd.com/api/script-tag.js'
      );
      signifySnippet.setAttribute('data-order-session-id', this.uuid);
      signifySnippet.setAttribute('id', 'sig-api');
      signifySnippet.setAttribute('type', 'text/javascript');
      signifySnippet.setAttribute('defer', true);
      document.head.appendChild(signifySnippet);
    },
    countryPhone() {
      if (this.countryGlobal === 'UK') {
        return 'GB';
      }
      return this.countryGlobal;
    },
    findCountryInstallments() {
      var siglas = ['US', 'PT', 'ES', 'FR', 'IT', 'JP', 'MY', 'UK','DE'];
      return siglas.find((x) => x === this.countryGlobal);
    },
    getIndexInstallments(e) {
      if(this.countryGlobal === 'MX' || this.countryGlobal === 'CO' || this.countryGlobal === 'PE' || this.countryGlobal === 'CL' || this.countryGlobal === 'UY') {
        if(e === 1 || e === 3 || e === 6 || e === 9 || e === 12) return true;
        else return false;
      } else if(this.countryGlobal === 'ES' || this.countryGlobal === 'FR' || this.countryGlobal === 'IT' || this.countryGlobal === 'JP' || this.countryGlobal === 'MY' || this.countryGlobal === 'UK' || this.countryGlobal === 'US' || this.countryGlobal === 'DE') {
        if (e === 1) {
          this.installments = 1;
          return true;
        } else return false;
      } else return true;
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    filterCurrency() {
      if (
        this.checkoutPayment &&
        this.checkoutPayment.data &&
        this.checkoutPayment.data.symbol_currency
      ) {
        return this.checkoutPayment.data.symbol_currency;
      }
      return 'R$';
    },
    filterCurrencyPais(id) {
      try {
        return symbolCurrency(id).pais;
      } catch (error) {
        return 'BR';
      }
    },
    formatValueToValidation(value) {
      if (!value || value >= 0 || value == '') return false;
      value = parseFloat(
        value
          .toString()
          .replace('R$ ', '')
          .replace(',', '.')
          .replace('-', '')
      );
      if (value < 1) return false;
      if (value >= this.getInstallments(this.installments) * this.installments)
        return false;
      else return true;
    },
    onCheckoutEvent(product) {
      const dataProduct = {
        id: product.id,
        name: product.name,
        price: product.amount,
      };

      dataLayer.push({
        event: 'checkout',
        checkout: {
          products: [
            {
              amount: dataProduct.price,
              product_name: dataProduct.name,
              product_id: dataProduct.id,
            },
          ],
        },
      });
    },
    changeEnderecoEntrega(e) {
      if (e) this.getCEP('charge');
    },
    changeBump(item, index) {
      this.allowed_methods = this.product.method;
      let aux_allowed_methods = this.allowed_methods.split(",");
      if (
        this.hasBumpSelected &&
        this.method === 'PAYPAL'
      ) {
        this.hidePaypal();
      } else {
        if (item.checkbox === true) {
          Vue.set(this.bump_list[index], 'checkbox', false);
        } else {
          Vue.set(this.bump_list[index], 'checkbox', true);
        }

        if (this.product.type === 'SUBSCRIPTION') {
          this.installments = this.product.fixed_installments ? this.product.fixed_installments : 1
        }
        if (this.bump_list.filter((i) => i.checkbox && i.type === "SUBSCRIPTION").length) {
          this.installments = this.product.fixed_installments ? this.product.fixed_installments : 1
          this.bump_list.map(bump => {
            aux_allowed_methods = aux_allowed_methods.filter(method => bump.method.includes(method))
          })
        }
        if (!this.product.has_shipping_fee && this.product.trial) {
          aux_allowed_methods = aux_allowed_methods.filter(method => method !== 'PIX')
        }
        if (this.bump_list.filter((i) => i.checkbox && !i.has_shipping_fee && i.trial).length) {
          aux_allowed_methods = aux_allowed_methods.filter(method => method !== 'PIX')
        }
        this.allowed_methods = aux_allowed_methods.join(",")
        this.data.billing_shipping_same_address = this.data.billing_shipping_same_address ? this.data.billing_shipping_same_address : this.bump_list.some(element => element.format === 'PHYSICALPRODUCT')
        this.addBumpProduct(item);
      }
    },
    getResetCheckout() {
      let product_id = this.$route.params.product;

      var error_type = sessionStorage.getItem('error_type_' + product_id);
      var all_data = sessionStorage.getItem('all_data_' + product_id);

      if (error_type && all_data) {
        this.error_message = sessionStorage.getItem('error_msg_' + product_id);
        if (error_type == 'CARD') {
          this.data = JSON.parse(all_data);
          this.data.cards = [
            {
              amount: '',
              number: '',
              holder_name: '',
              valid: '',
              year: '',
              month: '',
              cvv: '',
            },
          ];
        } else if (error_type == 'CVV') {
          this.data = JSON.parse(all_data);
          if (this.data.cards.length == 2) this.data.cards[1].cvv = '';
          else this.data.cards[0].cvv = '';
        } else {
          if(all_data) this.data = JSON.parse(all_data);
        }

        let error_type = sessionStorage.removeItem('error_type_' + product_id);
        let all_data = sessionStorage.removeItem('all_data_' + product_id);
      }
    },
    // reset erro payment
    resetCheckout(type) {
      this.submit = false;

      let product_id = this.$route.params.product;

      switch (type.toUpperCase()) {
        case 'ALL':
        default:
          this.etapa_atual = 1;
          this.address_step = false;
          this.last_step = false;
          this.capture.step = 1;

          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.yourValue = '';

          if (this.product.amount && this.original_amount) {
            this.product.amount = this.original_amount;
            this.amount = this.original_amount;
          } else {
            this.product.product.amount = this.original_amount;
            this.amount = this.original_amount;
          }

          this.cupom_checkout = '';
          this.cupom_valid = false;

          if (this.products_list.length > 1) {
            var bumps = this.bump_list;
            var products = this.products_list;
            for (let i = 0; i < products.length; i++) {
              const product_id = products[i].product_id;
              for (let x = 0; x < bumps.length; x++) {
                const bump_id = bumps[x].id;
                if (product_id === bump_id) {
                  Vue.set(this.bump_list[x], 'checkbox', true);
                  this.addBumpProduct(this.bump_list[x]);
                }
              }
            }
          }

          this.data = {
            name: '',
            email: '',
            confirmed_email: '',
            cellphone: '',
            document: '',
            cards: [
              {
                amount: '',
                number: '',
                holder_name: '',
                valid: '',
                year: '',
                month: '',
                cvv: '',
              },
            ],
            zipcode: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
            bump: false,
            gift_message: '',
            is_gift: false,
            billing_shipping_same_address: false,
            has_shipping_fee: false,
          };

          if (this.method === 'TWO_CREDIT_CARDS') {
            this.data.cards.push({
              amount: '',
              number: '',
              holder_name: '',
              valid: '',
              year: '',
              month: '',
              cvv: '',
            });
          }

          this.data.has_shipping_fee =
            this.product_type == 'COMMON'
              ? this.product.has_shipping_fee
              : this.product.product.has_shipping_fee;

          break;
        case 'CARD':
          this.data.cards = [
            {
              amount: '',
              number: '',
              holder_name: '',
              valid: '',
              year: '',
              month: '',
              cvv: '',
            },
          ];

          if (this.method == 'TWO_CREDIT_CARDS') {
            this.data.cards.push({
              amount: '',
              number: '',
              holder_name: '',
              valid: '',
              year: '',
              month: '',
              cvv: '',
            });
          }
          break;
        case 'CVV':
          if (this.data.cards.length == 2) this.data.cards[1].cvv = '';
          else this.data.cards[0].cvv = '';
          break;
      }

      sessionStorage.setItem(
        'all_data_' + product_id,
        JSON.stringify(this.data)
      );
      sessionStorage.setItem('error_type_' + product_id, type);
    },
    blurInputPhone() {
      this.validateForm();
      try {
        if (
          this.results_tel.nationalNumber.length !== 11 &&
          this.results_tel.countryCode === 'BR'
        )
          this.errorPhone = false;
        else {
          if (this.results_tel.countryCode !== 'BR') return;
          this.errorPhone = false;
        }
      } catch {
        GreennLogs.logger.info('🔴 Error Validar Telefone BR', {
          name: 'FORMAT NUMBER PHONE',
          product_id: this.product.id,
          number: this.results_tel.formattedNumber,
        });
      }
    },
    onSelectCountry(event) {
      this.country_code = event.iso2;
      let countyCode = document.getElementsByClassName('country-code')[0];
      countyCode.classList.add('ml-2');
      countyCode.classList.add('mr-2');
      countyCode.innerText = event.name;
    },
    r3t() {
      this.preload = false;
      this.loading = false;
      // this.hard_loading = true;

      // const query = this.$route.query;
      // const slug = this.$route.params.product;
      // if (slug && !query.prop_id && !query.ch_id) {
      //   this.getProduct(slug, this.countryGlobal);
      // } else if (typeof query.prop_id != "undefined") {
      //   this.getProposal(query.prop_id);
      // } else if (typeof query.ch_id != "undefined") {
      //   this.getThemeCheckout(slug, query.ch_id);
      // }

      // this.$refs.Captcha.resetCaptcha();

      // if (query.b_id) this.getBump(query.b_id, this.countryGlobal)

      // window.location.reload(true);
    },
    formatPageThankYou(response) {
      if(response[0].upsell && response[0].upsell.metas.length) {
        response[0].upsell.metas.forEach((item) => {
          if(item.upsell_key == 'link_obrigado') {
            this.page_thanks_response = item.upsell_value
            if(!item.upsell_value) this.page_thanks_response = this.product.thank_you_page
          }
        })
      } else {
        this.page_thanks_response = this.product.thank_you_page
      }
    },
    getThemeCheckout(id_produto, id_checkout) {
      let data = {
        id: `/${id_produto}/checkout/${id_checkout}`,
      };

      if (this.$route.params.hash) {
        data.id = `/${id_produto}/checkout/${id_checkout}/offer/${this.$route.params.hash}`;
      }

      const country = this.$route.query.country || null
      if (country) data.id = data.id + '?country=' + country

      serviceCheckout
        .readAll(data)
        .then((response) => {
          const token_header = {
            'controller-token-': response.headers['controller-token-'],
            'requestray-token-': response.headers['requestray-token-'],
            'firewall-token-': response.headers['firewall-token-'],
            'cache-token-': response.headers['cache-token-'],
            'trans-token-': response.headers['trans-token-'],
            'wd-token-': this.getWdToken(),
          };

          if(this.$route.query.country) {
            this.setLocale(this.$route.query.country);
          }

          this.$store.commit('UPDATE_TOKEN', token_header);
          return JSON.parse(response.data);
        })
        .then((response) => {
          this.allow_free_offers = response.allow_free_offers === 'ENABLED';
          this.checkoutPayment = response.checkout_payment;
          if (
            this.checkoutPayment &&
            this.checkoutPayment.data &&
            this.checkoutPayment.data.amount
          ) {
            response.data.amount = this.checkoutPayment.data.amount;
          }
          if (!this.$store.state.mounted) {
            this.mountedProduct(response.data, response.type);
            this.themeCheckout = response.custom_checkout;

            this.pop_modal.data = {
              is_on: this.themeCheckout.exit_pop_up,
              image: this.themeCheckout.image_exit_pop_up,
              title: this.themeCheckout.title_exit_pop_up,
              link: this.themeCheckout.link_exit_pop_up,
              description: this.themeCheckout.description_exit_pop_up,
              is_button: this.themeCheckout.button_exit_pop_up,
              button_text: this.themeCheckout.text_button_exit_pop_up || "Comprar agora",
            };

            this.escassez = {
              scarcity: this.themeCheckout.scarcity,
              scarcity_background_color: this.themeCheckout
                .scarcity_background_color,
              scarcity_subtitle: this.themeCheckout.scarcity_subtitle,
              scarcity_time: this.themeCheckout.scarcity_time,
              scarcity_title: this.themeCheckout.scarcity_title,
            };

            if (this.themeCheckout.ob_custom) {
              this.custom_bump = {
                ob_description: this.themeCheckout.ob_description,
                ob_title: this.themeCheckout.ob_title,
                ob_subtitle: this.themeCheckout.ob_subtitle,
                ob_background_color: JSON.parse(
                  this.themeCheckout.ob_background_color
                ),
                ob_border: this.themeCheckout.ob_border,
                ob_border_px: this.themeCheckout.ob_border_px,
              };
            }

            if (this.themeCheckout.jivochat_id) {
              this.initJivoChat(this.themeCheckout.jivochat_id);
            }

            if (this.themeCheckout.zopim_id) {
              this.initZopimChat(this.themeCheckout.zopim_id);
            }

            if( this.themeCheckout.purchase_notification === 'on' && this.product.status == 'APPROVED') {
              this.notifications = response.purchase_notification;
              this.initNotifications();
            }

            if (this.business) {
              // setando itens
              this.themeCheckout.button_text = 'Reservar agora';
              this.themeCheckout.trial_position = 'bottom';
              this.themeCheckout.trial_info = 'fixa';
            }

            this.themeCheckout.whatsapp_button =
              this.themeCheckout.whatsapp_button == '1' ? true : false;

            if (
              this.themeCheckout.whatsapp_button &&
              this.themeCheckout.whatsapp_number != null &&
              this.themeCheckout.whatsapp_number != ''
            ) {
              this.wpp_number = this.themeCheckout.whatsapp_number.substring(3);
              this.wpp_number = this.wpp_number.replace('.', '');
              this.wpp = true;
            }

            // set local variabel with currency conversion data
            this.rate = {
              target_currency: response.checkout_payment.data.to,
              base_currency: response.checkout_payment.data.from,
              token: response.checkout_payment.token,
            };

            this.confirmation_email =
              this.themeCheckout.confirmation_email === 'on' ?? false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.removePreload(true);
        });
    },
    initNotifications() {
      let color = this.themeCheckout.theme_color;
      let background = this.themeCheckout.theme_color_bg;
      if (color === null) {
        color = '#00E4A0';
      }
      if (background === null || background === 'rgba(0, 228, 160, 0.3)') {
        background = 'rgb(232 252 246)';
      } else if (background === 'rgba(33, 51, 210, 0.3)') {
        background = '#e9eafa';
      } else if (background === 'rgba(255, 12, 55, 0.3)') {
        background = '#ffb8c4';
      } else if (background === 'rgba(255, 203, 55, 0.3)') {
        background = '#ffefc6';
      } else if (background === 'rgba(46, 215, 238, 0.3)') {
        background = '#c2f3f9';
      } else if (background === 'rgba(93, 33, 210, 0.3)') {
        background = '#cebff1';
      } else if (background === 'rgba(0, 9, 22, 0.3)') {
        background = '#b2b5b8';
      } else if (background === 'rgba(52, 131, 250, 0.3)') {
        background = '#c2dafd';
      } else if (background === 'rgba(0, 175, 123, 0.3)') {
        background = '#b8e7d8';
      }
      let css = `.b-toast-custom .toast-header strong {
        color: ${color};
      }
      .b-toast-custom .toast-header strong::before {
        content: "🔥";
        background: none;
        font-size: 22px;
        position: absolute;
        left: -36px;
      }
      .b-toast-custom .toast {
        background-color: ${background} !important;
        border-color: ${color} !important;
        color: ${color} !important;
      }
      .b-toast-custom .toast .toast-header {
        color: ${color} !important;
        background-color: ${background} !important;
        border: none !important;
      }
      .b-toast-custom.b-toast-solid .toast {
        background-color: ${color} !important;
      }`;
      let head = document.head || document.getElementsByTagName('head')[0];
      let style = document.createElement('style');
      head.appendChild(style);

      style.type = 'text/css';

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      let array = this.notifications;

      for (let i = 0; i < array.length; i++) {
        const element = array[i];

        if (localStorage.getItem(`notification${element.id}`) === null) {
          localStorage.setItem(`notification${element.id}`, 'true');
          let time =
            this.getRandomInt(
              this.themeCheckout.minimum_purchase_notification_interval,
              this.themeCheckout.maximum_purchase_notification_interval
            ) + '000';
          this.makeNotification(element.name, time);
          return;
        }
      }
    },
    calculateNotification() {
      let array = this.notifications;
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        if (localStorage.getItem(`notification${element.id}`) === null) {
          localStorage.setItem(`notification${element.id}`, 'true');
          let time =
            this.getRandomInt(
              this.themeCheckout.minimum_purchase_notification_interval,
              this.themeCheckout.maximum_purchase_notification_interval
            ) + '000';
          this.makeNotification(element.name, time);
          return;
        }
      }
    },
    makeNotification(name, time) {
      var position = this.themeCheckout.type_purchase_notification;
      if (!position) {
        position = 'b-toaster-bottom-right';
      }
      setTimeout(() => {
        this.$bvToast.toast(`${name} acabou de comprar!`, {
          title: `Nova venda realizada`,
          variant: 'custom',
          toaster: position,
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.calculateNotification();
      }, parseInt(time));
    },
    getRandomInt(min, max) {
      min = Math.ceil(5);
      max = Math.floor(10);
      return Math.floor(Math.random() * (max - min)) + min;
    },
    initJivoChat(id) {
      // J0jlVX87X9
      // script jivochat
      const jivoScript = document.createElement('script');
      jivoScript.setAttribute('src', `//code-eu1.jivosite.com/widget/${id}`);
      jivoScript.async = true;
      document.head.appendChild(jivoScript);
    },
    initZopimChat(id) {
      // 3d5dAUgCZbe2ecEjO0Zz1eIlAg9qTnQF
      const zopimScript = document.createElement('script');
      zopimScript.setAttribute('src', `https://v2.zopim.com/?${id}`);
      zopimScript.async = true;
      document.head.appendChild(zopimScript);
    },
    setLocale(newLocale) {
      if (newLocale === 'ES') {
        this.data.document = null;
      }
      let data = {
        locale: newLocale,
      };
      EventBus.$emit('changeLocale', data);
    },
    debounceSave() {
      /* cleaning possible blanks in email fields  */
      if(typeof this.data.email === 'string') this.data.email = this.data.email.trim()
      if(typeof this.data.confirmation_email === 'string') this.data.confirmation_email = this.data.confirmation_email.trim()
      
      if (this.debounce) {
        clearTimeout(this.debounce);
        this.debounce = null;
      }
      this.debounce = setTimeout(() => {
        this.saveDataUser();
        this.debounce = null;
      }, 1000);
    },
    fetchCapture(capture) {
      let data = {
        product_id: capture.product_id,
        uuid: capture.uuid,
      };
      serviceLead.search(data).then((r) => {
        this.capture = Object.keys(r).length ? r : capture;
        this.data.name = !this.data.name ? this.capture.name : this.data.name;
        this.data.email = !this.data.email ? this.capture.email : this.data.email;
        this.yourValue = !this.data.cellphone ? this.capture.cellphone : this.data.cellphone;
        this.data.document = this.capture.cpf;
        this.data.zipcode = this.capture.zip_code;
        this.data.offer_hash = this.$route.params.hash;
        this.data.street = this.capture.street;
        this.data.number = this.capture.number;
        this.data.neighborhood = this.capture.neighborhood;
        this.data.city = this.capture.city;
        this.data.state = this.capture.state;

        if (
          this.data.zipcode &&
          this.is_produto_fisico &&
          this.product.method !== 'FREE' &&
          this.data.has_shipping_fee &&
          !this.isFixedShipping
        ) {
          this.checkShippingFee(this.data.zipcode);
        }
      });
    },
    atualizaCapture(capture) {
      const data = capture;
      data.id = this.capture.uuid;
      data.product_id = this.capture.product_id;
      data.offer_hash = this.$route.params.hash;
      data.country_code = this.countryGlobal === 'OUTROS' ? this.countryGlobalSettings : this.countryGlobal
      if (data.id) serviceLead.update(data);
    },
    createCapture(capture) {
      let data = {
        product_id: capture.product_id,
        seller_id: capture.seller_id,
        offer_hash: this.$route.params.hash,
        country_code: this.countryGlobal === 'OUTROS' ? this.countryGlobalSettings : this.countryGlobal,
        uuid: capture.uuid,
      };
      serviceLead.create(data);
    },
    saveDataUser() {
      this.capture.step = 1;

      this.data.cellphone = this.results_tel.formattedNumber;

      this.capture.name = this.data.name;
      this.capture.cellphone = this.data.cellphone;
      this.capture.email = this.data.email;
      this.capture.cpf = this.data.document;
      this.capture.zip_code = this.data.zipcode;
      this.capture.street = this.data.street;
      this.capture.number = this.data.number;
      this.capture.neighborhood = this.data.neighborhood;
      this.capture.city = this.data.city;
      this.capture.state = this.data.state;
      this.capture.complement = this.data.complement;

      if ((this.is_produto_fisico || this.hasPhysicalProduct) && this.product.method !== 'FREE') {
        this.capture.shipping_address_zip_code = this.shipping.address.zipcode;
        this.capture.shipping_address_street = this.shipping.address.street;
        this.capture.shipping_address_number = this.shipping.address.number;
        this.capture.shipping_address_neighborhood = this.shipping.address.neighborhood;
        this.capture.shipping_address_city = this.shipping.address.city;
        this.capture.shipping_address_state = this.shipping.address.state;
        this.capture.shipping_address_complement = this.shipping.address.complement;
      }

      if (
        this.capture.name &&
        this.capture.cellphone &&
        this.capture.email &&
        this.capture.cpf
      ) {
        this.capture.step = 1;
      } else this.capture.step = 0;
      if (this.capture.step == 1) {
        if (
          this.capture.zip_code &&
          this.capture.street &&
          this.capture.number &&
          this.capture.neighborhood &&
          this.capture.city &&
          this.capture.city
        ) {
          this.capture.step = 2;
        } else this.capture.step = 1;
      }
      // enviar os dados para a api
      this.atualizaCapture(this.capture);
      //valida os dados para o paypal
      this.validateForm();
    },
    // função validando formulario
    async validateAllForm() {
      let valid_pessoal = false;
      let valid_address = false;
      let valid_pay = false;
      let valid_document_es = !this.data.document;

      // validando primeira etapa
      valid_pessoal = await this.$validator.validateAll('pessoal');

      if (
        this.countryGlobal === 'AR' ||
        this.countryGlobal === 'MX' ||
        this.countryGlobal === 'UY'
      ) {
        if (this.data.document)
          if (this.data.document.length === 0) {
            valid_document_es = false;
          } else valid_document_es = true;
      } else {
        valid_document_es = true;
      }

      if(!this.data.document && this.countries_obrigatory_document.includes(this.countryGlobal)) {
        valid_pessoal = false
      }

      this.valid_document_es = valid_document_es;

      // validando segunda etapa (se existir)
      if (this.etapa_total == 3) {
        valid_address = await this.$validator.validateAll('address');
      } else {
        valid_address = true;
      }

      // validando terceira etapa
      if (this.method === 'CREDIT_CARD' || this.method === 'TWO_CREDIT_CARDS') {
        valid_pay = await this.$validator.validateAll('pay');
      } else if (this.isMobile && this.countryGlobal === 'BR') {
        valid_pay = await this.$validator.validate('pay.document');
      } else {
        valid_pay = true;
      }

      if (this.results_tel.isValid && this.results_tel.countryCode === 'BR') {
        this.errorPhone = false;
      } else if (
        !this.results_tel.isValid &&
        this.results_tel.countryCode === 'BR'
      ) {
        this.errorPhone = true;
        this.results_tel.isValid = false;
      } else {
        if (this.results_tel.phoneNumber) {
          if (
            this.results_tel.phoneNumber.length > 8 &&
            this.results_tel.phoneNumber.length < 13
          ) {
            this.errorPhone = false;
            this.results_tel.isValid = true;
          } else {
            this.errorPhone = true;
          }
        } else {
          this.errorPhone = true;
        }
      }

      return (
        valid_pessoal &&
        valid_address &&
        valid_pay &&
        this.results_tel.isValid &&
        valid_document_es
      );
    },
    hasAddress() {
      this.possui_endereco = true
      this.etapa_total = 3
    },
    addBumpProduct(bump_item) {
      let divisaoValor = 0;

      const contem = [...this.products_list].findIndex((item) => {
        if (item.product_id == bump_item.id) {
          return true;
        }
      });

      if (contem > -1) {
        if (this.product_type == 'COMMON') {
          this.amount -= bump_item.custom_charges.length ? bump_item.custom_charges[0].amount : bump_item.amount;
          this.original_amount -= bump_item.custom_charges.length ? bump_item.custom_charges[0].amount : bump_item.amount;

          let product = [...this.products_list].filter(item => item.product_id === bump_item.id).pop()
          if (product?.shipping_amount) {
            this.amount -= product.shipping_amount;
            this.original_amount -= product.shipping_amount;
          }
        } else {
          if (
            this.product.product.type == 'TRANSACTION' &&
            bump_item.type == 'TRANSACTION'
          ) {
            this.amount -= bump_item.amount;
            this.original_amount -= bump_item.amount;
          }
        }
        this.products_list.splice(contem, 1);
      } else {
        if (this.b_offer && typeof this.$route.query.b_id == 'string') {
          this.products_list.push({
            product_id: bump_item.id,
            product_offer: this.b_offer,
          });
        } else {
          this.products_list.push({
            product_id: bump_item.id,
            product_offer: bump_item.hash,
          });
        }

        if (this.product_type == 'COMMON') {
          this.amount += bump_item.custom_charges.length ? bump_item.custom_charges[0].amount : bump_item.amount;
          this.original_amount += bump_item.custom_charges.length ? bump_item.custom_charges[0].amount : bump_item.amount;
        } else {
          if (
            this.product.product.type == 'TRANSACTION' &&
            bump_item.type == 'TRANSACTION'
          ) {
            this.amount += bump_item.amount;
            this.original_amount += bump_item.amount;
          }
        }
      }

      divisaoValor = this.amount / 2;

      if (this.method == 'TWO_CREDIT_CARDS') {
        this.data.cards[0].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(divisaoValor)}`;
        this.data.cards[1].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(divisaoValor)}`;
      }

      this.amount_cards = {
        card_1: divisaoValor,
        card_2: divisaoValor,
      };
    },
    handleResize() {
      this.client.width = window.innerWidth;
    },
    nextStep(step, scope) {
      this.submit = true

      if(typeof this.data.email === 'string') this.data.email = this.data.email.trim()

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          if (this.results_tel.countryCode === 'BR' && this.errorPhone === true) return
          this.submit = false;
          if (step == 'address') {
            this.address_step = true
            this.last_step = false
          } else if (step == 'pagamento') {
            this.last_step = true
            this.address_step = false
          }

          window.scrollTo({ top: 250, behavior: 'smooth' })

          const etapas = document.querySelectorAll('.icon-etapa')
          etapas[this.etapa_atual - 1].classList.add('complete')
          etapas[this.etapa_atual].classList.add('target')
          this.etapa_atual++
        }
      })
    },
    previous_step() {
      const cep = document.querySelector('#zipcode');
      this.submit = true;
      if (this.etapa_atual == 2) {
        this.address_step = false;
        this.last_step = false;
      } else if (this.etapa_atual == 3) {
        this.address_step = true;
        this.last_step = false;
        setTimeout(() => {
          if (cep) cep.focus();
        });
      }

      window.scrollTo({ top: 340, behavior: 'smooth' });
      this.submit = false;

      const etapas = document.querySelectorAll('.icon-etapa');
      this.etapa_atual--;
      etapas[this.etapa_atual - 1].classList.remove('complete');
      etapas[this.etapa_atual - 1].classList.add('target');
      etapas[this.etapa_atual].classList.remove('target');
    },
    getImg(img) {
      return require(`@/assets/img/footer/${img}.svg`);
    },
    flipCard(status) {
      if (this.$refs.card) this.$refs.card.flipCard(status);
    },
    focusInput(e) {
      if (this.$refs.card) this.$refs.card.focusInput(e);
    },
    blurInput() {
      if (this.$refs.card) this.$refs.card.blurInput();
    },
    clickTab(metodo) {
      this.submit = false;
      this.sem_parcela = false;
      this.method_pix = false;

      switch (metodo) {
        case 'CREDIT_CARD':
          this.method = 'CREDIT_CARD';
          this.sem_juros = this.product.no_interest_installments
          break;
        case 'BOLETO':
          this.method = 'BOLETO';
          this.sem_parcela = true;
          this.sem_juros = false;
          break;
        case 'PAYPAL':
          this.method = 'PAYPAL';
          this.sem_juros = false;
          break;
        case 'SAFETYPAY-CASH':
          this.method = 'SAFETYPAY-CASH';
          this.sem_juros = false;
          break;
        case 'EFT':
          this.method = 'EFT';
          this.sem_juros = false;
          break;
        case 'BANKTRANSFER':
          this.method = 'BANKTRANSFER';
          this.sem_juros = false;
          break;
        case 'DEBITCARD':
          this.method = 'DEBITCARD';
          this.installments = 1;
          this.sem_juros = false;
          break;
        case 'EFECTY':
          this.method = 'EFECTY';
          this.sem_juros = false;
          break;
        case 'MULTICAJA':
          this.method = 'MULTICAJA';
          this.sem_juros = false;
          break;
        case 'SENCILLITO':
          this.method = 'SENCILLITO';
          this.sem_juros = false;
          break;
        case 'SERVIPAG':
          this.method = 'SERVIPAG';
          this.sem_juros = false;
          break;
        case 'PAGOSNET':
          this.method = 'PAGOSNET';
          this.sem_juros = false;
          break;
        case 'RAPIPAGO':
          this.method = 'RAPIPAGO';
          this.sem_juros = false;
          break;
        case 'PAGOFACIL':
          this.method = 'PAGOFACIL';
          this.sem_juros = false;
          break;
        case 'WEBPAY':
          this.method = 'WEBPAY';
          this.sem_juros = false;
          break;
        case 'OXXO':
          this.method = 'OXXO';
          this.sem_juros = false;
          break;
        case 'SPEI':
          this.method = 'SPEI';
          this.sem_juros = false;
          break;
        case 'PIX':
          this.method = 'PIX';
          this.method_pix = true;
          this.sem_parcela = true;
          this.sem_juros = false;
          break;
      }
    },
    addCard1() {
      this.method = 'CREDIT_CARD';
      if (this.data.cards.length > 1) {
        this.data.cards = [
          {
            amount: '',
            number: '',
            holder_name: '',
            valid: '',
            year: '',
            month: '',
            cvv: '',
          },
        ];
      }
    },
    addCard2() {
      this.method = 'TWO_CREDIT_CARDS';
      this.data.cards.push({
        amount: '',
        number: '',
        holder_name: '',
        valid: '',
        year: '',
        month: '',
        cvv: '',
      });

      this.initValueTwoCards();
    },
    initValueTwoCards() {
      let divisaoValor = 0;
      let parsedAmount = 0
      if (this.installments > 1) {
        if (this.includeBump) {
          parsedAmount = parseFloat(this.amount + this.bump.amount).toFixed(2)
        } else {
          parsedAmount = parseFloat(this.getInstallments() * this.installments).toFixed(2);
        }
      } else {
        if (this.data.has_shipping_fee) {
          parsedAmount = parseFloat(this.amount + this.shipping.amount).toFixed(2) ;
        } else {
          parsedAmount = parseFloat(this.amount).toFixed(2);
        }
      }
      let firstValue = parseFloat(parsedAmount / 2).toFixed(2);
      let secondValue = parsedAmount - firstValue
      this.data.cards[0].amount = `${this.filterCurrency(
        this.currency_id
      )} ${this.formatMoney(firstValue)}`;
      this.data.cards[1].amount = `${this.filterCurrency(
        this.currency_id
      )} ${this.formatMoney(secondValue)}`;

      let card_1 = this.amount / 2;
      this.amount_cards = {
        card_1: card_1,
        card_2: this.amount - card_1,
      };
    },
    changeParcelamentoCartao() {
      if (this.method == 'TWO_CREDIT_CARDS') {
        this.initValueTwoCards();
      }
    },
    firstCard() {
      // if (this.debounce) {
      //   clearTimeout(this.debounce);
      //   this.debounce = null;
      // }
      // this.debounce = setTimeout(() => {
      //   this.changeFirstCard();
      //   this.debounce = null;
      // }, 100);
    },
    changeFirstCard() {
      // limpando valor digitado
      const amountFix = +this.data.cards[0].amount
        .toString()
        .replace('R$ ', '')
        .replace(',', '.')
        .replace('-', '');

      // pegando amount com juros
      const amountJuros =
        parseFloat(this.getInstallments(this.installments) * this.installments).toFixed(2);
      if (amountFix) {
        let amount = this.amount - amountFix;
        if (!isNaN(amount)) {
          // valor sem juros
          this.amount_cards = {
            card_1: this.amount - amount,
            card_2: amount,
          };

          // subtração de valor digitado - valorTotal
          const amountVariant = amountJuros - amountFix;

          // setando os valores nos campos
          this.data.cards[1].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountVariant)}`;
          this.data.cards[0].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountFix)}`;

          if (amountFix > amountJuros) {
            // setando os valores nos campos
            this.data.cards[0].amount = `${this.filterCurrency(
              this.currency_id
            )} ${this.formatMoney(amountJuros)}`;
            this.data.cards[1].amount = '';
          }
        } else {
          this.data.cards[0].amount = '';
        }
      } else {
        // setando os valores nos campos

        this.data.cards[1].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(amountJuros)}`;
        this.data.cards[0].amount = '';
      }
    },
    secondCard() {
      // if (this.debounce) {
      //   clearTimeout(this.debounce);
      //   this.debounce = null;
      // }
      // this.debounce = setTimeout(() => {
      //   this.changeSecondCard();
      //   this.debounce = null;
      // }, 1500);
    },
    changeSecondCard() {
      // limpando valor digitado
      const amountFix = +this.data.cards[1].amount
        .toString()
        .replace('R$ ', '')
        .replace(',', '.')
        .replace('-', '');

      // pegando amount com juros
      const amountJuros =
        parseFloat(this.getInstallments(this.installments) * this.installments).toFixed(2);
      if (amountFix) {
        let amount = this.amount - amountFix;
        if (!isNaN(amount)) {
          // valor sem juros
          this.amount_cards = {
            card_1: amount,
            card_2: this.amount - amount,
          };

          // subtração de valor digitado - valorTotal
          const amountVariant = amountJuros - amountFix;

          // setando os valores nos campos
          this.data.cards[0].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountVariant)}`;
          this.data.cards[1].amount = `${this.filterCurrency(
            this.currency_id
          )} ${this.formatMoney(amountFix)}`;

          if (amountFix > amountJuros) {
            // setando os valores nos campos
            this.data.cards[1].amount = `${this.filterCurrency(
              this.currency_id
            )} ${this.formatMoney(amountJuros)}`;
            this.data.cards[0].amount = '';
          }
        } else {
          this.data.cards[1].amount = '';
        }
      } else {
        // setando os valores nos campos
        this.data.cards[0].amount = `${this.filterCurrency(
          this.currency_id
        )} ${this.formatMoney(amountJuros)}`;
        this.data.cards[1].amount = '';
      }
    },
    convertAmount() {
      if (
        this.data.cards[0].amount
          .toString()
          .includes(`${this.filterCurrency(this.currency_id)} `)
      ) {
        this.data.cards[0].amount = +this.data.cards[0].amount
          .replace(`${this.filterCurrency(this.currency_id)} `, '')
          .replace('.', '')
          .replace(',', '.');
      }
      if (
        this.data.cards[1].amount
          .toString()
          .includes(`${this.filterCurrency(this.currency_id)}`)
      ) {
        this.data.cards[1].amount = +this.data.cards[1].amount
          .replace(`${this.filterCurrency(this.currency_id)} `, '')
          .replace('.', '')
          .replace(',', '.');
      }
    },
    checkAddressShipping() {
      return new Promise((resolve) => {
        if ((this.is_produto_fisico || this.hasPhysicalProduct) && this.product.method !== 'FREE') {
          if (this.data.billing_shipping_same_address) {
            this.shipping.address.zipcode = this.data.zipcode;
            this.shipping.address.street = this.data.street;
            this.shipping.address.neighborhood = this.data.neighborhood;
            this.shipping.address.city = this.data.city;
            this.shipping.address.state = this.data.state;
            this.shipping.address.number = this.data.number;
            this.shipping.address.complement = this.data.complement;
          }
          if (!this.isFixedShipping) {
            this.checkShippingFee(this.shipping.address.zipcode).then((resp) =>
              resolve(resp)
            );
          }
          resolve(true)
        } else resolve(true);
      });
    },
    changeFrete(frete) {
      this.shipping.frete = frete;
      this.shipping.amount = +frete.price;
      this.shipping.old_amount = this.amount;
      this.shipping.service_name = frete.name;
      this.shipping.frete_anterior = +frete.price;
      this.productHasShipping({ 
        ...this.product, 
        shipping: {
            shipping_service_id: frete.id,
            shipping_service_name: frete.name,
            shipping_amount: frete.price,
            shipping_selected: JSON.stringify(this.shipping)
        }
      });
    },
    checkShippingFee(cep) {
      return new Promise((resolve) => {
        if (this.data.has_shipping_fee) {
          let product_id =
            this.product_type == 'COMMON'
              ? this.product.id
              : this.product.product.id;

          let data = { shipping_address_zip_code: cep.replace(/[-]/g, '') };
          serviceShipping
            .create(data, `/calculate/${product_id}`)
            .then((response) => {
              this.options_shipping = response;
            })
            .catch(() => {
              this.$bvToast.toast(
                this.$t('Esse produto não possue integração para envio'),
                {
                  title: 'Frete',
                  variant: 'danger',
                  autoHideDelay: 5000,
                  appendToast: true,
                }
              );
            })
            .finally(() => {
              if (this.options_shipping.length) {
                this.options_shipping = [...this.options_shipping].filter(
                  (frete) => frete.price
                );

                this.options_shipping = [...this.options_shipping].sort(
                  (a, b) => {
                    return +a.price - +b.price;
                  }
                );

                // revalidando
                if (this.shipping.frete) {
                  const frete_selecionado = this.options_shipping.find(
                    (item) => item.id == this.shipping.service_id
                  );

                  if (+this.shipping.frete.price != +frete_selecionado.price) {
                    this.$bvToast.toast(this.$t('Erro no cálculo do frete'), {
                      title: 'Frete',
                      variant: 'danger',
                      autoHideDelay: 5000,
                      appendToast: true,
                    });

                    resolve(false);
                  } else resolve(true);
                } else {
                  this.shipping.service_id = this.options_shipping[0].id;
                  this.changeFrete(this.options_shipping[0]);
                  resolve(true);
                }
              } else resolve(true);
              this.loading_frete = false;
              if (this.method == 'TWO_CREDIT_CARDS') this.initValueTwoCards();
            });
        } else resolve(true);
      });
    },
    getCEP(type) {
      let cep = null;
      switch (type) {
        case 'charge':
          cep = this.data.zipcode;
          break;
        case 'shipping':
          cep = this.shipping.address.zipcode;
          break;
      }
      if (cep && cep.replace('-', '').length >= 8) {
        this.loading = true;
        if (this.data.has_shipping_fee) this.loading_frete = true;
        this.shipping.frete = null;

        axios
          .get('https://viacep.com.br/ws/' + cep.replace('-', '') + '/json')
          .then((response) => {
            if (type == 'charge') {
              this.data.number = '';
              this.data.street = response.data.logradouro;
              this.data.neighborhood = response.data.bairro;
              this.data.city = response.data.localidade;
              this.data.state = response.data.uf;
              document.querySelector('#number-address').focus();
            } else if (type == 'shipping') {
              this.shipping.address.number = '';
              this.shipping.address.street = response.data.logradouro;
              this.shipping.address.neighborhood = response.data.bairro;
              this.shipping.address.city = response.data.localidade;
              this.shipping.address.state = response.data.uf;
              document.querySelector('#number-address-shipping').focus();
            }
            if (!this.isFixedShipping) this.checkShippingFee(cep);
            EventBus.$emit('hasCep');
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getInstallments(n = this.installments, isSubmit = false) {
      let amount = this.amount

      //serve pra mandar para o backend quando o produto principal é assinatura com trial
      if(this.product.trial && !isSubmit && this.product.period === 30) amount -= this.product.amount

      if(n == 1) return amount

      let frete = 0
      // Removendo frete
      for (let index = 0; index < this.products_list.length; index++) {
        const product_id = this.products_list[index].product_id
        // Produto order bump
        if(index !== 0) {
          let bump = this.bump_list.find((x) => x.id === product_id)
          if(bump.has_shipping_fee == 1) {
            if(this.product.type_shipping_fee === "FIXED") {
              frete += this.product.amount_fixed_shipping_fee
            } else { // DYNAMIC
              frete += this.shipping.amount
            }
          }
        // Produto principal
        } else {
          if(this.product.has_shipping_fee == 1) {
            if(this.product.type_shipping_fee === "FIXED") {
              frete += this.product.amount_fixed_shipping_fee
              amount -= frete
            } else { // DYNAMIC
              frete += this.shipping.amount
              amount -= frete
            }
          }
        }
      }

      let retorno = 0
      let pv = amount; // product amount

      if(this.sem_juros && this.products_list.length > 1) {
        var products = this.products_list
        var bumps = this.bump_list
        var values = 0
        var values_sem_juros = 0

        for (let index = 0; index < products.length; index++) {
          const product_id = products[index].product_id
          if(index !== 0) {
            if(bumps.find((x) => x.id === product_id).no_interest_installments == 1) {
              values_sem_juros = values_sem_juros + bumps.find((x) => x.id === product_id).amount
            } else {
              values = values + bumps.find((x) => x.id === product_id).amount
            }
          } else {
            pv = this.product.amount - this.amount_cupom
          }
        }

        let i = this.monthly_interest / 100 // tax per month
        retorno = values / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i))

        return ((pv + retorno * n + values_sem_juros) / n) + (frete / n)
      }

      if (
        (this.sem_juros || this.product.no_interest_installments) &&
        (this.method == 'CREDIT_CARD' || this.method == 'TWO_CREDIT_CARDS' || this.method == 'BOLETO')
      ) {
        retorno = pv / n;
      } else {
        if (this.products_list.length > 1) {
          let products = this.products_list
          let bumps = this.bump_list
          let values = 0
          let values_sem_juros = 0

          for (let index = 0; index < products.length; index++) {
            const product_id = products[index].product_id;
            if(index !== 0) {
              if(bumps.find((x) => x.id === product_id).no_interest_installments == 1) {
                values_sem_juros = values_sem_juros + bumps.find((x) => x.id === product_id).amount
              } else {
                values = values + bumps.find((x) => x.id === product_id).amount
              }
            } else {
              pv = this.product.amount - Math.abs(this.amount_cupom)
            }
          }

          let i = this.monthly_interest / 100; // tax per month
          if (values_sem_juros === 0) {
            return (((pv + values) / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i)))) + (frete / n)
          }

          retorno = values / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i))
          let retorno_pv = pv / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i))

          return ((retorno_pv * n + retorno * n + values_sem_juros) / n) + (frete / n)
        }
        let i = this.monthly_interest / 100; // tax per month
        retorno = pv / ((Math.pow(1 + i, n) - 1) / (Math.pow(1 + i, n) * i))
      }

      return retorno + (frete / n)
    },
    vtk89(tk) {
      var wd_tk = document
        .querySelector('meta[data-wd]')
        .getAttribute('data-wd');
      if(typeof wd_tk === 'string') wd_tk = wd_tk.substr(wd_tk.length - 10)

      if(typeof tk === 'string') tk = tk.substr(tk.length - 10)

      if (wd_tk == tk) {
        this.paymentError('GENERIC');
        GreennLogs.logger.error('WD Token Error', { 'data-wd': wd_tk })
        return false
      } else {
        return true
      }
    },
    async onSubmit(get) {
      if (get !== 'get') {
        this.$refs.Captcha.setCaptcha();
        return;
      }
      this.loading = true;
      this.submit = true;

      if (this.$i18n.locale === 'pt') this.country_code = 'BR';
      else this.country_code = this.countryGlobal === 'OUTROS' ? this.countryGlobalSettings : this.countryGlobal;

      // atualizando com o step click
      this.capture.step = 3;
      this.atualizaCapture(this.capture);

      // this.country_code
      if (await this.validateAllForm()) {
        this.data.cellphone = this.results_tel.formattedNumber;
        this.preload = true;
        this.data.country_code = this.country_code;
        if (!(await this.checkAddressShipping())) {
          this.preload = false;
          this.loading = false;
          this.submit = false;
          return;
        }

        if(this.product.method === 'FREE') this.method = 'FREE'

        if (
          this.method == 'CREDIT_CARD' ||
          this.method == 'TWO_CREDIT_CARDS' ||
          this.method == 'DEBITCARD'
        ) {
          let cards = [];

          if (this.method == 'TWO_CREDIT_CARDS') {
            // this.initValueTwoCards();
          }

          for (let i = 0; i < this.data.cards.length; i++) {
            if (
              this.data.cards[i].number &&
              this.data.cards[i].holder_name &&
              this.data.cards[i].month &&
              this.data.cards[i].year &&
              this.data.cards[i].cvv
            ) {
              var card = {
                card_number: this.data.cards[i].number,
                card_holder_name: this.data.cards[i].holder_name,
                card_expiration_date:
                  String(this.data.cards[i].month) +
                  String(this.data.cards[i].year),
                card_cvv: this.data.cards[i].cvv,
                total: this.data.cards[i]?.total
              };

              var cardValidations = pagarme.validate({ card: card });

              // Check if the card number is valid
              if (!cardValidations.card.card_number) {
                this.card_number_error = true;
                this.preload = false;
                this.loading = false;
                return;
              }

              if (this.method == 'TWO_CREDIT_CARDS') {
                this.convertAmount();
              }

              if (this.data.cards[i].amount) {
                card.amount = parseFloat(
                  String(this.data.cards[i].amount)
                    .replace(this.filterCurrency(this.currency_id) + ' ', '')
                    .replace(',', '.')
                );
              } else {
                card.amount = this.amount;
              }

              if (this.method == 'CREDIT_CARD' || this.method == 'DEBITCARD') {
                card.amount = this.amount;
              }
              cards.push(card);
            }
          }

          if (this.method == 'TWO_CREDIT_CARDS') {
            const amountFix = +this.data.cards[0].amount
              .toString()
              .replace('R$ ', '')
              .replace(',', '.')
              .replace('-', '');

            if (amountFix) {
              let amount = this.amount - amountFix;
              if (!isNaN(amount)) {
                // valor sem juros
                this.amount_cards = {
                  card_1: this.amount - amount,
                  card_2: amount,
                };
              }
            }
            cards[0].amount = this.amount_cards.card_1;
            cards[1].amount = this.amount_cards.card_2;
          }

          // Success, so send the data to the server in order
          // to make the transaction
          var response;

          try {
            let bump_id;

            if (
              this.data.bump &&
              this.product.type == 'TRANSACTION' &&
              this.bump.type == 'TRANSACTION'
            ) {
              bump_id = this.bump.id;
            } else {
              bump_id = null;
            }

            response = await this.purchaseCreditCard(
              this.product.amount,
              this.product_type,
              this.installments,
              this.product.id,
              null,
              cards,
              bump_id
            );

            // removendo bump não comprado das query params para tela de obrigado
            let newQueryParams = Object.assign({}, this.$route.query)
            const queryKeys = Object.keys(newQueryParams)
            queryKeys.forEach(x => {
              if(x.substr(0, 4) === 'b_id') {
                if(!this.products_list.some(p => p.product_id === parseInt(newQueryParams[x]))) {
                  delete newQueryParams[x]
                }
              }
            })
            this.$router.push({ query: { ...newQueryParams } })
          } catch (e) {
            console.error(e);
            this.paymentError(e.response);

            GreennLogs.logger.info('🔴 Error Compra', {
              name: 'CATCH CARTÃO ',
              product_id: this.product.id,
              error: e,
            });
            if (
              this.method == 'TWO_CREDIT_CARDS' &&
              this.data.cards.length === 2
            ) {
              this.data.cards[0].amount = `R$ ${this.formatMoney(
                this.data.cards[0].amount
              )}`;
              this.data.cards[1].amount = `R$ ${this.formatMoney(
                this.data.cards[1].amount
              )}`;
            }
            this.preload = false;
            this.loading = false;
            return;
          }

          //xxxxxx vtk89

          if (response.sales != undefined && Array.isArray(response.sales) && response.sales.length && response.sales[0].product && response.sales[0].product.name) {
            const produto_principal = response.sales.find(x => x.product.name === this.product.name)
            if (response.sales.length) {
              this.preload = false
              this.loading = false
              if (
                (response.sales[0].success && !response.sales[0].code) ||
                response.sales[0].status == 'delayed'
              ) {
                let product_id = this.product.id
                Cookies.remove('affiliate_' + product_id)

                let query = {
                  s_id: produto_principal.status == 'delayed' ? 'delayed' : produto_principal.sale_id,
                }

                if(produto_principal.token) query.token = produto_principal.token
                if (this.vtk89(produto_principal.token)) {
                  query = Object.assign(this.$route.query, query)
                  this.formatPageThankYou(response.sales)

                  // Configurando na rota as querys de client_has_contract ids
                  let chc = '';
                  // Produto principal
                  if(response.sales && response.sales.length && produto_principal.chc) {
                    chc = '?chc=' + produto_principal.chc;
                  }
                  // Produto order bump
                  if(response.sales && response.sales.length > 1) {
                    this.products_list.forEach((product, index) => {
                      if(index !== 0) {
                        let orderbump = this.bump_list.find(bump => bump.id === +(product.product_id))
                        if(orderbump) {
                          response.sales.forEach(sale => {
                            if(sale.product.name === orderbump.name) {
                              const queryKeys = Object.keys(this.$route.query)
                              queryKeys.forEach(x => {
                                if(x.substr(0, 4) === 'b_id') {
                                  if(+(this.$route.query[x]) === orderbump.id && orderbump.name === sale.product.name) {
                                    if(orderbump.type === 'SUBSCRIPTION') {
                                      if(sale.sale_id) {
                                        this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc + '-s_id_' + sale.sale_id
                                      } else {
                                        this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc
                                      }
                                    } else { // TRANSACTION
                                      this.$route.query[x] = this.$route.query[x] + '-s_id_' + sale.sale_id
                                    }
                                  }
                                }
                              })
                            }
                          })
                        }
                      }
                    })
                  }

                  if (this.$route.params.hash) query.offer = this.$route.params.hash

                  this.$router.push({
                    path: `/${this.product.id}/obrigado` + chc,
                    query: query,
                    params: {
                      id_product: product_id,
                      name_product: this.product.name,
                      valor: this.getInstallments(this.installments),
                      type: this.product_type,
                      parcelas: response.sales[0].installments || this.installments,
                      trial: this.product.trial,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: 'CREDIT_CARD',
                      dados_response: response,
                    },
                  });
                }

                // registrando log de sucesso
                GreennLogs.logger.info('🟢 Success Compra', {
                  name: 'Compra concluída com sucesso',
                  product_id: this.product.id,
                });
              } else {
                this.paymentError(response.sales[0]);
              }
            } else if (response.reason) {
              this.r3t();
            } else {
              this.paymentError(response);
            }
          } else this.paymentError(response);
        } else if (this.method == 'PIX' || this.method_pix) {
          let product_id, amount, proposal_id, bump_amount, bump_product_id;
          amount = this.product.amount;

          product_id = this.product.id;

          if (this.data.bump) {
            bump_amount = this.bump.amount;
            bump_product_id = this.bump.id;
          }

          try {
            let response = await this.buildPix(
              this.product_type,
              product_id,
              amount,
              proposal_id,
              bump_product_id,
              bump_amount
            );

            if(Array.isArray(response.sales) && response.sales.length && response.sales[0].product && response.sales[0].product.name) {
              const produto_principal = response.sales.find(x => x.product.name === this.product.name)
              if (response.sales) {
                // if (response.success) {
                this.preload = false;
                this.loading = false;
  
                if (
                  (response.sales[0].success && !response.sales[0].code) ||
                  (response.sales[0].status && response.sales[0].status == 'delayed')
                ) {
                  Cookies.remove('affiliate_' + product_id);

                  let query = {};
                  if (produto_principal.status && produto_principal.status === 'delayed') {
                    query.s_id =  'delayed'
                  } else if (produto_principal) {
                    query.s_id = produto_principal.sale_id;
                  } else {
                    query.s_id = null
                  }
                  if (produto_principal.token) query.token = produto_principal.token
                  if (this.vtk89(produto_principal.token)) {
                    query = Object.assign(this.$route.query, query)
                    this.formatPageThankYou(response.sales)
  
                    // Configurando na rota as querys de client_has_contract ids
                    let chc = ''
                    // Produto principal
                    if(response.sales && response.sales.length && produto_principal.chc) {
                      chc = '?chc=' + produto_principal.chc
                    }
                    // Produto order bump
                    if(response.sales && response.sales.length > 0) {
                      this.products_list.forEach((product, index) => {
                        if(index !== 0) {
                          let orderbump = this.bump_list.find(bump => bump.id === +(product.product_id))
                          if(orderbump) {
                            response.sales.forEach(sale => {
                              if(sale.product.name === orderbump.name) {
                                const queryKeys = Object.keys(this.$route.query)
                                queryKeys.forEach(x => {
                                  if(x.substr(0, 4) === 'b_id') {
                                    if(+(this.$route.query[x]) === orderbump.id && orderbump.name === sale.product.name) {
                                      if(orderbump.type === 'SUBSCRIPTION') {
                                        if(sale.sale_id) {
                                          this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc + '-s_id_' + sale.sale_id
                                        } else {
                                          this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc
                                        }
                                      } else {
                                        this.$route.query[x] = this.$route.query[x] + '-s_id_' + sale.sale_id
                                      }
                                    }
                                  }
                                })
                              }
                            })
                          }
                        }
                      })
                    }
  
                    let params_multiple = {}
                    if (response.sales.length === 1) {
                      params_multiple = {
                        id_product: this.product.id,
                        qrcode: produto_principal.qrcode,
                        imgQrcode: produto_principal.imgQrcode,
                        valor: this.amount,
                        name_product: this.product.name,
                        thank_you_page: produto_principal.product.custom_thank_you_page || this.page_thanks_response,
                        isCheckout: true,
                        methodCheckout: 'PIX',
                        dados_response: response,
                      };
                    } else {
                      if (response?.order) {
                        params_multiple = {
                          id_product: this.product.id,
                          qrcode: response.order.qrcode,
                          imgQrcode: response.order.imgQrcode,
                          valor: this.amount,
                          name_product: this.product.name,
                          thank_you_page:
                            produto_principal.product.custom_thank_you_page ||
                            this.page_thanks_response,
                          isCheckout: true,
                          methodCheckout: 'PIX',
                          dados_response: response,
                        };
                      } else if (!response.order && response.sales.every(item => item.success)) {
                        params_multiple = {
                          id_product: this.product.id,
                          valor: this.amount,
                          name_product: this.product.name,
                          thank_you_page:
                            produto_principal.product.custom_thank_you_page ||
                            this.page_thanks_response,
                          isCheckout: true,
                          methodCheckout: 'PIX',
                          dados_response: response,
                        };
                      } 
                    }
                    if (this.$route.params.hash) query.offer = this.$route.params.hash
                    this.$router.push({
                      path: `/${params_multiple.id_product}/obrigado` + chc,
                      query: query,
                      params: params_multiple,
                    });
                  }
                } else {
                  this.paymentError(produto_principal);
                }
              } else if (response.reason) {
                this.r3t();
              } else {
                this.paymentError(response)
              }
            } else this.paymentError(response)
          } catch (err) {
            console.error(err);
            this.submit = false;
            this.preload = false;
            this.loading = false;
            this.paymentError(JSON.parse(err.response.data));
            GreennLogs.logger.info('🔴  Error Compra', {
              name: 'CATCH PIX',
              product_id: this.product.id,
              error: err,
            });
          }
        } else {
          let product_id, amount, proposal_id, bump_amount, bump_product_id;
          amount = this.product.amount;

          product_id = this.product.id;

          if (this.data.bump) {
            bump_amount = this.bump.amount;
            bump_product_id = this.bump.id;
          }

          try {
            let response = await this.buildTicket(
              this.product_type,
              product_id,
              amount,
              proposal_id,
              bump_product_id,
              bump_amount
            )

            if(Array.isArray(response.sales) && response.sales.length && response.sales[0].product && response.sales[0].product.name) {
              const produto_principal = response.sales.find(x => x.product.name === this.product.name)
              // removendo bump não comprado das query params para tela de obrigado
              let newQueryParams = Object.assign({}, this.$route.query)
              const queryKeys = Object.keys(newQueryParams)
              queryKeys.forEach(x => {
                if(x.substr(0, 4) === 'b_id') {
                  if(!this.products_list.some(p => p.product_id === parseInt(newQueryParams[x]))) {
                    delete newQueryParams[x]
                  }
                }
              })
              this.$router.push({ query: { ...newQueryParams } })
              // if (response.success) {
              this.preload = false;
              this.loading = false;
              if (
                (response.sales[0].success && !response.sales[0].code) ||
                response.sales[0].status == 'delayed'
              ) {
                Cookies.remove('affiliate_' + product_id);
                let query = {
                  s_id:
                    produto_principal.status == 'delayed'
                      ? 'delayed'
                      : produto_principal.sale_id, // id da venda
                };

                if (produto_principal.token) {
                  query.token = produto_principal.token;
                }
                if (this.vtk89(produto_principal.token)) {
                  query = Object.assign(this.$route.query, query);
                  this.formatPageThankYou(response.sales);

                  // Configurando na rota as querys de client_has_contract ids
                  let chc = ''
                  // Produto principal
                  if(response.sales && response.sales.length && produto_principal.chc) {
                    chc = '?chc=' + produto_principal.chc;
                  }
                  // Produto order bump
                  if(response.sales && response.sales.length > 0) {
                    this.products_list.forEach((product, index) => {
                      if(index !== 0) {
                        let orderbump = this.bump_list.find(bump => bump.id === +(product.product_id))
                        if(orderbump) {
                          response.sales.forEach(sale => {
                            if(sale.product.name === orderbump.name) {
                              const queryKeys = Object.keys(this.$route.query)
                              queryKeys.forEach(x => {
                                if(x.substr(0, 4) === 'b_id') {
                                  if(+(this.$route.query[x]) === orderbump.id && orderbump.name === sale.product.name) {
                                    if(orderbump.type === 'SUBSCRIPTION') {
                                      if(sale.sale_id) {
                                        this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc + '-s_id_' + sale.sale_id
                                      } else {
                                        this.$route.query[x] = this.$route.query[x] + '-chc_' + sale.chc
                                      }
                                    } else {
                                      this.$route.query[x] = this.$route.query[x] + '-s_id_' + sale.sale_id
                                    }
                                  }
                                }
                              })
                            }
                          })
                        }
                      }
                    })
                  }

                  let params_multiple = {};
                  if (response.sales.length === 1) {
                    params_multiple = {
                      id_product: this.product.id,
                      name_product: this.product.name,
                      valor: this.getInstallments(this.installments_boleto),
                      parcelas: this.installments_boleto,
                      type: this.product_type,
                      trial:this.product.trial,
                      thank_you_page:
                        response.sales[0].product.custom_thank_you_page ||
                        this.page_thanks_response,
                      isCheckout: true,
                      methodCheckout: 'BOLETO',
                      // response
                      dados_response: response,
                      boleto_url: response.sales[0].boleto_url,
                      boleto_barcode: response.sales[0].boleto_barcode,
                    };
                  } else {
                    if (response?.order) {
                      params_multiple = {
                        id_product: this.product.id,
                        name_product: this.product.name,
                        valor: this.getInstallments(this.installments_boleto),
                        parcelas: this.installments_boleto,
                        type: this.product_type,
                        trial: this.product.trial,
                        thank_you_page:
                          response.sales[0].product.custom_thank_you_page ||
                          this.page_thanks_response,
                        isCheckout: true,
                        methodCheckout: 'BOLETO',
                        // response
                        dados_response: response,
                        boleto_url: response.order.boleto_url,
                        boleto_barcode: response.order.boleto_barcode,
                      };
                    } else if (response.sales.every(item => item.success)) {
                      const boletos = [];
                      response.sales.forEach(sale => {
                        boletos.push({
                          url: sale.boleto_url,
                          barCode: sale.boleto_barcode,
                        })
                      })
                      params_multiple = {
                        id_product: this.product.id,
                        name_product: this.product.name,
                        valor: this.getInstallments(this.installments_boleto),
                        parcelas: this.installments_boleto,
                        type: this.product_type,
                        trial: this.product.trial,
                        thank_you_page:
                          response.sales[0].product.custom_thank_you_page ||
                          this.page_thanks_response,
                        isCheckout: true,
                        methodCheckout: 'BOLETO',
                        // response
                        dados_response: response,
                        boletos
                      };
                    } else {
                      throw new Error("error");
                    }
                  }
                  if (this.$route.params.hash) query.offer = this.$route.params.hash
                  this.$router.push({
                    path: `/${params_multiple.id_product}/obrigado` + chc,
                    query: query,
                    params: params_multiple,
                  });
                }
              } else {
                this.paymentError(response.sales[0]);
              }
            } else if (response.reason) {
              this.r3t();
            } else {
              this.paymentError(response).sales;
            }
          } catch (err) {
            console.error(err);

            this.submit = false;
            this.preload = false;
            this.loading = false;
            this.paymentError('GENERIC');

            GreennLogs.logger.info('🔴  Error Compra', {
              name: 'CATCH BOLETO',
              product_id: this.product.id,
              error: err,
            });
          }
        }
      } else {
        if (this.isMobile) {
          const dados_card = document.querySelector('#dados-card');

          if (dados_card) {
            const top = dados_card.parentElement.offsetTop + 100;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
        if(!this.data.document && this.countries_obrigatory_document.includes(this.countryGlobal)) {
          this.$bvToast.toast(
            this.$t('checkout.feedbacks.dados_obrigatorios.document'),
            {
              title: this.$t('checkout.feedbacks.dados_obrigatorios.title'),
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        } else {
          this.$bvToast.toast(
            this.$t('checkout.feedbacks.dados_obrigatorios.text'),
            {
              title: this.$t('checkout.feedbacks.dados_obrigatorios.title'),
              variant: 'danger',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }
        this.loading = false;
      }
    },
    validateEspanholError() {
      return (
        this.countryGlobal == 'AR' ||
        this.countryGlobal == 'CO' ||
        this.countryGlobal == 'CL' ||
        this.countryGlobal == 'EC' ||
        this.countryGlobal == 'GT' ||
        this.countryGlobal == 'MX' ||
        this.countryGlobal == 'PE' ||
        this.countryGlobal == 'UY' ||
        this.countryGlobal == 'ES'
      )
    },
    paymentError(response) {
      this.has_code = false;
      var country = this.countryGlobal;
      
      if (response && response.status == 'error') {
        switch (response.code) {
          case '0001':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Este cupom que está utilizando não é mais válido.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Este cupón que está utilizando ya no es válido.';
            } else {
              this.error_message = 'This coupon you are using is no longer valid.';
            }
            this.resetCheckout('CARD');
            break
          case 'BANK':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Algo deu errado com sua compra, por favor, entre em contato com o banco ou emissor do seu cartão.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Algo salió mal con su compra, comuníquese con su banco o emisor de la tarjeta.';
            } else {
              this.error_message = 'Something went wrong with your purchase, please contact your bank or card issuer.';
            }
            this.resetCheckout('ALL');
            break
          case 'BLACKLIST_PURCHASE':
            this.has_code = true;
            if (country === 'BR' || country === 'PT') {
              this.error_message = `Após inúmeras tentativas de pagamento o banco retornou que seu cartão foi bloqueado, entre em contato com sua operadora de cartão solicitando o desbloqueio e caso já tenha feito, nos avise em <a href="https://greenn.com.br" target="_blank">greenn.com.br</a> para liberarmos aqui.`;
            } else if (this.validateEspanholError()) {
              this.error_message = `Después de numerosos intentos de pago, el banco devolvió que su tarjeta estaba bloqueada, comuníquese con el operador de su tarjeta para solicitar el desbloqueo y, si ya lo hizo, infórmenos en <a href="https://greenn.com.br" target ="_blank">greenn.com.br</a> para publicar aquí.`;
            } else {
              this.error_message = `After numerous payment attempts, the bank returned that your card was blocked, contact your card operator asking to unblock it and if you have already done so, let us know at <a href="https://greenn.com.br" target ="_blank">greenn.com.br</a> to release here.`;
            }
            this.resetCheckout('ALL');
            break
          case 'INVALID_CVV':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Código de segurança do cartão inválido, verifique e tente novamente';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Código de seguridad de la tarjeta no válido, verifíquelo e inténtelo de nuevo';
            } else {
              this.error_message = 'Invalid card security code, please check and try again';
            }
            this.resetCheckout('CVV');
            break;
          case 'INVALID_CLIENT_DATA':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Dados do cliente consta incorretos, verifique e tente novamente';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Los datos del cliente son incorrectos, verifíquelo e inténtelo de nuevo';
            } else {
              this.error_message = 'Customer data is incorrect, please check and try again';
            }
            this.resetCheckout('ALL');
            break
          case 'DUPLICATE_PURCHASE':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Você já efetuou uma compra deste produto';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Ya has comprado este producto';
            } else {
              this.error_message = 'You have already purchased this product';
            }
            this.resetCheckout('ALL');
            break
          case 'PRODUCT_OUT_OF_STOCK':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Produto sem estoque. Não foi possível efetivar a compra.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Producto agotado. No se puede completar la compra.';
            } else {
              this.error_message = 'Product out of stock. Unable to complete the purchase.';
            }
            this.resetCheckout('ALL');
            break
          case 'CREDIT_CARD_OPERATOR':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Algo deu errado com sua compra, por favor, entre em contato com a operadora do seu cartão.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Algo salió mal con su compra, comuníquese con la compañía de su tarjeta.';
            } else {
              this.error_message = 'Something went wrong with your purchase, please contact your card company.';
            }
            this.resetCheckout('ALL');
            break
          case 'INVALID_DATA':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Os dados do seu cartão foram inseridos incorretamente, verifique e tente novamente.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Los datos de su tarjeta se ingresaron incorrectamente, verifique e intente nuevamente.';
            } else {
              this.error_message = 'Your card details were entered incorrectly, please check and try again.';
            }
            this.resetCheckout('CARD');
            break
          case 'INVALID_CREDIT_CARD':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'O cartão usado está desabilitado, bloqueado ou está vencido, entre em contato com o banco ou emissor do cartão.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'La tarjeta utilizada está deshabilitada, bloqueada o vencida, comuníquese con su banco o emisor de la tarjeta.';
            } else {
              this.error_message = 'The card used is disabled, blocked or expired, contact your bank or card issuer.';
            }
            this.resetCheckout('ALL');
            break
          case 'INSUFFICIENT_FUNDS':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Não há limite suficiente, Tente com outro cartão ou método de pagamento.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'No hay suficiente límite, prueba con otra tarjeta o método de pago.';
            } else {
              this.error_message = 'There is not enough limit, Try with another card or payment method.';
            }
            this.resetCheckout('CARD');
            break
          case 'INVALID_PAYMENT_TYPE':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Método de pagamento inválido, tente com outro cartão ou método de pagamento.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Método de pago no válido, intente con otra tarjeta o método de pago.';
            } else {
              this.error_message = 'Invalid payment method, please try another card or payment method.';
            }
            this.resetCheckout('ALL');
            break
          case 'INVALID_INSTALLMENTS':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Número ou valor das parcelas não foi autorizado, tente com outro cartão ou método de pagamento.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Número o valor de cuotas no autorizadas, prueba con otra tarjeta o forma de pago.';
            } else {
              this.error_message = 'Number or value of installments not authorized, try with another card or payment method.';
            }
            this.resetCheckout('CARD');
            break
          case 'INVALID_INSTALLMENTS_BUMP':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Número de valor de parcelas não foi autorizado, não é permitido comprar mais de um produto sendo um deles assinatura e parcelar.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'No se ha autorizado el valor del número de cuotas, no se permite comprar más de un producto, uno de los cuales es suscripción y cuotas.';
            } else {
              this.error_message = 'Number of installments value has not been authorized, it is not allowed to buy more than one product, one of which is subscription and installments.';
            }
            this.resetCheckout('CARD');
            break
          case 'CURRENCY_NOT_SUPPORTED':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Moeda não suportada.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Moneda no admitida.';
            } else {
              this.error_message = 'Currency not supported.';
            }
            this.resetCheckout('CARD');
            break
          case 'SUSPECTED_FRAUD':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Transação não permitida - Entre em contato com o banco ou tente outra forma de pagamento';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Transacción no permitida: comuníquese con su banco o pruebe con otro método de pago';
            } else {
              this.error_message = 'Transaction not allowed - Contact your bank or try another payment method';
            }
            this.resetCheckout('ALL');
            break
          case 'SUSPECTED_INTERN_FRAUD':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Tente outra forma de pagamento ou entre em contato com o banco - Transação não permitida.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Pruebe con otro método de pago o comuníquese con su banco: transacción no permitida.';
            } else {
              this.error_message = 'Try another payment method or contact your bank - Transaction not allowed.';
            }
            this.resetCheckout('ALL');
            break
          case 'GENERIC':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Ocorreu um erro durante o processamento da compra, verifique os dados e tente novamente, em caso de falhas, faça contato conosco para maiores orientações.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Ocurrió un error al procesar la compra, verifique los datos e intente nuevamente, en caso de fallas, contáctenos para obtener más orientación.';
            } else {
              this.error_message = 'An error occurred while processing the purchase, please check the data and try again, in case of failures, please contact us for further guidance.';
            }
            this.resetCheckout('ALL');
            break
          case 'EXPIRED_RATE_TOKEN':
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Erro na compra, tente novamente.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Error de compra, inténtalo de nuevo.';
            } else {
              this.error_message = 'Purchase error, please try again.';
            }
            break
          default:
            if (country === 'BR' || country === 'PT') {
              this.error_message = 'Ocorreu um erro durante o processamento da compra, verifique os dados e tente novamente, em caso de falhas, faça contato conosco para maiores orientações.';
            } else if (this.validateEspanholError()) {
              this.error_message = 'Ocurrió un error al procesar la compra, verifique los datos e intente nuevamente, en caso de fallas, contáctenos para obtener más orientación.';
            } else {
              this.error_message = 'An error occurred while processing the purchase, please check the data and try again, in case of failures, please contact us for further guidance.';
            }
            break
        }
        // this.charge_error = true;
      } else {
        if (response && response.shipping) {
          this.error_message = response.shipping[0];
        } else if (response && response.email) {
          if (country === 'BR' || country === 'PT') {
            this.error_message = 'O campo email não contém um endereço de email válido.';
          } else if (this.validateEspanholError()) {
            this.error_message = 'El campo de correo electrónico no contiene una dirección de correo electrónico válida.';
          } else {
            this.error_message = 'The email field does not contain a valid email address.';
          }
        } else if (response && response.product) {
          this.error_message = response.product[0];
        } else {
          if (country === 'BR' || country === 'PT') {
            this.error_message = 'Ocorreu um erro durante o processamento da compra, tente novamente mais tarde.';
          } else if (this.validateEspanholError()) {
            this.error_message = 'Ocurrió un error al procesar la compra, inténtalo de nuevo más tarde.';
          } else {
            this.error_message = 'An error occurred while processing the purchase, please try again later.';
          }
        }
      }

      // notificação
      this.$bvModal.show('alert-modal');

      // registrando log de error
      GreennLogs.logger.info('🔴  Error Compra', {
        name: 'Erro na Compra',
        product_id: this.product.id,
        error_code: response ? response.code : null,
        error_mensage: this.error_message,
      });

      this.r3t();
    },
    purchaseCreditCard: async function(
      amount,
      product_type,
      installments,
      product_id,
      proposal_id,
      cards,
      bump_id
    ) {
      if (
        this.product.seller.is_heaven &&
        this.checkoutPayment.base_currency !== 'BRL' &&
        (
          this.countryGlobal === 'US' ||
          this.countryGlobal === 'PT' ||
          this.countryGlobal === 'ES' ||
          this.countryGlobal === 'FR' ||
          this.countryGlobal === 'IT' ||
          this.countryGlobal === 'JP' ||
          this.countryGlobal === 'MY' ||
          this.countryGlobal === 'UK' ||
          this.countryGlobal === 'DE'
        )
      ) {
        installments = 1;
        this.installments = 1;
      }
      if (this.method === 'CREDIT_CARD') {
        cards[0].amount -= this.totalBumpSubscription;
      }
      var data = {
        method: this.method,
        language: this.$i18n.locale,
        total: this.getInstallments(this.installments, true) * this.installments - this.shipping.amount,
        product_type: product_type,
        // product_id: product_id,
        products: this.products_list,
        amount: this.amount,
        cards: cards,
        installments: installments,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.countryGlobal === 'OUTROS' ? this.countryGlobalSettings : this.countryGlobal,
        captcha: this.captcha_code,
        zipcode: this.data.zipcode ? this.data.zipcode.replace(/[-]/g, '') : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        gateway: "MERCADOPAGO"
      };
      if (this.data.gateway !== "MERCADOPAGO") delete data.gateway;
      if (
        this.product_type == 'COMMON'
          ? this.product.is_checkout_address
          : this.product.product.is_checkout_address
      ) {
        data.zipcode = this.data.zipcode
          ? this.data.zipcode.replace(/[-]/g, '')
          : null;
        data.street = this.data.street;
        data.number = this.data.number;
        data.complement = this.data.complement;
        data.neighborhood = this.data.neighborhood;
        data.city = this.data.city;
        data.state = this.data.state;
      }

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if ((this.is_produto_fisico || this.hasPhysicalProduct) && this.product.method !== 'FREE') {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, '')
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee) {
          // adicionando frete ao total
          data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        }
      }

      data.total = parseFloat(data.total.toFixed(2));

      if (typeof proposal_id != 'undefined' && proposal_id != null) {
        data.proposal_id = proposal_id;
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      if (typeof bump_id != 'undefined' && bump_id != null) {
        data.bump_product_id = bump_id;
        data.bump_amount = this.bump.amount;
      }

      // Check if there's meta tags
      if (
        typeof this.metas != 'undefined' &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // set currency conversion data
      data.rate = this.rate;

      const currency_data = {
        local_currency: this.rate.target_currency || 'BRL',
        base_currency: this.rate.base_currency || 'BRL'
      };
      data.currency_data = currency_data;

      // registrando log do objeto com os dados de compra
      if (
        this.method == 'CREDIT_CARD' ||
        this.method == 'TWO_CREDIT_CARDS' ||
        this.method == 'DEBITCARD'
      ) {
        this.dataLog = Object.assign(
          {
            cartoes: [],
          },
          data
        );
        // enviando amount junto dos dados para analises
        this.dataLog.cartoes.push({
          amount: data.cards[0].amount,
          cvv: '###',
          holder_name: data.cards[0].card_holder_name,
          expiration_date: data.cards[0].card_expiration_date,
          number: `#### #### #### ${
            data.cards[0].card_number.split(' ')[
              data.cards[0].card_number.split(' ').length - 1
            ]
          }`,
        });

        if (this.method == 'TWO_CREDIT_CARDS') {
          this.dataLog.cartoes.push({
            amount: data.cards[1].amount,
            cvv: '###',
            holder_name: data.cards[1].card_holder_name,
            expiration_date: data.cards[1].card_expiration_date,
            number: `#### #### #### ${
              data.cards[1].card_number.split(' ')[
                data.cards[1].card_number.split(' ').length - 1
              ]
            }`,
          });
        }
        delete this.dataLog.cards;
      } else {
        this.dataLog = Object.assign({}, data);
      }

      GreennLogs.logger.info('🟡 Dados da Compra', {
        name: 'Enviando objeto da compra [CARTAO]',
        objetoCompra: JSON.stringify(this.dataLog),
      });


     
      let promises = [];
      // Iterar sobre cada cartão e criar uma promessa para cada um
      let errorRequestCard = false;
      if(data.cards ){
        
        let gateway = this.getGateway(this.product.type, this.method, this.product.global_settings, data.installments, this.product.seller.recipientIsActivated);
        
        if(data.country_code === 'BR'){
          gateway = 'IUGU'
        }
        
        if (gateway) {
          data.gateway = gateway;
        }

          for (let i = 0; i < data.cards.length; i++) {
            if (
              data.cards[i] &&
              data.cards[i].card_number &&
              data.cards[i].card_holder_name &&
              data.cards[i].card_expiration_date &&
              data.cards[i].card_number != undefined
            ) {
              let amount = data.cards[i].amount; // Armazenar o valor do campo amount
              let total = data.cards[i].total; // Armazenar o valor do campo total
              
              let dataGateway = {
                system: 'CHECKOUT',
                gateway: gateway,
                card: {
                  holder_name:  data.cards[i].card_holder_name,
                  number:  data.cards[i].card_number.replace(/\s/g, ''),
                  exp_month:   data.cards[i].card_expiration_date ? data.cards[i].card_expiration_date.substring(0, 2) : null ,
                  exp_year: data.cards[i].card_expiration_date.substring(4),
                  cvv: data.cards[i].card_cvv,
                  costumer: this.customerData(data)
                }
              };
              
              // Criar a promessa e armazená-la no array de promessas
              let promise = this.cardGateway(dataGateway).then(responseGateway => {
                // Atualizar o objeto data.cards[i] mantendo os campos amount e total
                if(data.cards){
                  data.cards[i] = {
                    id: responseGateway.id,
                    last_digits: responseGateway.data ? responseGateway.data.last_digits : responseGateway.last_digits,
                    first_digits:  responseGateway.data ? responseGateway.data.first_digits : responseGateway.first_digits,
                    customer: responseGateway.customer || null, amount,
                    total
                  };
                }
              })
              .catch(error => {
                errorRequestCard = true;
                // Tratar erros
                console.error(error);
              });        
              promises.push(promise);
            }
          }
        }

      // Aguardar a resolução de todas as promessas usando Promise.all()
      return Promise.all(promises)
        .then(() => {
          if(!errorRequestCard){
            return servicePayment.create(data);
          }
        })
        .catch(error => {
            // Se ocorrer um erro em qualquer uma das promessas ou na criação do pagamento, ele será capturado aqui
            console.error("Erro:", error);
            throw error; // Lança novamente o erro para a função que contém este código
      });
    },
    paymentPayPal: async function(
      product_type,
      product_id,
      amount,
      bump_amount,
      paypal
    ) {
      var data = {
        method: 'PAYPAL',
        language: this.$i18n.locale,
        product_type: product_type,
        amount: amount,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: null,
        bump_product_id: null,
        bump_amount: bump_amount,
        paypal: paypal,
        zipcode: this.data.zipcode
          ? this.data.zipcode.replace(/[-]/g, '')
          : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
        captcha: this.captcha_code
      };

      if (this.$route.params.hash) {
        data.offer_hash = this.$route.params.hash;
        data.products[0].product_offer = this.$route.params.hash;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // Check if there's meta tags
      if (
        typeof this.metas != 'undefined' &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // set currency conversion data
      data.rate = this.rate;

      const currency_data = {
        local_currency: this.rate.target_currency || 'BRL',
        base_currency: this.rate.base_currency || 'BRL'
      };
      data.currency_data = currency_data;

      // Registrando log paypal
      this.dataLog = Object.assign({}, data);

      GreennLogs.logger.info('🟡 Dados da Compra', {
        name: 'Enviando objeto da compra [PAYPAL]',
        objetoCompra: JSON.stringify(this.dataLog),
      });

      return await servicePayment.create(data);
    },
    buildTicket: async function(
      product_type,
      product_id,
      amount,
      proposal_id,
      bump_product_id,
      bump_amount
    ) {
      var data = {
        method: this.method,
        language: this.$i18n.locale,
        total:
          this.getInstallments(this.installments_boleto) *
          this.installments_boleto,
        product_type: product_type,
        amount: amount,
        installments: this.permite_parcela_boleto > 1 ? this.installments_boleto : 1,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: proposal_id,
        bump_product_id: bump_product_id,
        bump_amount: bump_amount,
        zipcode: this.data.zipcode ? this.data.zipcode.replace(/[-]/g, '') : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
        captcha: this.captcha_code,
      };

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if (this.method === 'EFT') {
        data.eft_code = this.bank_type;
      }

      if ((this.is_produto_fisico || this.hasPhysicalProduct) && this.product.method !== 'FREE') {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, '')
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee && !this.isFixedShipping) {
          // adicionando frete ao total
          // data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        } else {
          data.shipping_amount = this.product.amount_fixed_shipping_fee;
        }
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }

      // Check if there's meta tags
      if (
        typeof this.metas != 'undefined' &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // set currency conversion data
      data.rate = this.rate;

      const currency_data = {
        local_currency: this.rate.target_currency || 'BRL',
        base_currency: this.rate.base_currency || 'BRL'
      };
      data.currency_data = currency_data;

      // Registrando log boleto
      this.dataLog = Object.assign({}, data);

      GreennLogs.logger.info('🟡 Dados da Compra', {
        name: 'Enviando objeto da compra [BOLETO]',
        objetoCompra: JSON.stringify(this.dataLog),
      });

      return await servicePayment.create(data);
    },
    buildPix: async function(
      product_type,
      product_id,
      amount,
      proposal_id,
      bump_product_id,
      bump_amount
    ) {
      var data = {
        method: 'PIX',
        language: this.$i18n.locale,
        total: amount + this.valueOfSelectedBumps,
        product_type: product_type,
        amount: amount,
        product_id: product_id,
        products: this.products_list,
        name: this.data.name,
        email: this.data.email,
        cellphone: this.data.cellphone,
        document: this.data.document,
        client_statistics: this.client_statistics,
        proposal_id: proposal_id,
        bump_product_id: bump_product_id,
        bump_amount: bump_amount,
        zipcode: this.data.zipcode ? this.data.zipcode.replace(/[-]/g, '') : null,
        street: this.data.street,
        number: this.data.number,
        complement: this.data.complement,
        neighborhood: this.data.neighborhood,
        city: this.data.city,
        state: this.data.state,
        uuid: this.capture.uuid,
        upsell_id: this.upsell_id,
        country_code: this.country_code,
        captcha: this.captcha_code,
      };

      if (this.$route.params.hash) {
        data.products[0].product_offer = this.$route.params.hash;
      }

      if ((this.is_produto_fisico || this.hasPhysicalProduct) && this.product.method !== 'FREE') {
        data.shipping_address_zip_code = this.shipping.address.zipcode
          ? this.shipping.address.zipcode.replace(/[-]/g, '')
          : null;
        data.shipping_address_street = this.shipping.address.street;
        data.shipping_address_number = this.shipping.address.number;
        data.shipping_address_complement = this.shipping.address.complement;
        data.shipping_address_neighborhood = this.shipping.address.neighborhood;
        data.shipping_address_city = this.shipping.address.city;
        data.shipping_address_state = this.shipping.address.state;

        if (this.data.has_shipping_fee && !this.isFixedShipping) {
          // adicionando frete ao total
          data.total += this.shipping.amount;

          data.shipping_amount = this.shipping.amount;
          data.shipping_service_name = this.shipping.service_name;
          data.shipping_service_id = this.shipping.service_id;
          // todos dados do frete
          data.shipping_selected = JSON.stringify(this.shipping);
        } else {
          data.shipping_amount = this.product.amount_fixed_shipping_fee;
        }
      }

      // cupom
      if (this.cupom_checkout && this.cupom_valid) {
        data.products[0].coupon = this.cupom_checkout.toUpperCase();
      }

      // produto fisico / presente
      if (this.data.is_gift) {
        data.is_gift = this.data.is_gift;
        data.gift_message = this.data.gift_message;
      }
      // Check if there's meta tags
      if (
        typeof this.metas != 'undefined' &&
        Object.keys(this.metas).length > 0
      ) {
        data.metas = this.metas;
      }

      // Check if there's affiliate with this product
      if (this.affiliate_id != null) {
        data.affiliate_id = this.affiliate_id;
      }

      // set currency conversion data
      data.rate = this.rate;

      const currency_data = {
        local_currency: this.rate.target_currency || 'BRL',
        base_currency: this.rate.base_currency || 'BRL'
      };
      data.currency_data = currency_data;

      // Registrando log pix
      this.dataLog = Object.assign({}, data);

      GreennLogs.logger.info('🟡 Dados da Compra', {
        name: 'Enviando objeto da compra [PIX]',
        objetoCompra: JSON.stringify(this.dataLog),
      });

      return await servicePayment.create(data);
    },
    getWdToken() {
      try {
        return document.querySelector('[data-wd]').getAttribute('data-wd');
      } catch (error) {
        return 'dom_read_error';
      }
    },
    getProduct(slug, pais) {
      return new Promise((resolve) => {
        let data = { id: slug };

        if (this.$route.params.hash) {
          data.id = slug + '/offer/' + this.$route.params.hash;
        }

        const country = pais || this.$route.query.country || null
        if (country) data.id = data.id + '?country=' + (country === 'OUTROS' ? this.countryGlobalSettings : country)

        serviceCheckout
          .readAll(data)
          .then((response) => {
            const token_header = {
              'controller-token-': response.headers['controller-token-'],
              'requestray-token-': response.headers['requestray-token-'],
              'firewall-token-': response.headers['firewall-token-'],
              'cache-token-': response.headers['cache-token-'],
              'trans-token-': response.headers['trans-token-'],
              'wd-token-': this.getWdToken(),
            };

            if(this.$route.query.country) {
              this.setLocale(this.$route.query.country);
            }

            this.$store.commit('UPDATE_TOKEN', token_header);
            return JSON.parse(response.data);
          })
          .then((response) => {
            this.$store.dispatch('getFlags',response.data.is_dlocal);
            this.checkoutPayment = response.checkout_payment;
            this.allow_free_offers = response.allow_free_offers === 'ENABLED';
            if (
              this.checkoutPayment &&
              this.checkoutPayment.data &&
              this.checkoutPayment.data.amount
            ) {
              response.data.amount = this.checkoutPayment.data.amount;
              this.mountedProduct(response.data, response.type);
            }
            if (!this.$store.state.mounted) {
              this.mountedProduct(response.data, response.type);
            }

            // set local variabel with currency conversion data
            this.rate = {
              target_currency: response.checkout_payment.data.to,
              base_currency: response.checkout_payment.data.from,
              token: response.checkout_payment.token,
            };
          })
          .then(() => resolve(true))
          .catch((err) => {
            console.error(err);
            resolve(true);
            this.removePreload(true);
          });
      });
    },
    getProposal(id_proposta) {
      serviceProposal
        .readAll({ id: id_proposta })
        .then((response) => {
          const token_header = {
            'controller-token-': response.headers['controller-token-'],
            'requestray-token-': response.headers['requestray-token-'],
            'firewall-token-': response.headers['firewall-token-'],
            'cache-token-': response.headers['cache-token-'],
            'trans-token-': response.headers['trans-token-'],
            'wd-token-': this.getWdToken(),
          };

          this.$store.commit('UPDATE_TOKEN', token_header);
          return JSON.parse(response.data);
        })
        .then((response) => {
          if (response.name) {
            if (!this.$store.state.mounted) {
              this.mountedProduct(response, 'PROPOSAL');
            }
          } else {
            document.querySelector('.carregando').classList.add('erro', 'prop');
          }
        })
        .catch((err) => {
          console.error(err);
          document.querySelector('.carregando').classList.add('erro', 'prop');
        });
    },
    mountedProduct(product, type) {
      // recreate paypal link with currency and correct token
      if(product.type !== 'SUBSCRIPTION') {

        // valida se o produtor/vendedor tem permissão para venda no internacional
        let client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL
        if(this.countryGlobal !== 'BR' && (this.isHeaven || this.product.seller.is_heaven)) {
          client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL
        }

        if(document.getElementById('paypal_id')) document.getElementById('paypal_id').remove()
        let script = document.createElement('script')
        script.id = 'paypal_id'
        if(this.checkoutPayment)
          if(this.checkoutPayment.paypal) {
            script.src =
              'https://www.paypal.com/sdk/js?client-id=' +
              client_id +
              `&currency=${this.checkoutPayment.paypal.currency}&disable-funding=credit,card,mercadopago`
          }
        document.body.appendChild(script)

        // get paypal data
        this.paypal.amount = this.checkoutPayment.paypal.amount
        this.paypal.original_amount = this.checkoutPayment.paypal.amount
        this.paypal.currency = this.checkoutPayment.paypal.currency
        this.paypal.symbol_currency = this.checkoutPayment.paypal.symbol_currency
      }

      // rodapé
      this.has_greenn_me = document.URL.includes('https://pay.greenn.me');

      this.$store.commit('UPDATE_MOUNTED', true);
      this.product_type = type;
      this.product = product;
      this.allowed_methods = product.method;

      this.amount = this.hasCustomCharges ? this.customCharges[0].amount : this.product.amount;

      this.currency_id = this.product.currency_id;

      // cupom de desconto
      this.permite_cupom = this.product.allowed_coupon;

      if(this.permite_cupom && this.cupom_checkout) {
        this.$refs.Cupom.id_product = this.product.product_id || this.product.id
        setTimeout(() => {
          this.$refs.Cupom.collapse = true
          this.$refs.Cupom.cupom_active = true
          this.$refs.Cupom.cupom = this.cupom_checkout
          this.$refs.Cupom.checkCupom()
        }, 100)
      }

      // validando status changed
      if (this.product.status == 'CHANGED') {
        this.product.status = 'APPROVED';
      }

      this.original_amount = this.product.amount;

      this.isHeaven
        ? document.title = `${this.product.name} | Heaven Pay`
        : document.title = `${this.product.name} | Greenn Pay`

      // juros vendedor
      this.sem_juros = this.product.no_interest_installments;

      // produto fisico
      this.is_produto_fisico = this.product.format === 'PHYSICALPRODUCT'

      this.data.has_shipping_fee = this.product.has_shipping_fee;

      if (
        (this.product.format == 'PHYSICALPRODUCT' &&
          !this.product.in_stock) ||
        !this.product.is_active
      ) {
        this.product.status = 'DISAPPROVED';
      }

      this.products_list = [];

      this.products_list.push({
        product_id: this.product.id || +this.$route.params.product,
        proposal_id: +this.$route.query.prop_id || null,
      });

      // if (this.product.status != "APPROVED") {
      //   this.error_message =
      //     "Este produto não está disponível para pagamento.";
      //   this.charge_error = true;
      // }

      this.product.banner_checkout = null;

      var product_id = this.product.id;
      var seller_id = this.product.seller_id;
      this.capture.seller_id = this.product.seller_id;

      // permite parcelamento de boleto
      this.permite_parcela_boleto = this.product.max_boleto_installments
        ? this.product.max_boleto_installments
        : 0;

      // permite parcelamento de assinatura
      this.permite_parcela_assinatura = this.product
        .max_subscription_installments
        ? this.product.max_subscription_installments
        : 0;

      // metodos de pagamento
      this.product.method = this.product.method
        ? this.product.method
        : 'CREDIT_CARD,PIX,BOLETO,PAYPAL,TWO_CREDIT_CARDS';

      if (this.product.format && this.product.has_shipping_fee) {
        const method = this.product.method.split(',');
        const index = method.indexOf('PAYPAL');
        if (index > -1) {
          method.splice(index, 1);
        }

        this.product.method = method.toString();
        this.permite_parcela_boleto = false;
      }

      if(this.product.method !== 'FREE') {
        if (
          this.product.method.includes('CREDIT_CARD') ||
          this.product.method.includes('ALL')
        ) {
          this.method = 'CREDIT_CARD';
          this.$nextTick(() => {
            try {
              document.querySelector('.CREDIT_CARD').click();
            } catch (error) {
              const splitMethod = this.product.method.split(',')[0];
              document.querySelector(`.${splitMethod}`).click();
            }
          });
        } else {
          this.$nextTick(() => {
            try {
              const splitMethod = this.product.method.split(',')[0];
              document.querySelector(`.${splitMethod}`).click();
            } catch (error) {
              document.querySelector('.CREDIT_CARD').click();
            }
          });
        }
      }

      if(this.countryGlobal === 'OUTROS') {
        this.product.method = 'CREDIT_CARD'
        this.method = 'CREDIT_CARD'
        document.querySelector('.CREDIT_CARD').click()
      }

      if (
        this.product.type == 'SUBSCRIPTION' &&
        this.product.period > 30 &&
        this.permite_parcela_assinatura > 1
      ) {
        this.installments = this.product.max_subscription_installments;
      }

      if (this.product.type == 'SUBSCRIPTION' && this.product.period == 30) {
        this.installments = 1;
      }

      // quantidade de parcelas
      if (this.product.type == 'TRANSACTION') {
        this.product.max_installments = this.product.max_installments || 12;
        this.installments = this.product.max_installments;
      }

      // parcelas fixas
      if (this.product.fixed_installments) {
        this.parcela_fixa = this.product.fixed_installments;
        this.installments = this.product.fixed_installments;
      }

      if (this.product.status_product === 'CHANGED') {
        this.product.status_product = 'APPROVED';
      }

      if (this.product.status_offer === 'PENDING') {
        this.product.status_offer = 'APPROVED';
      }

      if (
        !['APPROVED','PRE_APPROVED','REVISION'].includes(this.product.status_product) ||
        this.product.status_offer != 'APPROVED' ||
        this.product.is_active === 0 ||
        ((!this.allow_free_offers) && this.product.method == 'FREE')
      ) {
        this.error_message = 'Este produto não está disponível para pagamento.';
        this.charge_error = true;
      }

      if (this.product.pre_selected_installment) {
        this.installments = this.product.pre_selected_installment;
      }

      // this.setSocialProve(this.product);

      // produto fisico
      this.data.billing_shipping_same_address = this.is_produto_fisico;

      this.products_client_statistics = [
        ...this.products_list,
        ...this.products_client_statistics,
      ];
      if (this.isFixedShipping && this.product.has_shipping_fee) {
        this.productHasShipping({ 
          ...this.product,
          shipping: {
            shipping_amount: this.product.amount_fixed_shipping_fee
          }
        });
      }

      if (this.product.affiliation_lead) {
        this.affiliate_id = +Cookies.get('affiliate');
      } 
      if (!this.product.affiliation_lead) { 
        this.affiliate_id = +Cookies.get('affiliate_' + product_id) || +this.$route.query.a_id;
      }
      this.setClientStatistics();

      // Load pixels
      this.getMetrics(product_id);

      this.getSellerSettings(seller_id);
      // Save client statistics

      // setando os dados de captura
      if (this.product_type == 'PROPOSAL') {
        this.capture.product_id = this.product.product.id;
      } else {
        this.capture.product_id = this.product.id;
      }
      this.capture.uuid = localStorage.getItem(
        `${this.capture.product_id}_user_uuid`
      );

      if (this.capture.uuid) {
        this.fetchCapture(this.capture);
        this.atualizaCapture(this.capture);
      } else {
        localStorage.setItem(`${this.capture.product_id}_user_uuid`, this.uuid);
        this.capture.uuid = localStorage.getItem(
          `${this.capture.product_id}_user_uuid`
        );
        this.createCapture(this.capture);
      }

      this.removePreload();
    },
    setSocialProve(product) {
      if (product.notify_views && product.views >= product.notify_views) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function() {
          vm.$bvToast.toast(
            product.views + ' pessoas visualizaram este produto.',
            {
              title: 'Visualizações',
              variant: 'info',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }
      if (
        product.notify_purchases &&
        product.purchases >= product.notify_purchases
      ) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function() {
          vm.$bvToast.toast(
            product.purchases + ' pessoas compraram este produto.',
            {
              title: 'Compras',
              variant: 'success',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }

      if (product.notify_amount && product.quantity <= product.notify_amount) {
        let random = parseInt(Math.random() * 100) % 20; // secounds
        let vm = this;
        setTimeout(function() {
          vm.$bvToast.toast(
            'Somente ' + product.quantity + ' produtos restantes.',
            {
              title: 'Quantidade',
              variant: 'warning',
              autoHideDelay: 5000,
              appendToast: true,
            }
          );
        }, random * 1000);
      }
    },
    getBump(slug, pais) {
      if (!slug) return;

      const query = this.$route.query;
      if (typeof slug == 'object') {
        this.products_client_statistics = [];
        for (let b in query.b_id) {
          this.getBump(query.b_id[b], this.countryGlobal);
          this.products_client_statistics.push({
            product_id: +query.b_id[b],
          });
        }
        return;
      }

      let data = { id: slug };

      if (this.b_offer && typeof this.$route.query.b_id == 'string') {
        data.id = slug + '/offer/' + this.b_offer;
      }

      if (pais) data.id = data.id + '?country=' + (pais === 'OUTROS' ? this.countryGlobalSettings : pais);
      this.bump_list = [];

      serviceProduct
        .read(data)
        .then((response) => {
          this.bump = response.data;

          let bump_is_a_approved = true

          // validando status changed
          if(this.bump.status == 'CHANGED') {
            this.bump.status = 'APPROVED'
          }
          if ((this.bump.format == 'PHYSICALPRODUCT' && !this.bump.in_stock) || !this.bump.is_active ) {
            this.bump.status = 'DISAPPROVED';
            bump_is_a_approved = false
          }
          if (this.bump.status_product === 'CHANGED') {
            this.bump.status_product = 'APPROVED';
          }

          if (this.bump.status_offer === 'PENDING') {
            this.bump.status_offer = 'APPROVED';
          }

          if (
            this.bump.status_product != 'APPROVED' ||
            this.bump.status_offer != 'APPROVED' ||
            this.bump.is_active === 0
          ) {
            bump_is_a_approved = false
          }

          if (
            response.checkout_payment &&
            response.checkout_payment.data &&
            response.checkout_payment.data.amount
          ) {
            response.data.amount = response.checkout_payment.data.amount;
            response.data.currency = response.checkout_payment.data.to;
          }

          response.data.paypal = response.checkout_payment.paypal;

          if(this.product.id !== response.data.id && bump_is_a_approved) this.bump_list.push(response.data);
        })
        .catch((err) => console.error(err))
        .finally(() => {
          let array = [];
          if (this.queryUrl.b_id.length > 0 && this.bump_list.length > 0) {
            if (Array.isArray(this.queryUrl.b_id)) {
              this.queryUrl.b_id.forEach((queryItem) => {
                this.bump_list.forEach((bumpItem) => {
                  if (parseInt(queryItem) === bumpItem.id) array.push(bumpItem);
                });
              });
            } else {
              this.bump_list.forEach((bumpItem) => {
                if (parseInt(this.queryUrl.b_id) === bumpItem.id)
                  array.push(bumpItem);
              });
            }
          }
          this.bump_list = array;
        });
    },
    getSellerSettings(user_id) {
      serviceSettings
        .read({ id: user_id })
        .then((response) => {
          response.forEach((element) => {

            if (element.key == 'BUY_BUTTON_TEXT') {
              this.buy_button_text = element.value;
            }

            if (element.key == 'MONTHLY_INTEREST') {
              this.monthly_interest = parseFloat(element.value);
            }
            
          });
        })
        .catch((err) => console.error(err));
    },
    getGlobalSettings() {
      serviceGlobalSettings
        .search({
          keys: ['PAGARME_ANTIFRAUDE', 'MONTHLY_INTEREST', 'CHECKOUT_CAPTCHA'],
        })
        .then((response) => {
          response.forEach((element) => {
            if (element.key == 'PAGARME_ANTIFRAUDE') {
              this.is_antifraude = element.value == 'ENABLED' ? true : false;
            }
            if (element.key == 'MONTHLY_INTEREST') {

              if (this.monthly_interest === 0) {
                this.monthly_interest = parseFloat(element.value);
              }
            }
            if (element.key == 'CHECKOUT_CAPTCHA') {
              this.captcha = element.value == 'ENABLED' ? true : false;
            }
          });

          this.countryGlobalSettings = [...response].find((item) => item.country);
          this.countryGlobalSettings = this.countryGlobalSettings ? this.countryGlobalSettings.country : 'US';
          this.countryGlobal = this.countryGlobalSettings

          if(this.$route.query.country) {
            this.countryGlobal = this.$route.query.country;
            delete this.$route.query.country;

            var currentUrl = window.location.href;
            var urlParts = currentUrl.split("?");
            if (urlParts.length > 1) {
              var queryParams = urlParts[1].split("&");
              var updatedQueryParams = queryParams.filter(function (param) {
                return !param.startsWith("country=");
              });
              var newUrl = urlParts[0] + (updatedQueryParams.length > 0 ? "?" + updatedQueryParams.join("&") : "");
              window.history.replaceState({}, document.title, newUrl);
            }
          }

          this.redirectOfferPanel(this.countryGlobal);

          // paypal
          let script = document.createElement('script')
          let client_id = process.env.PAYPAL_CLIENT_ID_NATIONAL
          if(this.countryGlobal !== 'BR' && (this.isHeaven || this.product.seller.is_heaven)) {
            client_id = process.env.PAYPAL_CLIENT_ID_INTERNATIONAL
          }
          script.id = 'paypal_id'
          script.src =
            'https://www.paypal.com/sdk/js?client-id=' +
            client_id +
            '&currency=BRL&disable-funding=credit,card,mercadopago'
          document.body.appendChild(script)
        })
        .catch((err) => {
          this.countryGlobal = 'BR'
          console.error(err)
        })
        .finally(() => this.setLocale(this.countryGlobal))
    },
    getMetrics(product_id) {
      let data = { id: product_id };

      if (this.affiliate_id) data.id = data.id + '?a_id=' + this.affiliate_id;
      
      if (this.affiliate) data.id = data.id + '?a_id=' + this.affiliate;

      const pixels =
        this.product_type == 'COMMON'
          ? this.product.pixels
          : this.product.product.pixels;

      const hasTagManager =
        pixels && pixels.length
          ? pixels.filter((item) => item.type == 'GOOGLETAGMANAGER')
          : [];

      // fluxo tagmanager manual
      if (hasTagManager.length) {
        hasTagManager.forEach((item) => {
          (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', item.pixel_id);
        });

        // enviando o evento de checkout para o tagmanager
        this.onCheckoutEvent(
          this.product_type == 'COMMON' ? this.product : this.product.product
        );
      }

      window.pixel.handleEvent(
        'view',
        product_id,
        this.affiliate_id,
        this.method,
        this.amount,
        this.original_amount
      );

      if (this.debugPixel) {
        window.pixel.handleEvent(
          'conversion',
          product_id,
          this.affiliate_id,
          this.method,
          this.amount,
          this.original_amount,
          this.data.email,
          this.data.cellphone
        );
      }
    },
    setClientStatistics() {
      var parser = new UAParser();
      let result = parser.getResult();

      let data = {
        device_type: result.device_type,
        device_vendor: result.device_vendor,
        engine: result.engine.name,
        browser: result.browser.name,
        os: result.os.name,
        cpu: result.cpu.architecture,
        ua: result.ua,
        affiliate_id: this.affiliate_id ? this.affiliate_id : null,
        products: this.products_client_statistics,
      };

      if (this.product_type == 'COMMON') {
        data.product_id = this.product.id;
        data.seller_id = this.product.seller_id;
      } else if (this.product_type == 'PROPOSAL') {
        data.product_id = this.product.product.id;
        data.proposal_id = this.product.id;
        data.seller_id = this.product.product.seller_id;
      }

      serviceClientStatistics
        .create(data)
        .then((response) => {
          if (response.length > 1) {
            this.client_statistics = [...response].map((item) => item.id);
          } else this.client_statistics = [response[0].id];
        })
        .catch((err) => console.error(err));
    },
    getBanks() {
      serviceGateway
        .create({ country: 'CO' }, '/banks')
        .then((response) => {
          this.external_banks = response;
          this.bank_type = response[0].code;
        })
        .catch((err) => console.error(err));
    },
    showBtn(metodo) {
      if (metodo === 'EFT') {
        this.getBanks();
      }
      this.clickTab(metodo);
      this.btn_paypal = false;
    },
    async validateForm() {
      if (this.btn_paypal == true) {
        this.submit = true;
        // validando com a função
        if (await this.validateAllForm()) {
          if (
            document.getElementsByClassName('paypal-buttons-context-iframe')
              .length == 0
          ) {
            this.renderPaypal(true);
          }
          this.paypal_true = true;
        } else {
          this.paypal_true = false;
        }
      }
    },
    convertCurrency(amount) {
      const roundedAmount = Number(amount.toFixed(2));

      return roundedAmount;
    },
    renderPaypal(getCaptcha = false) {
      this.data.cellphone = this.results_tel.formattedNumber
      this.loaded = true
      this.btn_paypal = true
      this.clickTab('PAYPAL')

      if (
        document.getElementsByClassName('paypal-buttons-context-iframe').length == 0 &&
        this.paypal_true == true &&
        !this.hasBumpSelected &&
        getCaptcha
      ) {
        this.paypal.amount = this.convertCurrency(this.paypal.amount)
        this.paypal.original_amount = this.convertCurrency(this.paypal.original_amount)

        window.paypal
          .Buttons({
            locale: 'pt_BR',
            style: {
              size: 'responsive',
              color: 'black',
              label: 'buynow',
              branding: true,
            },
            onClick: (data, actions) => {
              actions.reject();
              this.submit = true;
              this.$validator.validateAll().then(async (result) => {
                if (result) {
                  return actions.resolve();
                } else {
                  actions.close();
                }
              });
            },
            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [
                  {
                    description: this.product.name,
                    amount: {
                      value: this.paypal.amount,
                      currency_code: this.paypal.currency,
                    },
                    reference_id: JSON.stringify({
                      product_id: this.product.id,
                      affiliate_id: this.capture.affiliate_id,
                      seller_id: this.product.seller_id,
                      proposal_id: this.capture.proposal_id,
                      offer_hash: this.product.hash || null,
                      rate: this.rate.token,
                      country: this.countryGlobal,
                      email: this.data.email,
                    }),
                  },
                ],
                application_context: {
                  shipping_preference: 'NO_SHIPPING',
                },
              });
            },
            onApprove: async (data, actions) => {
              this.loading = true
              // This function captures the funds from the transaction.
              this.resultPaypal = await actions.order
                .capture()
                .then(function(details) {
                  return details
                })
              this.$refs.CaptchaPaypal.setCaptcha()
            },
            onError: (err) => {
              console.error(err);
              this.paymentError('PayPal');
            },
          })
          .render(this.$refs.paypal);
      }
      setTimeout(() => this.validateForm(), 1000);
    },
    removePreload(erro = false) {
      if (!erro) {
        try {
          if (this.product) {
            this.preload = false;
            this.loading = false;
            document.querySelector('body').classList.remove('preload');
          } else {
            document.querySelector('.carregando').classList.add('erro');
          }
        } catch {
          this.preload = false;
          this.loading = false;
          document.querySelector('body').classList.remove('preload');
        }
      } else {
        setTimeout(() => {
          document.querySelector('.carregando').classList.add('erro');
        });
      }
    },
    validateInstallments() {
      if (
        (this.method == 'CREDIT_CARD' || this.method == 'TWO_CREDIT_CARDS') &&
        ((this.product_type == 'COMMON' &&
          this.product.type == 'TRANSACTION') ||
          (this.product_type == 'PROPOSAL' &&
            this.product.product.type == 'TRANSACTION'))
      ) {
        if (
          this.countryGlobal === 'US' ||
          this.countryGlobal === 'PT' ||
          this.countryGlobal === 'ES' ||
          this.countryGlobal === 'FR' ||
          this.countryGlobal === 'IT' ||
          this.countryGlobal === 'JP' ||
          this.countryGlobal === 'MY' ||
          this.countryGlobal === 'UK' ||
          this.countryGlobal === 'GB' ||
          this.countryGlobal === 'DE' ||
          this.countryGlobal === 'OUTROS'
        ) {
          if (this.checkoutPayment.base_currency === 'BRL') {
            return true;
          }
          this.installments = 1;
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    validateSelectNotFixedInstallments() {
      if (
        this.countryGlobal === 'US' ||
        this.countryGlobal === 'PT' ||
        this.countryGlobal === 'ES' ||
        this.countryGlobal === 'FR' ||
        this.countryGlobal === 'IT' ||
        this.countryGlobal === 'JP' ||
        this.countryGlobal === 'MY' ||
        this.countryGlobal === 'UK' ||
        this.countryGlobal === 'GB' ||
        this.countryGlobal === 'DE' ||
        this.countryGlobal === 'OUTROS'
      ) {
        if (this.checkoutPayment.base_currency === 'BRL') {
          return true;
        }
        this.installments = 1;
        return false;
      }
      if (
        !this.parcela_fixa ||
        this.countryGlobal === 'CO' ||
        this.countryGlobal === 'CL' ||
        this.countryGlobal === 'MX' ||
        this.countryGlobal === 'PE' ||
        this.countryGlobal === 'UY'
      ) {
        return true;
      } else if (!this.parcela_fixa && this.countryGlobal === 'BR') {
        this.installments = this.product.pre_selected_installment;
        return true;
      } else return false;
    },
    showAddress() {
      return this.is_antifraude ||
        (this.product.is_checkout_address) ||
        (this.products_list.length > 1 &&
        this.bump_list.some(b => { if(b.is_checkout_address) return true }))
    },
    hidePaypal() {
      this.paypal_true = false;
      this.btn_paypal = false;
      const bumps = this.bump_list;
      this.bump_list = [];
      this.bump_list = bumps;
      this.$forceUpdate();
      this.forceRerender()
    },
    getResetLink() {
      const currentURL = new URL(window.location.href);
      const newSearchParams = new URLSearchParams();
      currentURL.searchParams.forEach((value, key) => {
        if (!key.startsWith('_rl_')) {
          newSearchParams.append(key, value);
        }
      });
      newSearchParams.set(
        '_rl_' +
          Math.random()
            .toString(36)
            .substring(2, 8),
        Math.random()
          .toString(36)
          .substring(2, 8)
      );
      currentURL.search = newSearchParams.toString();
      return currentURL.toString();
    },
    productHasShipping(product) {
      this.products_list.forEach(item => {
        if (item?.shipping_amount) {
          this.amount -= parseFloat(item.shipping_amount)
          this.original_amount -= parseFloat(item.shipping_amount)
        }
      })
      this.products_list = this.products_list.map(item => {
        if (item.product_id === product.id) {
          return { ...item, ...product.shipping }
        }
        return item
      })
      this.products_list.forEach(item => {
        if (item?.shipping_amount) {
          this.amount += parseFloat(item.shipping_amount)
          this.original_amount += parseFloat(item.shipping_amount)
        }
      })
    },
    /**
     * @returns {void}
     * @description This function get all order bumps and bumps offers from url.
     */
    getBumps(country = null){
      this.bump_list = [];
      // parse apenas dos params
      let searchParams = new URLSearchParams(this.$route.query);
      // instancia o array final
      let bumpsWithOffers = [];
      // regex para pegar ids dos bumps
      let bumpRegex = new RegExp('(b_id_)(\\d*$)', 'i');
      // regex para pegar o hash das ofertas
      let offerRegex = new RegExp('(b_offer_)(\\d*$)', 'i');
      // passamos uma vez apenas pegando o id dos produtos
      searchParams.forEach((value, key) => {
        let matches = key.match(bumpRegex)
        if (matches) {
          // caso esteja repetido, ignoramos
          if(!bumpsWithOffers.find(item => item.bump_id === matches[2])) {
            // setamos o id do produto junto com a posicional para depois encontrar a oferta
            bumpsWithOffers.push({ bump_id: matches[2], product_id: value });
          }
        }
      })
      // passamos novamente pois temos certeza que os produtos estão no array
      searchParams.forEach((value, key) => {
        let matches = key.match(offerRegex)
        if (matches) {
          // pegamos o index do produto pelo id posicional dos elementos
          let indexOfBump = bumpsWithOffers.map(item => item.bump_id).indexOf(matches[2]);
          // caso exista
          if(bumpsWithOffers[indexOfBump]) {
            let bump = bumpsWithOffers[indexOfBump]
            bump.offer_hash = value
            // sobrescrevemos o objeto com id da oferta
            bumpsWithOffers[indexOfBump] = bump
          }
        }
      })

      if (bumpsWithOffers.length) {
        this.products_client_statistics = [];
        this.bump_list = [];
        bumpsWithOffers.forEach(bump => {
          this.getBumpProduct(bump, country)
        })
      }
    },
    /**
     * @param {String} product_id - this is product id
     * @param {String} offer_hash - this is offer of product, null by default
     */
    async getBumpProduct({ product_id, offer_hash = null, bump_id = 0 }, country = null) {
      this.products_client_statistics.push({ product_id });
      let data = {
        id: !offer_hash ? product_id : `${product_id}/offer/${offer_hash}`
      }
      if (country) data.id = data.id + '?country=' + (country === 'OUTROS' ? this.countryGlobalSettings : country)

      await serviceProduct
        .read(data)
        .then((response) => {

          const approvedStatus = ["APPROVED", "PRE_APPROVED", "REVISION"];
          let bump_is_a_approved = true

          if ((response.data.format == 'PHYSICALPRODUCT' && !response.data.in_stock) || !response.data.is_active ) {
            response.data.status = 'DISAPPROVED';
            bump_is_a_approved = false
          }

          if (response.data.status_offer === 'PENDING') {
            response.data.status_offer = 'APPROVED';
          }

          if (
            !approvedStatus.includes(response.data.status_product) ||
            !approvedStatus.includes(response.data.status_offer) ||
            response.data.is_active === 0
          ) {
            bump_is_a_approved = false
          }

          if (
            response.checkout_payment &&
            response.checkout_payment.data &&
            response.checkout_payment.data.amount
          ) {
            response.data.amount = response.checkout_payment.data.amount;
          }

          if (
            response.checkout_payment &&
            response.checkout_payment.paypal
          ) {
            response.data.paypal = response.checkout_payment.paypal;
          }

          if (this.product.id !== response.data.id && bump_is_a_approved){ 
            if(this.bump_list.some(x => x.id === response.data.id)) {
              const index = this.bump_list.indexOf(this.bump_list.find(x => x.id === response.data.id))
              this.bump_list.splice(index, 1, {...response.data, b_order: bump_id })
            } else {
              this.bump_list.push({...response.data, b_order: bump_id });
            }
            this.bump_list = this.bump_list.sort((bump1, bump2) => {
                return bump1.b_order - bump2.b_order;
            });
          }
        });
    },
    /**
     * @params {id} - this is product id
     * @params {isMainProduct} - check if is main product or a order bump 
     */
    isPhysicalProduct(id, isMainProduct) {
      if (isMainProduct) {
        return this.is_produto_fisico;
      }
      return this.bump_list.some(bump => bump.format === 'PHYSICALPRODUCT' && bump.id === id)
    },
    shippingAmountFormat(index, product) {
      if (index === 0) {
        if (this.data.has_shipping_fee) {
          if (product.shipping_amount) {
            return `${this.filterCurrency(this.currency_id)} ${this.formatMoney(product.shipping_amount)}`
          } else if (product.shipping_amount === 0) {
            return "Grátis"
          } else {
            return "a calcular"
          }
        }
      } else {
        if (this.bump_list.filter(prod => prod.id === product.product_id).pop().has_shipping_fee) {
          if (product.shipping_amount) {
            return `${this.filterCurrency(this.currency_id)} ${this.formatMoney(product.shipping_amount)}`
          } else if (product.shipping_amount === 0) {
            return "Grátis"
          } else {
            return "a calcular"
          }
        }
      }
      return "Grátis";
    },
    isReseted() {
      const currentURL = new URL(window.location.href);
      let isReseted = false;
      currentURL.searchParams.forEach((value, key) => {
        if (key.startsWith('_rl_')) {
          isReseted = true
        }
      });
      return isReseted;
    },
    getDistrictOptions(country) {
      return districtOptions(country)
    },
    calculateAmountAfterTrial() {
      if(this.parcela_fixa && this.themeCheckout.trial_info == 'fixa') {
        return `${this.parcela_fixa}x de ${this.filterCurrency(this.currency_id)} ${this.formatMoney(this.getInstallments(this.parcela_fixa))}`
      } else {
        if(this.product.shipping_fee_is_recurring) {
          if(this.product.type_shipping_fee === "FIXED") {
            return `${this.filterCurrency(this.currency_id)} ${this.formatMoney(this.product.amount + this.product.amount_fixed_shipping_fee)}`
          } else {
            return `${this.filterCurrency(this.currency_id)} ${this.formatMoney(this.product.amount + this.shipping.amount)}`
          }
        } else {
          return `${this.filterCurrency(this.currency_id)} ${this.formatMoney(this.product.amount)}`
        }
      }
    },
    getGateway(type, metodo,global_settings, installments , recipientIsActivated) {
      
      //concatena type com method tranformando em letras Maiúsculas
      let gatewayKey = `${type.toUpperCase()}_${metodo.toUpperCase()}`;
      let result = "";

      switch (gatewayKey) {
        case 'TRANSACTION_CREDIT_CARD':
        case 'SUBSCRIPTION_CREDIT_CARD':
        case 'TRANSACTION_TWO_CREDIT_CARDS':
        case 'SUBSCRIPTION_TWO_CREDIT_CARDS':
        case 'TRANSACTION_BOLETO':
        case 'SUBSCRIPTION_BOLETO':
          result = 'PAGARME';
        case 'TRANSACTION_PIX':
        case 'SUBSCRIPTION_PIX':
          result = 'IUGU';
        case 'SUBSCRIPTION_CREDIT_CARD_DLOCAL':
        case 'TRANSACTION_CREDIT_CARD_DLOCAL':
          result = 'DLOCAL';
        default:
          result = "";
      }

      if (global_settings && global_settings.length > 0) {
        // Faz um find dentro das configurações globais
          const databaseConfiguration = global_settings.find(config => config.key === gatewayKey);

          // Se encontrar, retorna o valor correspondente
          if (databaseConfiguration) {
            result = databaseConfiguration.value;
          }
      

          const gatewayLowInstallment = global_settings.find(config => config.key === 'TRANSACTION_CREDIT_CARD_LOW_INSTALLMENT');
          let valuegatewayLowInstallment = null;

          if(gatewayLowInstallment){
            valuegatewayLowInstallment = gatewayLowInstallment.value;

            if(installments && installments <=2){
              // Se encontrar, retorna o valor correspondente
              if (gatewayLowInstallment) {
                result = gatewayLowInstallment.value;
              }
            }

            if(result == 'PAGARME' && !recipientIsActivated && valuegatewayLowInstallment == 'IUGU'){
              result = 'IUGU';
            }
          }
      }

      if(result == ''){
        this.$bvToast.toast(this.$t("global_settings.error"), {
              title: this.$t("global_settings.title"),
              variant: "danger",
              autoHideDelay: 5000,
              appendToast: true,
            });
      }

      return result;
    },
    
    async cardGateway(dataGateway) {
      try {
        
        const response = await serviceGatewayHash.card(dataGateway);
        return response;
      } catch (error) {
        // Tratar erros
        if(error.data.type === 'INVALID_CREDIT_CARD'){
          this.$bvToast.toast("Não foi possível completar sua solicitação, configura seus dados ou tente novamente mais tarde.", {
          title: "",
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        }else{
          this.$bvToast.toast("Ocorreu um erro ao processar a sua solicitação. Por favor tente novamente mais tarde.", {
          title: "",
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        });
        }
        
        throw error; // Lançar o erro novamente para que ele possa ser tratado onde a função cardGateway() foi chamada
      }
    },
    documentType(data) {
      switch (this.country_code) {
        case 'BR':
          return data.document.length > 14 ? 'cnpj' : 'cpf';
        case 'MX':
          return 'RCF';
        case 'CL':
          return 'RUT';
        case 'UY':
          return 'CI';
        case 'ES':
          return 'DNI';
        case 'AR':
          switch (data.document.length) {
            case 8:
              return 'DNI';
            case 11:
              return 'CUIT/CUIL';
          }
        default:
          return null;
    }
    },
    customerData(data) {
      let document_number = data.document.replace(/\D/g, '');
      let document_type = this.documentType(data);
      let zipcodeFormatted = data.zipcode ? data.zipcode.slice(0, 5) + '-' + data.zipcode.slice(5) : null;

      let document = {};
          if (document_number) {
              document = {
                  document: {
                      type: document_type,
                      number: document_number,
                      document_type: document_type,
                      document_number: document_number
                  }
              };
          }

          let address = {};
          if (data.city) {
              address = {
                  address: {
                      street: data.street,
                      street_number: data.number,
                      state: data.state || data.uf,
                      city: data.city,
                      neighborhood: data.neighborhood,
                      zipcode: zipcodeFormatted
                  }
              };

              if (this.language && this.language !== 'pt' && this.country_code !== 'BR') {
                  delete address.address.zipcode;
              }
          }

          data.client_id = null; // Passando como nulo, pq até então o client não foi criado 
          return {
              external_id: String(data.client_id),
              name: data.name,
              phone: data.cellphone,
              email: data.email,
              document_number: document_number,
              document_type: document_type,
              ...document,
              ...address
          };
    }
  },
  async mounted() {
    let current_wd = document
      .querySelector('meta[data-wd]')
      .getAttribute('data-wd');
    GreennLogs.logger.info('Checkout mounted', {
      'data-wd': document
        .querySelector('meta[data-wd]')
        .getAttribute('data-wd'),
    });
    let stored_wd = window.localStorage.getItem('data-wd');
    if (!this.isReseted() || (stored_wd === current_wd && process.env.ENVIREMENT === 'production')) {
      GreennLogs.logger.info('Reloading Checkout', {
        'data-wd': document
          .querySelector('meta[data-wd]')
          .getAttribute('data-wd'),
      });
      window.location.href = this.getResetLink();
    } else {
      window.localStorage.setItem('data-wd', current_wd);
    }
    document.querySelector('body').classList.add('preload');
    this.preload = true;

    // last_seen // definido como 60 segundos
    setInterval(() => this.saveDataUser(), 1000 * 240);

    let query = this.$route.query;
    this.queryUrl = Object.assign({}, this.$route.query);
    this.getBumps();

    if (typeof query.up_id != 'undefined') {
      this.upsell_id = +query.up_id;
    }
    if (typeof query.cupom != 'undefined') {
      this.cupom_checkout = query.cupom;
      delete query.cupom;
    }
    if (typeof query.b != 'undefined') {
      this.business = true;
      delete query.b;

      // script jivochat
      const jivoScript = document.createElement('script');
      jivoScript.setAttribute(
        'src',
        '//code-eu1.jivosite.com/widget/J0jlVX87X9'
      );
      jivoScript.async = true;
      document.head.appendChild(jivoScript);
    }
    if (typeof query.force != 'undefined') {
      this.forceUrl = query.force == 'true' ? true : false;
      delete query.force;
    }
    if (typeof query.fn != 'undefined') {
      this.data.name = query.fn;
      this.queryUrl.fn = query.fn ? true : false;
      delete query.fn;
    }
    if (typeof query.em != 'undefined') {
      this.data.email = query.em;
      this.queryUrl.em = query.em ? true : false;
      delete query.em;
    }
    if (typeof query.ph != 'undefined') {
      this.data.cellphone = query.ph;
      this.yourValue = query.ph;
      this.queryUrl.ph = query.ph ? true : false;
      delete query.ph;
    }
    if (typeof query.document != 'undefined') {
      this.data.document = query.document;
      this.queryUrl.document = query.document ? true : false;
      delete query.document;
    }
    if (typeof query.debugPixel != 'undefined') {
      this.debugPixel = query.debugPixel == 'true' ? true : false;
      delete query.debugPixel;
    }
    if (typeof query.b_offer != 'undefined') {
      this.b_offer = query.b_offer;
      delete query.b_offer;
    }
    if (typeof query.a_id != 'undefined') {
      Cookies.set(`affiliate_${this.$route.params.product}`, query.a_id, {
        expires: 7,
        path: "/",
      });
    }
    if (typeof query.a_id != 'undefined') {
      Cookies.set(`affiliate`, query.a_id, {
        expires: 7,
        path: "/",
      });
    }
    if (
      typeof query.b_id != 'undefined' &&
      query.b_id != this.$route.params.product
    ) {
      if (typeof query.b_id == 'string') {
        this.getBump(query.b_id);
        this.products_client_statistics.push({
          product_id: +query.b_id,
        });
      } else if (typeof query.b_id == 'object') {
        for (let b in query.b_id) {
          this.getBump(query.b_id[b]);
          this.products_client_statistics.push({
            product_id: +query.b_id[b],
          });
        }
      }
    }

    this.metas = query;
    const slug = this.$route.params.product;
    if (slug && slug != 'undefined' && !query.prop_id && !query.ch_id) {
      await this.getProduct(slug);
    } else if (typeof query.prop_id != 'undefined') {
      this.getProposal(query.prop_id);
    } else if (typeof query.ch_id != 'undefined') {
      await this.getThemeCheckout(slug, query.ch_id);
    } else this.removePreload(true);

    this.getGlobalSettings();
    this.addSignifydSnippet();
    this.getResetCheckout();
  },
  created() {
    sanitizeUrl(this.$route);
    // window.addEventListener('mouseout', this.handleMouseOut);
    // window.addEventListener('touchend', this.handleTouchEnd);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    EventBus.$on('atualizaPais', (data) => {
      const currentCountry = data.locale === 'OUTROS' ? this.countryGlobalSettings : data.locale
      this.redirectOfferPanel(currentCountry)
      
      this.getProduct(
        this.product.id ?? this.$route.params.product,
        currentCountry
      );
      this.getBumps(data.locale)

      if (this.$route.query.b_id) {
        this.getBump(this.$route.query.b_id, data.locale);
      }

      this.preload = true;
      if (data.locale != 'BR') {
        this.etapa_total = 2;
        // selecionando o primeiro método
        if (this.method == 'BOLETO') {
          document.querySelector('.nav-link').click();
        }
      } else {
        if (this.possui_endereco) {
          this.etapa_total = 3;
        } else this.etapa_total = 2;
      }

      this.countryGlobal = data.locale;

      setTimeout(() => {
        this.preload = false;
      }, 1000);
    })
  }
}
</script>

<style scoped lang="scss">

.vue-country-select {
  height: 54px;
  min-height: 54px;
  border: 1px solid #e4e4ec !important;
}
.vue-country-select:hover {
  border: 1px solid rgb(0, 228, 160) !important;
  background-color: #fff;
}

.frete-remove-dot {
  list-style-type: none;
}

.btn-paypal {
  height: 55px;
  background-color: #000;
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  text-transform: none;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-paypal img {
  margin-right: 15px;
}
.icon-lock {
  color: var(--main-color);
  filter: brightness(0.9);
}
.badge-success,
.badge-info {
  padding: 10px 15px;
  font-weight: 600;
  background-color: rgba(65, 137, 230, 0.15);
  color: #3483fa;
  margin-bottom: 20px;
}
.badge-info {
  margin: 0;
  width: 100%;
}

.margin-top-fix {
  margin-top: 100px;
}

.Product-trial {
  white-space: pre-line;
  text-align: left;
  line-height: 1.5;
}

.etapas {
  max-width: 100%;
  margin: 10px auto 20px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  //
  position: fixed;
  top: 12px;
  right: 0;
  z-index: 888;
}
.etapas a,
.btn-voltar-step {
  padding: 8px;
  font-weight: 600;
  color: var(--text-color);
  border-radius: 5px;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-top: -25px;
  margin-bottom: 15px;
}
.btn-voltar-step {
  margin-top: -10px;
  margin-bottom: 0;
}
.btn-voltar-step img {
  transform: rotate(90deg);
  filter: invert(50%);
  margin-right: 10px;
}
.btn-voltar-step:hover {
  text-decoration: none;
}
.etapas p {
  margin: 0;
  font-weight: 600;
  color: #333;
}
/* etapas item */
.icon-etapa {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--transparent);
  display: inline-block;
}
.icon-etapa.target {
  background: var(--transparent-color);
}
.icon-etapa.complete {
  background: var(--main-color) !important;
}
.icon-etapa + .icon-etapa {
  margin-left: 12px;
}

// bump erro
.bumpInfo.noBump::before {
  content: '';
  position: absolute;
  right: 20px;
  top: 20px;
  border-radius: 3px;

  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: url('../assets/img/icon/block.svg') no-repeat center center;
}
.cupom-mobile {
  padding: 0 20px;
}
// presente
.gift-content {
  padding: 0 20px;
  margin-bottom: 30px;
}

.padding-checkout {
  padding-top: 3rem;
}
.padding-checkout.mobile {
  padding-top: 1.5rem;
}
.padding-checkout.escassez {
  padding-top: 5rem;
}
.padding-checkout.mobile.escassez {
  padding-top: 4.5rem;
}
.padding-checkout.mobile.escassez.thumb {
  padding-top: 1rem;
}
.is-stick {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
}

.btn-wpp {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-wpp:hover {
  transform: scale(1.1);
}

.input-es {
  display: flex;
}

.input-es #ES {
  width: 63px;
  border-radius: 5px 0px 0px 5px;
}
.tab-paypal-btn-disabled {
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 15px 25px !important;
  color: #333;
  margin: 0px;
  padding-left: 0px;
  background: rgb(173, 172, 172);
  border-radius: 5px;
  margin-top: 13px;
  font-size: 13px;
  margin-left: -16px;
  font-weight: 600;
  height: 50px;

  .icon {
    font-size: 16px;
    margin-right: 10px;
    color: var(--text-color);
    width: 16px;
    height: 16px;
  }

  .icon-mini {
    width: 15px !important;
    height: 15px !important;
  }
}
#tab-paypal-btn-disabled .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  position: absolute;
  z-index: 10000;
}
#tab-paypal-btn-disabled:hover .tooltiptext {
  visibility: visible;
  width: 320px;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  right: -268px;

  position: absolute;
  z-index: 10000;
}
.shippingContent {
  display: flex;
  flex-direction: column;

  .shippingRow {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    span {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
    }

    .shipping-amount {
      color: #3483FA;
      font-weight: 600;
    }
  }
}

.custom_charges {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .charges {
    width: 100%;
    border: 1px #3C88FA solid;
    border-radius: 5px;
    
    margin: 10px 0;
    padding: 10px;
    
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 45px;
    overflow-y: hidden;
    
    &[opened] {
      height: 100%;
    }
    p {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      
      color: #81858E;
      font: 12px 400 'Montserrat';
      line-height: 15px;
    }
  }

  .show-more {
    color: #3C88FA;
    background: transparent;
    outline: none;
    border: none;
    font-size: 12px;
    font-weight: 400;
  }
}

.content-card[hasCustomCharge] {
  align-items: flex-start;
}
@media only screen and (max-width: 600px) {
  #tab-paypal-btn-disabled:hover .tooltiptext {
    visibility: visible;
    width: 320px;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    top: 250px;
    left: -50px;

    position: absolute;
    z-index: 10000;
  }
  .tab-paypal-btn-disabled {
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding: 15px 25px !important;
    color: #333;
    margin: 0px;
    padding-left: 0px;
    background: rgb(173, 172, 172);
    border-radius: 5px;
    margin-top: 18px;
    font-size: 13px;
    font-weight: 600;
    height: 80px;
    margin-left: -16px;
    flex-direction: column;

    .icon {
      font-size: 16px;
      margin-bottom: 10px;
      color: var(--text-color);
      width: 16px;
      height: 16px;
    }

    .icon-mini {
      width: 15px !important;
      height: 15px !important;
    }
  }
}

.modal-default {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  padding: 50px 20px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  animation: fade-in 500ms;
  background: rgba(0, 0, 0, 0.65)
}

.custom-pop-modal {
  margin-top: 120px;
  background: var(--bg-checkout);
  color: var(--text-color);
  border-radius: 10px;
  max-width: 420px;
  padding: 10px;
  padding-top: 20px;
  animation: showTop 0.3s forwards !important;
}

.close-pop-modal {
  position: absolute;
  right: 7px;
  top: 2px;
  color: var(--text-color);
}


.button-custom-modal {
  text-decoration: none !important;
}

.button-custom-modal {
  text-decoration: none !important;
  background: var(--main-color);
  font-size: 14px;
  animation: ease-in-out 300ms;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  border-radius: 5px;
  width: 100%;
  position: relative;
  display: block;
  text-align: center;
  font-weight: bold;
  color: var(--text-color);
}
.image-fix {
  display: block;
  margin: 0 auto;
  max-height: 420px;
}

.total-blue {
  color: #3483fa;
}
.custom-free {
  font-weight: normal;
}
</style>
